// ReSharper disable InconsistentNaming
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-useless-escape */
/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable no-tabs */
/* eslint-disable camelcase */
export class Translations_sv_FI {
	static RiskTemplateNotAnyAllowedForUser = '-';
	static RiskAssessmentApprovalWasSuccessful = '-';
	static FurtherEducationsMustBeDefinedBeforeAddingRecordUsers = 'Utbildningar måste definieras innan användarposter läggs till!';
	static EventParameterUnitChangedFromParameterToParameter = 'Incident \'{0}\' enhet ändrades från \'{1}\' till \'{2}\'.';
	static DataTransferError = 'Dataöverföringsfel!';
	static DeletingOpportunityParameterWasSuccessful = '-';
	static SavingRecordUserQualificationParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara kvalifikationen \'{0}\', eftersom data i kvalificeringen har ändrats samtidigt av en annan användare!';
	static EventTypeCostsReportName = '-';
	static DoYouReallyWantToRemoveSelectedKeywords = 'Vill du verkligen ta bort valda sökord?';
	static DoYouReallyWantToRemoveEventHandlerParameter = 'Vill du verkligen ta bort hanteraren \'{0}\'?';
	static EventReceiverIsPartnerCompany = 'Incidentmottagare är partnerföretag';
	static BirthDate = 'Födelsedatum';
	static DraftVersion = 'Utkastsversion';
	static LockedRiskParameterCannotBeRestored = '-';
	static ParameterIsNotValidBankBICCode = '\'{0}\' är inte giltig bank-BIC-kod!';
	static DeletingMessageTypeParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort meddelandetypen \'{0}\'! Fel: \'{1}\'';
	static PrintTextPublished = 'Publicerad';
	static Saved = 'Sparad av';
	static DefaultEventSettings = 'Standardinställningar för incidenter';
	static MessageTypeCodeMustBeDefined = 'Meddelandetypskod måste definieras!';
	static SavingRiskAssessmentParameterWasNotSuccessfulConcurrencyError = '-';
	static SendingNotificationsWasNotSuccessfulErrorParameter = 'Det gick inte att skicka aviseringar! Fel: \'{0}\'';
	static ForwardMessage = 'Fram';
	static RiskAssessmentPersonsInChargeMustBeDefined = '-';
	static FormPlaceholder = 'Platshållartext';
	static FormDropdownOptionsDialog = 'Dropdown alternativ';
	static ValidPasswordMustBeDefined = 'Giltigt lösenord måste definieras!';
	static AccessRightRead_EventDescription_AC = '-';
	static Starts = 'Startar';
	static Reject = 'Avvisa';
	static ReadingFileParameterWasNotSuccessfulFileNotFound = 'Det gick inte att läsa filen \'{0}\' i filsystemet! Filen hittades inte!';
	static RiskTreatmentState = '-';
	static PrintFirstRows = '-';
	static AddCompanyGroups = 'Lägg till företagsgrupper';
	static CalendarTaskCategory = 'Kategori';
	static EventTypesReportPieChartName = '-';
	static EditDefaultEventHandlersAndNotifiedPersons = 'Redigera standardincidenthanterare och anmälda personer';
	static CheckingExistanceOfFileParameterWasNotSuccessfulErrorParameter = 'Det gick inte att kontrollera existensen av filen \'{0}\' i filsystemet! Fel: \'{1}\'';
	static AddBasicEducation = 'Lägg till grundutbildning';
	static DeletingEventTypeCParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kategori 3 \'{0}\', eftersom data i kategori 3 har ändrats samtidigt av en annan användare!';
	static DeletingDocumentTemplatesParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort dokumentmallarna \'{0}\'! Fel: \'{1}\'';
	static DeletingDocumentTemplatesParameterWasSuccessful = 'Dokumentmallarna \'{0}\' har tagits bort!';
	static FormEventReferenceWarning = '-';
	static ChangingPasswordWasNotSuccessfulErrorParameter = 'Det gick inte att byta lösenord! Fel: \'{0}\'';
	static AddWhistleBlowChannelAdminsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till administratörer \'{0}\'! Fel: \'{1}\'';
	static SavingRecordFamiliarizationParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara bekantskapen \'{0}\'! Fel: \'{1}\'';
	static Success = 'Framgång!';
	static DriversLicenseType = 'Typ av körkort';
	static CurrentAndPreviousCalendarHalfYear = '-';
	static AddComment = 'Lägg till kommentar';
	static Link = 'Länk';
	static RiskLevelLow = '-';
	static PieChart = '-';
	static RemoveLogisticTransportCompany = 'Ta bort Transport Company';
	static DefineRecordUserFurtherEducation = 'Definiera utbildning';
	static Employments = 'Anställningar';
	static FileNameMustBeDefined = 'Filnamn måste definieras!';
	static TaskDataRowParameterNotFound = '-';
	static DoYouReallyWantToUnlockRiskAssessment = '-';
	static NewRecordUserMustBeSavedBeforeQualificationsCanBeAdded = 'Ny användarpost måste sparas innan kvalifikationer kan läggas till!';
	static Assessor = '-';
	static RecordUserFamiliarizationParameterNotFound = 'Bekantgöring \'{0}\' hittades inte!';
	static SavingInstantMessageChannelUserWasNotSuccessfulConcurrencyError = 'Det gick inte att spara deltagare, eftersom data i deltagaren har ändrats samtidigt av en annan användare!';
	static GroupByQuarter = 'Gruppera efter kvartal';
	static DoYouReallyWantToRestoreRecordUserParameterFromArchive = '-';
	static DeletingRiskProcessesParameterWasNotSuccessfulConcurrencyError = '-';
	static WhistleBlowEventTypeModified = 'Ändrad';
	static UserCodeParameterMustBeValid = 'Användarnamnet måste vara 8-50 tecken långt och det får inte innehålla blanksteg (\'{0}\').';
	static NoEmailsToSend = 'Inga mail att skickas!';
	static PrivacyPolicyUrlMustBeDefined = 'Sekretesspolicy webbadress måste definieras!';
	static Hour = 'Timme';
	static JobTitle = 'Jobbtitel';
	static UseObserverAction = 'Visa observatörsåtgärdsfält';
	static RiskApprovalListNotApproved = '-';
	static RecordUserTrangerredPropertyParameterNotFound = 'Den överförda egenskapen \'{0}\' hittades inte!';
	static Severity = 'Allvarlighetsgrad';
	static SavingTaskDataRowWasNotSuccessfulConcurrencyError = '-';
	static DeletingUserParameterWasSuccessful = 'Användarkontot \'{0}\' har tagits bort!';
	static DeletingTaskTypeParameterWasNotSuccessfulErrorParameter = '-';
	static AccessRightRead_InstantMessage = '-';
	static SavingEventMessageWasNotSuccessfulConcurrencyError = 'Det gick inte att spara kommentaren eftersom data i kommentaren har ändrats samtidigt av en annan användare!';
	static ArchivingRecordUserFurtherEducationsWasSuccessful = 'Utbildningar arkiverade framgångsrikt!';
	static AddReportTemplateFromTemplate = '-';
	static AddPhoto = 'Lägg till foto';
	static ExternalSystemUserCodeMustBeDefined = 'Användarkod i externt system måste definieras!';
	static Portrait = 'Porträtt';
	static CopyingFolderDirectoryItemParameterToFolderParameterWasSuccessful = 'Mappen \'{0}\' har kopierats till mappen \'{1}\'!';
	static AddWhistleBlowCategory = 'Lägg till kategori för Whistle Blow';
	static DocumentContentsSearch = 'Sök dokumentinnehåll';
	static RiskLevelHigh = '-';
	static DecreasingVersionHistorySizeRemovesCurrentlySavedVersionHistoryRecords = 'Notera! Om du minskar storleken på versionshistoriken tas tidigare sparade versioner bort från versionshistoriken.';
	static ArchivingTaskParameterWasSuccessful = '-';
	static AddingRecordUserFamiliarizationsWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till bekantskaper! Fel: \'{0}\'';
	static SavingReadReceiptWasNotSuccessfulErrorParameter = 'Det gick inte att spara läskvitto! Fel: \'{0}\'';
	static AddFamiliarizations = 'Lägg till bekantskaper';
	static OpportunityRegisterDetails = '-';
	static ThisMessageWasDeleted = 'Detta meddelande raderades';
	static NewFurtherEducationMustBeSavedBeforeAttachmentsCanBeAdded = 'Ny utbildning måste sparas innan bilagor kan läggas till!';
	static CompanyName = 'Företagsnamn';
	static ExcelTemplate = '-';
	static UserRecordStatisticsExpiringInSixMonthsQualifications = 'Kvalifikationer som löper ut om sex månader';
	static UpdateUserGroupParameterExternalSystemsWasNotSuccessfulConcurrencyError = 'Det gick inte att länka användargruppen \'{0}\' till externa system, eftersom data har ändrats samtidigt av en annan användare!';
	static Preview = 'Förhandsvisning';
	static SendingPushNotificationsToParameter = 'Skickar push-meddelanden till användaren \'{0}\'...';
	static AddEventTypeC = 'Lägg till kategori 3';
	static AddEventTypeB = 'Lägg till kategori 2';
	static FormPages = '-';
	static WhistleBlowEventTypeDescriptionModifiedDescription = '-';
	static TaskChartGroupingFieldDynamicValueFieldTypeYearly = '-';
	static TimeSpanQuarter = 'Fjärdedel';
	static DeletingTaskPrioritiesParameterWasNotSuccessfulConcurrencyError = '-';
	static WhistleBlowInformantHint = 'Tänk på att beskriva ditt ärende så noggrant som möjligt för att underlätta vår utredning.';
	static Entrepreneur = 'Entreprenör';
	static AccessRightWrite_TaskDescription_C = '-';
	static Visibility = 'Synlighet';
	static RiskCategoryParameterNotFound = '-';
	static RemovingTaskTypeUnitsWasNotSuccessfulErrorParameter = '-';
	static RecordUserLogEntryTypeCreate = 'Skapa';
	static RestoringRiskParameterFromTrashBinWasSuccessful = '-';
	static Source = 'Källa';
	static RemoveEventUrgencyClass = 'Ta bort brådskande klass';
	static RecordFurtherEducationParameterIsInUseInParameterRecordUsersQualificationsAndCannotBeDeleted = 'Utbildning \'{0}\' används som kvalifikation i {1} användarregister och kan inte tas bort!';
	static AppReportTemplateModuleInfoCompanyReportTemplates = '-';
	static JobLineParameterNotFound = 'Jobbraden \'{0}\' hittades inte!';
	static DeletingRiskAssesmentParameterWasNotSuccessfulErrorParameter = '-';
	static FollowUp = 'Uppföljning';
	static AccessRightWrite_InstantMessageDescription_A = '-';
	static DeletingRiskTemplateParameterWasNotSuccessfulErrorParameter = '-';
	static SearchProperties = 'avancerad sökning';
	static AddCompanyGroupsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till företagsgrupper \'{0}\'! Fel: \'{1}\'';
	static CopyOrMoveFolder = 'Kopiera eller flytta mapp';
	static EventPartners = 'Incidentpartners';
	static Private = 'Privat';
	static RestoringRiskParameterFromTrashBinWasNotSuccessfulConcurrencyError = '-';
	static AllUserGroups = 'Alla användargrupper';
	static FormOptions = 'Alternativ';
	static Years = 'År';
	static Menu = 'Meny';
	static PreviewMobile = 'Förhandsgranska (mobil)';
	static AddTransferredPropertyToMultipleUserRecords = 'Lägg till överförd egendom till flera användarposter';
	static TypeMustBeDefined = 'Typ måste definieras!';
	static RemoveTaskPermanently = '-';
	static Archive = 'Arkivera';
	static RiskOwner = '-';
	static NotRepeated = 'Inte upprepad';
	static ExternalSystemUserTokenParameterIsAlreadyInUse = 'Användartoken \'{0}\' används redan!';
	static PreviewRowPrint = 'Förhandsgranska (radutskrift)';
	static MicrosoftLogIn = 'Logga in med Microsoft-konto';
	static DocumentModuleInfoAutoSaveVersionHistorySize = 'Antal tidigare sparade versioner som behålls när dokumentet sparas.';
	static RecordFurtherEducationParameterNotFound = 'Utbildning \'{0}\' hittades inte!';
	static SavingEventPartnerParameterWasSuccessful = 'Incidentpartner \'{0}\' har sparats!';
	static FormTextAlignmentCenter = '-';
	static AddTarget = 'Lägg till mål';
	static NewTransferredPropertyMustBeSavedBeforeAttachmentsCanBeAdded = 'Ny överlåten egendom måste sparas innan bilagor kan läggas till!';
	static DaysAgo30 = '30 dagar sedan';
	static AccessRightWrite_InstantMessage = '-';
	static TaskStateLocked = '-';
	static CalendarTaskRepetitionRepeatIntervalMonthlySuffix = 'månader';
	static AddLogisticVoucherPaymentSetting = 'Lägg till betalningsinställning';
	static Color = 'Färg';
	static ScopeCanBeChanged = 'Omfattning kan ändras';
	static NewInstantMessageChannelGroup = 'Ny grupp';
	static ImmediatelyAfterExpiration = '-';
	static DeletingCalendarTaskParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort händelsen \'{0}\', eftersom data i uppgiften har ändrats samtidigt av en annan användare!';
	static RiskRegisterDetails = '-';
	static ArchivingRecordUserFurtherEducationsWasNotSuccessfulConcurrencyError = 'Det gick inte att arkivera utbildningar, eftersom data i utbildningar har ändrats samtidigt av en annan användare!';
	static RootCause = 'Grundorsak';
	static BrowseFiles = 'Bläddra bland filer';
	static AddDefaultFurtherEducation = 'Lägg till standard för utbildning';
	static DoYouReallyWantToRemoveSelectedRecordFurtherEducations = 'Vill du verkligen ta bort utvalda utbildningar?';
	static EditMode = 'Redigera';
	static EditLogisticVoucherPaymentSetting = 'Redigera betalningsinställning';
	static DeletingPartnerParameterWasSuccessful = 'Partnern \'{0}\' har tagits bort!';
	static DownloadPdf = 'Ladda ner pdf';
	static SentEmails = 'Skickade mejl';
	static WhistleBlowSourceUnspecified = 'Ospecificerad';
	static FormCalculatedIntegerNumber = 'Beräknat heltal';
	static DeletingWhistleBlowChannelAdminParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort administratören \'{0}\'! Fel: \'{1}\'';
	static AddingAttachmentsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till bilagor \'{0}\'! Fel: \'{1}\'';
	static PanelSize = 'Panelstorlek';
	static AddEditableDocument = 'Lägg till dokument';
	static AddingAddRecordUserQualificationsWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till kvalifikationer! Fel: \'{0}\'';
	static AddingCalendarTaskHandlerWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till ansvariga personer! Fel: \'{0}\'';
	static SenderOrReceiver = 'Avsändare eller mottagare';
	static RecordUserFamiliarizationApprovalWasNotSuccessfulConcurrencyError = 'Kunde inte godkänna introduktionen av användarposten eftersom godkännaren har ändrats samtidigt av en annan användare!';
	static Category = 'Kategori';
	static UserIsWhistleBlowChannelAdminAndCannotBeDeleted = 'Användaren är visselblåsningschanel administratör och kan inte raderas!';
	static DeletingTaskStateParameterWasNotSuccessfulErrorParameter = '-';
	static CreatingUserTokenWasNotSuccessfulErrorParameter = 'Det gick inte att byta lösenord! Fel: \'{0}\'';
	static FormSizeMedium = 'Medium';
	static OldPasswordIsIncorrect = 'Det gamla lösenordet är felaktigt!';
	static TaskRepetitionType = '-';
	static PasteGroupPermissions = 'Klistra in gruppbehörigheter från minnet';
	static DeletingRiskAssesmentsParameterWasNotSuccessfulErrorParameter = '-';
	static DocumentModulePropertiesSaveWasSuccessful = 'Dokumentinställningarna har sparats!';
	static Last5Years = '-';
	static NoAddedEventTypeCs = 'Inga tillagda kategorier!';
	static NoAddedEventTypeBs = 'Inga tillagda kategorier!';
	static OtherRiskTemplates = '-';
	static LoginTitle = 'Logga in på PKY-LAATU Intra';
	static Modification = 'Modifiering';
	static EditCompanyGroup = 'Redigera företagsgrupp';
	static AddingReportTemplateUnitsWasSuccessful = '-';
	static PrintTextPrinted = 'Tryckt';
	static InstantMessageChannelGroupInternal = 'Grupp (företagsintern)';
	static Continue = 'Fortsätta';
	static DirectCosts = 'Direkta kostnader';
	static Draft = 'Förslag';
	static ReportParameterNotFound = '-';
	static DocumentIsEmpty = 'Dokumentet är tomt!';
	static AccessRightRead_CalendarTask = '-';
	static TrendingFlat = '-';
	static EventMessageConfirmation = 'Vill du spara en ny kommentar?';
	static SavingEditableDocumentParameterWasSuccessful = 'Dokumentet \'{0}\' har sparats!';
	static SavingReportTemplateParameterWasSuccessful = '-';
	static EventHandlerParameterNotFound = 'Hanteraren \'{0}\' hittades inte!';
	static FolderMustBeEmptyBeforeItCanBeRemoved = 'Mappen måste vara tom innan den kan tas bort!';
	static WhistleBlowChannel = 'Whistle Blow Channel';
	static DoYouReallyWantToRemoveSelectedRecordBasicEducations = 'Vill du verkligen ta bort utvalda grundutbildningar?';
	static EditDefaultTaskPriority = '-';
	static Days = 'dagar';
	static DeletingOpportunityParameterWasNotSuccessfulErrorParameter = '-';
	static FormPageBreak = '-';
	static AccessRightRead_Event = '-';
	static RemoveMessage = 'Ta bort meddelande';
	static SendTime = 'Skicka tid';
	static SavingReportParameterWasNotSuccessfulErrorParameter = '-';
	static CopyActiveUserRightsToAllSameLevelFolders = 'Kopiera aktiva behörigheter till alla mappar på samma nivå';
	static RemoveUserGroup = 'Ta bort användargrupp';
	static Courses = 'Kurser';
	static DoYouReallyWantToRemoveSelectedTaskPriorities = '-';
	static EmailAddressDoesNotExist = 'E-postadressen finns inte!';
	static SaveEvent = 'Spara incidenten';
	static NextAssessmentDate = '-';
	static FormAddOption = '-';
	static SavingDocumentTemplateParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara dokumentmallen \'{0}\'! Fel: \'{1}\'';
	static DocumentApproval = 'Dokumentgodkännande';
	static DeletingRecordUserPartnerParameterWasSuccessful = 'Resurspartnern \'{0}\' har tagits bort!';
	static ApproveEvent = 'Godkänn event';
	static FileFilter = 'Filfilter';
	static RemoveMessageType = 'Ta bort meddelandetyp';
	static ArchivingOpportunityParameterWasNotSuccessfulConcurrencyError = '-';
	static DeletingDirectoryItemDocumentParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort filen \'{0}\' eftersom data i filen har ändrats samtidigt av en annan användare!';
	static TimeSpanHalfYear = 'Halvår';
	static ZipFileParameterNotFound = 'Zip-filen \'{0}\' hittades inte!';
	static SavingReportWasNotSuccessfulConcurrencyError = 'Det gick inte att spara rapporten eftersom data i rapporten har ändrats samtidigt av en annan användare!';
	static PublishingReportParameterWasSuccessful = '-';
	static WhistleBlowInformant = 'Informant';
	static SaveAndPublish = 'Spara och publicera';
	static AutomaticLogoutDone = 'Automatisk utloggning gjord på grund av utgången användarsession!';
	static DeletingCompanyGroupsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort företagsgrupperna \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static ClearSubUnitPermissions = 'Rensa underenhetsbehörigheter';
	static DefaultFurtherEducationGroup = 'Standard ubildningsgrupp';
	static AddPartnersParameterWasSuccessful = 'Partners \'{0}\' har lagts till!';
	static UserAccountNotConnected = 'Användarkonto inte anslutet';
	static MovingReportParameterToTrashBinWasSuccessful = '-';
	static SelectEventInListToSeeThePreview = 'Välj incident i listan för att se förhandsgranskningen';
	static DeletingReportTemplateParameterWasNotSuccessfulErrorParameter = '-';
	static SharedBy = 'Delad av';
	static Publish = 'Publicera';
	static LoginCompany = 'Inloggningsföretag';
	static IpAddress = 'IP-adress';
	static Characters = 'Tecken';
	static RecurringCalendarTaskMustHaveAtLeastOneOccurence = '-';
	static EventTypesReportBarChartByTimeName = '-';
	static DoYouReallyWantToRemoveRemainderParameter = 'Vill du verkligen ta bort resten "{0}"?';
	static Week = 'Vecka';
	static ImportUserDialogInstruction = 'Ladda upp excel-fil för att importera användarkonto eller ladda ner excel-mall där du kan fylla i användarkontoinformation.';
	static CopyPermissionToAllSameLevelFolders = 'Kopiera behörighet till alla mappar på samma nivå';
	static QrCodeAuthenticationTimeoutDay = '24 timmar';
	static AddUserGroupsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till användargrupper "{0}", eftersom data har ändrats samtidigt av en annan användare!';
	static RiskCategoriesMustBeDefinedBeforeAddingRisks = '-';
	static SavingReportTemplateParameterWasNotSuccessfulConcurrencyError = '-';
	static FormColumnWidthMobile = 'Kolumnbredd i mobilapp';
	static Image = '-';
	static AddDefaultFurtherEducationGroup = 'Lägg till standardgrupp för utbildning';
	static AddUserGroupParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till användargruppen \'{0}\'! Fel: \'{1}\'';
	static SavingFileFilterParameterWasSuccessful = 'Filfiltret \'{0}\' har sparats!';
	static LoggedInCompanyCannotBeDeleted = 'Företaget kan inte ta bort sig själv!';
	static DeletingMessageTypeParameterWasSuccessful = 'Meddelandetypen \'{0}\' har tagits bort!';
	static TransferredProperties = 'Överlåtna fastigheter';
	static DoYouReallyWantToRemoveOpportunityParameterPermanently = '-';
	static SavingUserParameterWasSuccessful = 'Användaren \'{0}\' har sparats!';
	static SelectCustomer = 'Välj Kund';
	static AdministratorUserCodeMustBeDefined = 'Användarnamnet för administratören måste definieras!';
	static UserEndDateMustBeDefined = 'Giltighetstidens utgång måste definieras!';
	static JobDataIsEmpty = 'Jobbdata saknas!';
	static ReadReceiptMessage = 'Meddelande som kräver läskvitto';
	static EmptyForm = 'Tomt formulär';
	static AdvancePaymentReportPath = 'Sökväg för förskottsbetalningsrapport';
	static DirectoryItemDocumentParameterNotFound = 'Filen \'{0}\' gillar inte!';
	static PrintGenerationFailed = 'Det gick inte att skapa utskrift!';
	static EmptyingReportTrashBinWasSuccessful = '-';
	static SavingFilterWasNotSuccessfulErrorParameter = 'Det gick inte att spara filtret! Fel: \'{1}\'';
	static EmailNotificationOfChangedPublishStatus = 'Meddela när publicerade tillståndsändringar via e-post';
	static EventUrgencyClass = 'Brådskande klass';
	static Loading = 'Läser in...';
	static DoYouReallyWantToRemoveReportParameterPermanently = '-';
	static ArchivingReportParameterWasNotSuccessfulErrorParameter = '-';
	static FolderParameterNotFound = 'Mappen \'{0}\' hittades inte!';
	static DoYouReallyWantToRemoveSharedPanelParameter = '-';
	static MessageTypeClass = 'Meddelandeklass';
	static DoYouReallyWantToRemoveSelectedTaskTypes = '-';
	static TaskChartGroupingFieldGroupingType = '-';
	static SavingEventUrgencyClassParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara brådskande klass \'{0}\'! Fel: \'{1}\'';
	static PermissionToCreateEvents = 'Tillstånd att skapa incidenter';
	static UnpublishingOpportunityParameterWasNotSuccessfulErrorParameter = '-';
	static OpenCalendarTask = 'Öppna event';
	static RestoringInstantMessageWasNotSuccessfulErrorParameter = 'Det gick inte att återställa snabbmeddelanden! Fel: \'{0}\'';
	static PermissionsForSection = 'Sektionsbehörigheter';
	static DocumentModuleInfoFolderPermissions = 'Åtkomsträttigheter till mappar/dokument. Den överordnade mappen måste ha minst läsåtkomst för att undermappen ska vara synlig för användaren. Åtkomst kan beviljas QR-kodanvändare.';
	static SaveUserFurtherEducation = 'Spara utbildning';
	static CostCentreName = 'Kostnadsställets namn';
	static WhistleBlowStatisticsNewRecords = 'Nya rapporter';
	static RowInformation = 'Radinformation';
	static RemovePrint = 'Ta bort utskrift';
	static AddUserParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till användarkontot \'{0}\'! Fel: \'{1}\'';
	static AddingAttachmentsParameterWasSuccessful = 'Bilagorna "{0}" har lagts till!';
	static FormulaAbs = 'Absolut värde';
	static RemoveRiskProcess = '-';
	static LockedTaskParameterCannotBeRestored = '-';
	static BasicEducation = 'Grundläggande utbildning';
	static NewRecordUserMustBeSavedBeforeFamiliarizationsCanBeAdded = 'Ny användarpost måste sparas innan bekantskaper kan läggas till!';
	static DoYouReallyWantToRemoveSelectedEventUrgencyClasses = 'Vill du verkligen ta bort utvalda brådskande klasser?';
	static CurrentCalendarWeek = 'Aktuell kalendervecka';
	static ChangingPasswordWasNotSuccessfulConcurrencyError = 'Det gick inte att ändra lösenordet eftersom användardata har ändrats samtidigt av en annan användare!';
	static AddRiskCategory = '-';
	static EventTypeCostsReportBarChartIndirectCostsByCategoryName = '-';
	static RemoveFamiliarization = 'Ta bort bekantskaper';
	static Total = 'Total';
	static AppReportDashboard = '-';
	static UnitMustBeSelected = 'Enhet måste väljas!';
	static Impact = '-';
	static CreatingCompressedFileWasNotSuccessfulErrorParameter = 'Filkomprimering misslyckades! Fel: \'{0}\'';
	static WhistleBlowAnonymousReport = 'Anmäl anonymt';
	static DeletingPartnerParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort partner \'{0}\'! Fel: \'{1}\'';
	static DeletingInstantMessageUsersParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort deltagare \'{0}\'! Fel: \'{1}\'';
	static DeletingRiskProcessParameterWasNotSuccessfulConcurrencyError = '-';
	static ArchivingRecordUserFamiliarizationsWasNotSuccessfulConcurrencyError = 'Det gick inte att arkivera ytterligare bekantskaper, eftersom data i bekantskaper har ändrats samtidigt av en annan användare!';
	static DeletingTaskTypesParameterWasNotSuccessfulConcurrencyError = '-';
	static AddRiskProcess = '-';
	static CalendarTaskHandlers = 'Synlighet';
	static DateField = '-';
	static TargetCompany = 'Målföretag';
	static SelectInstantMessageChannelUsers = 'Välj deltagare';
	static DoYouReallyWantToRemoveKeywordParameterItIsUsedByParameterDocuments = 'Vill du verkligen ta bort sökordet "{0}"? Nyckelord som används i {1} filer/dokument.';
	static ApproveEventHandlerConfirmation = 'Avhjälpande åtgärder har inte definierats. Vill du verkligen godkänna händelsen?';
	static TimeMustBeDefined = 'Tiden måste definieras!';
	static AddRiskStakeholder = '-';
	static WhistleBlowSeverityCritical = 'Kritisk';
	static Language = 'Språk';
	static AddUser = 'Lägg till användarkonto';
	static DeletingMetadataFromFileParameterFailed = 'Det gick inte att ta bort metadata från filen \'{0}\'!';
	static RiskControlsPlaceholder = '-';
	static AppReportModuleInfoPermissions = '-';
	static AccessRightRead_Task_BC = '-';
	static CalendarTaskStartDateMustBeDefined = 'Händelsens starttid måste definieras!';
	static Sender = 'Avsändare';
	static CalendarTaskStateFinished = 'Färdig';
	static RemoveReportPermanently = '-';
	static ChartOrTableType = '-';
	static DeletingRecordFamiliarizationsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort bekantskaper "{0}", eftersom data i bekantskaper har ändrats samtidigt av en annan användare!';
	static DeletingUserGroupParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort användargruppen \'{0}\' eftersom data i användargruppen har ändrats samtidigt av en annan användare!';
	static UpdateCompanyExternalSystemsWasNotSuccessfulConcurrencyError = 'Det gick inte att länka företaget till externa system, eftersom data har ändrats samtidigt av en annan användare!';
	static EditRecordUser = 'Redigera användarpost';
	static DeletingCalendarTaskCategoriesParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kategorierna \'{0}\'! Fel: \'{1}\'';
	static RemovingRiskAssessmentHandlersWasSuccessful = '-';
	static PicturesAreVisibleForAllCompanyUsers = 'Bilder är synliga för alla företagsanvändare';
	static ArchivingWhistleBlowsParameterWasSuccessful = 'Visselslagsrapporter \'{0}\' har arkiverats framgångsrikt!';
	static FileSynchronizationToDatabaseFinishedInParameterSeconds = 'Filsystemsynkronisering med databas slutförd (varaktighet: {0:N0}s, fel: {1}, mappar: {2}, mappar utan fel: {3})';
	static RecordUserLogEntryTypeOpen = 'Läsning';
	static ReminderHourBefore = 'timme innan';
	static SelectTaskPriority = '-';
	static NewVersionAvailable = 'Ny applikationsversion tillgänglig! Applikationen kan inte användas innan den har uppdaterats.';
	static UpdateUserParameterExternalSystemsWasNotSuccessfulConcurrencyError = 'Det gick inte att länka användaren \'{0}\' till externa system, eftersom data har ändrats samtidigt av en annan användare!';
	static TaskStateParameterIsInUseInParameterTasksAndCannotBeDeleted = '-';
	static EventsToApprove = 'Händelser att godkänna';
	static OptionCodeIsAlreadyInUse = 'Systemalternativkoden \'{0}\' används redan!';
	static EditQrCodeUser = 'Redigera QR-kod användarkonto';
	static AppReportModuleInfoUnits = '-';
	static AccessRightWrite_RecordDescription = '-';
	static FormulaRemainder = 'Återstoden';
	static UserParameterCodeIsAlreadyInUse = 'Användarparametrarnas kod används redan!';
	static AddInstantMessageUserParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till deltagare \'{0}\'! Fel: \'{1}\'';
	static WhistleBlowNewReport = 'Ny rapport';
	static SavingRecordBasicEducationParameterWasSuccessful = 'Grundutbildningen \'{0}\' har sparats!';
	static WorkTimeType = 'Typ av arbetstid';
	static FormulaTan = 'Tangent';
	static DeletingEventTypeCParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kategori 3 \'{0}\'! Fel: \'{1}\'';
	static SavingTaskParameterWasNotSuccessfulConcurrencyError = '-';
	static FormRemoveColumnFromRowConfirmation = 'Vill du verkligen ta bort kolumnen från raden?';
	static FormDocumentReferenceIsNotSet = '-';
	static ClosedPlural = 'Stängd';
	static Print = 'Skriva ut';
	static UserFilterInActive = 'Används inte';
	static ChangingPasswordWasSuccessful = 'Lösenordet har ändrats!';
	static SavingMessageTypeParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara meddelandetypen \'{0}\', eftersom data i meddelandetypen har ändrats samtidigt av en annan användare!';
	static AddUnit = 'Lägg till enhet';
	static UserUnapprovedFamiliarization = 'Jag har inte godkänt bekantskapsbedömningen';
	static DeletingRecordQualificationsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kvalifikationerna \'{0}\'! Fel: \'{1}\'';
	static DeletingRiskCategoriesParameterWasNotSuccessfulConcurrencyError = '-';
	static UnpublishingRiskParameterWasNotSuccessfulConcurrencyError = '-';
	static ClassParameterHasNotBeenInitialized = 'Klassen \'{0}\' har inte initierats!';
	static UserIsActiveInWeb = 'Användarkontot är aktivt i webbapplikationen.';
	static Unread = 'Oläst';
	static CompanyThatIsInUseCannotBeDeleted = 'Företag som är i tillståndet "I bruk" kan inte tas bort!';
	static RecordFurtherEducationCodeMustBeDefined = 'Utbildningens namn måste anges!';
	static RenewPersonalization = 'Personalisering';
	static Documents = 'Dokument';
	static RecordUserSettings = '-';
	static NewCompanyMustBeSavedBeforePartnersCanBeAdded = 'Nytt företag måste sparas innan partner kan läggas till!';
	static RecordFamiliarizationParameterIsInUseInParameterRecordUsersAndCannotBeDeleted = 'Bekantskap \'{0}\' används i {1} användarposter och kan inte tas bort!';
	static WhistleBlowInformantMessages = 'Informantmeddelanden';
	static ChangeSystemLanguageToFinnish = 'Byt språk till finska';
	static NameIsAlreadyInUse = 'Namnet används redan!';
	static Filter = 'Filtrera';
	static RiskCategoryCodeIsAlreadyInUse = '-';
	static NotAssigned = 'Inte tilldelats';
	static SelectSharedPanel = '-';
	static TaskChartValueFieldCalculationTypeMax = '-';
	static SavingRiskCategoryParameterWasNotSuccessfulErrorParameter = '-';
	static AccessRightNone = '-';
	static RiskStakeholders = '-';
	static AddDefaultTaskPriority = '-';
	static DeletingInstantMessageChannelParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort chatten "{0}" eftersom data i snabbmeddelandekanalen har ändrats samtidigt av en annan användare!';
	static EInvoiceOperator = 'E-fakturaoperatör';
	static RemoveTarget = 'Ta bort mål';
	static DeletingInstantMessageWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort snabbmeddelanden! Fel: \'{0}\'';
	static NotifiedPersonsShort = 'Aviseringar';
	static WriteMessage = 'Skriv meddelande';
	static AddFile = 'Lägg till fil';
	static UserApproved = 'Jag har godkänt';
	static WhistleBlowStatisticsUnreadMessages = 'Olästa meddelanden';
	static DisableExternalIntraSystemConfirmation = 'Vill du verkligen stänga av företaget från systemet? Företaget kommer att tas bort från systemet när företaget har sparats.';
	static LogisticVoucherCustomers = 'Kunder';
	static ValidityDate = 'Giltighetsdatum';
	static SavingChartWasNotSuccessfulConcurrencyError = 'Det gick inte att spara diagrammet eftersom data i diagrammet har ändrats samtidigt av en annan användare!';
	static UserGroupAll = '\'Alla användare\'';
	static AddRecordUser = 'Lägg till användarpost';
	static TaskDataRows = '-';
	static RemoveTaskPriority = '-';
	static LoggedInUserCannotBeDeleted = 'Användaren kan inte ta bort sig själv!';
	static RemovingRiskTemplateUnitsWasSuccessful = '-';
	static LockedTaskDataRowCannotBeDeleted = '-';
	static LockedOpportunityParameterCannotBeDeleted = '-';
	static RiskTemplateCodeIsAlreadyInUse = '-';
	static DeletingWhistleBlowCategoryParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kategorin \'{0}\'! Fel: \'{1}\'';
	static Instructions = 'Instruktioner';
	static Document = 'Document';
	static DeletingRecordFurtherEducationsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort utbildningar \'{0}\'! Fel: \'{1}\'';
	static DefaultDeductionWithoutTax = 'Standardavdrag (moms 0 %)';
	static EditWhistleBlow = 'Redigera Whistle Blow Report';
	static DaysAgo90 = '90 dagar sedan';
	static SavingCalendarTaskCategoryParameterWasSuccessful = 'Kategori \'{0}\' har sparats!';
	static WhistleBlowFrontPage = 'Framsida';
	static SavingDirectoryItemPermissionsNotSuccessfulErrorParameter = 'Det gick inte att spara mappbehörigheter! Fel: \'{0}\'';
	static SharedDocumentTemplate = 'Mall för delad dokument';
	static RecordUserModuleInfoPermissions = 'Åtkomsträttigheter anges per enhet. Åtkomst till användaruppgifter kan nekas, begränsas till användarens eget kort eller utökas till alla uppgifter inom enheten. Åtkomst kan inte beviljas QR-kodanvändare.';
	static SavingUserParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara användaren \'{0}\', eftersom användardata har ändrats samtidigt av en annan användare!';
	static WhistleBlowDescriptionEditReasonMustBeDefined = '-';
	static SelectVisibility = '-';
	static InstantMessageUserInvitationAcceptTypeCanInvite = 'Jag kan bli inbjuden att gå med i chatten';
	static TheUserDoesNotHavePermissionsForThisSystem = 'Användaren har inte behörighet att använda detta system!';
	static AddCalendarTaskCategory = 'Lägg till kategori';
	static MiddleName = 'Mellannamn';
	static ForLastParameterDays = 'i {0} dagar';
	static SavingReportWasSuccessful = 'Rapporten har sparats!';
	static RemoveDefaultHandler = 'Ta bort standardhanteraren';
	static Open = 'Öppen';
	static TaskChartGroupingFieldGroupingTypeDayOfWeek = '-';
	static CalendarTaskStateStarted = 'Startade';
	static SelectCompany = 'Välj Företag';
	static UnitChangedFromParameterToParameter = 'Enheten ändrades från \'{0}\' till \'{1}\'.';
	static TransportCompanies = 'Transportföretag';
	static ReportTemplates = '-';
	static Drafts = 'Utkast';
	static DeletingReportParameterWasNotSuccessfulErrorParameter = '-';
	static CalendarTaskParameterNotFound = 'Händelsen \'{0}\' hittades inte!';
	static CompanyToken = 'Company Token';
	static Education = 'Utbildning';
	static SavingWhistleBlowCategoryParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara kategorin \'{0}\'! Fel: \'{1}\'';
	static SavingCalendarTaskParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara händelsen \'{0}\'! Fel: \'{1}\'';
	static WhistleBlowActiveReports = 'Aktiva rapporter';
	static AddDefaultBasicEducation = 'Lägg till standard grundutbildning';
	static TaxNumber = 'Skattenummer';
	static LanguageFinnish = 'finska';
	static UserReports = 'Användarregisterrapporter';
	static DeletingPartnerParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort partnern \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static DoYouReallyWantToRemoveFormParameter = 'Vill du verkligen ta bort formuläret \'{0}\'?';
	static FormDocumentReferenceIsIsInvalid = '-';
	static DeletingEventTypeParameterWasSuccessful = 'Kategori 1 \'{0}\' har tagits bort!';
	static Traceability = '-';
	static AccessRightRead_InstantMessageDescription_A = '-';
	static EditEvent = 'Redigera incident';
	static LockedOpportunityParameterCannotBeArchived = '-';
	static EventHandlersExcelTitle = 'Hanterare (x = godkänd)';
	static IndirectCosts = 'Indirekta kostnader';
	static MaximumSizeOfAttachmentThatCanBeAddedInBatchIsParameterMB = 'Den maximala totala storleken på bilagor som kan läggas till i batch är {0} MB!';
	static NotificationSettings = 'Aviseringsinställningar';
	static EventTypeParameterIsInUseInParameterEventsAndCannotBeDeleted = 'Kategori 1 \'{0}\' används i {1} incidenter och kan inte tas bort!';
	static AtLeastOneFormOptionMustBeDefined = '-';
	static Paste = 'Klistra';
	static FormComponents = 'Komponenter';
	static FormDate = 'Datum';
	static TaskChartGroupingFieldGroupingTypeYear = '-';
	static SavingCompanyParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara företaget \'{0}\' eftersom data i företaget har ändrats samtidigt av en annan användare!';
	static RequireReadReceipt = 'Kräver läskvitto';
	static FirstName = 'Förnamn';
	static Layout = '-';
	static PermissionDeniedForOperation = 'Tillstånd nekad för drift!';
	static CurrentCalendarHalfYear = '-';
	static EmptyRiskManagementTrashBinConfirmation = '-';
	static TaskDataRowTotalTypeLineCount = '-';
	static SelectInstantMessageChannelType = 'Välj vhattyp';
	static NewRow = 'Ny rad';
	static CustomStyleClass = 'Klassnamn för anpassad stil';
	static Relation = 'Relation';
	static DeletingFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort mappen \'{0}\' i filsystemet! Fel: \'{1}\'';
	static AddTransferredProperty = 'Lägg till överlåten egendom';
	static OK = 'Ok';
	static FolderName = 'Mappnamn';
	static EventApprovalWasNotSuccessfulConcurrencyError = 'Det gick inte att godkänna incidenten eftersom hanteraren har ändrats samtidigt av en annan användare!';
	static FileUploadWasSuccessful = 'Filer har laddats upp!';
	static FileNameConstainsIllegalCharacters = 'Filnamnet innehåller förbjudna tecken (<, >, :, ", /, \, |, ? eller *) eller slutar med förbjudna tecken (., \' \')!';
	static TimeSpanTwoYears = 'Två år';
	static UserEndDateMustBeLessOrEqualToParameter = 'Giltighetstiden måste vara mindre än eller lika med \'{0}\'!';
	static SavingEventParameterWasSuccessful = 'Incidenten \'{0}\' har sparats!';
	static OpenCalendarTasks = 'Öppna evenemang';
	static RiskTraceabilityHigh = '-';
	static MaximumSizeOfInstantMessageAttachmentIsParameterMB = 'Den maximala storleken på bilaga till snabbmeddelanden är {0} MB!';
	static EventTypesReportName = '-';
	static RemoveFurtherEducation = 'Ta bort utbildning';
	static Camera = 'Kamera';
	static Order = 'Beställa';
	static TaskDataRowFieldParameterNotFoundInDataSchema = '-';
	static RiskMatrix = '-';
	static Folders = 'Mappar';
	static ACopy = 'Kopiera';
	static SSRSRefreshStarted = 'SSRS-uppdatering startade';
	static FormWidthMobile = 'Bredd i mobilapp';
	static SelectReceiver = 'Välj mottagare';
	static DoYouReallyWantToRemoveCompanyGroupParameter = 'Vill du verkligen ta bort företagsgruppen \'{0}\'?';
	static SSRSParameterReportsFetched = '{0} rapporter hämtade från SSRS';
	static DeletingMessageParameterWasSuccessful = 'Meddelandet \'{0}\' har tagits bort!';
	static EditableDocumentPublishUnapprovedConfirmation = 'Vill du publicera ett icke godkänt dokument till fil?';
	static RecordUserHasBeenArchived = '-';
	static DeletingRiskAssesmentsParameterWasNotSuccessfulConcurrencyError = '-';
	static DeletingRecordFurtherEducationParameterWasSuccessful = 'Utbildning \'{0}\' har tagits bort!';
	static RemoveFileFilter = 'Ta bort filfilter';
	static DeletingDirectoryItemDocumentParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort filen \'{0}\'! Fel: \'{1}\'';
	static ImportingUsersParameterWasNotSuccessfulErrorParameter = 'Det gick inte att importera användarkonton \'{0}\'! Fel: \'{1}\'';
	static DoYouWantToAddThisApplicationToHomeScreen = 'Vill du lägga till den här applikationen på startskärmen?';
	static RemoveKeyword = 'Ta bort nyckelord';
	static SavingReportParameterWasNotSuccessfulConcurrencyError = '-';
	static QrCodeAuthenticationTimeout = 'Livstid för användarsession';
	static WhistleBlowResolutionTypeMustBeDefined = 'Upplösning måste definieras! Du kan också ange upplösningsbeskrivning.';
	static SavingTaskPriorityParameterWasNotSuccessfulConcurrencyError = '-';
	static RemoveEventHandler = 'Ta bort hanteraren';
	static SavingRiskStakeholderParameterWasNotSuccessfulErrorParameter = '-';
	static RecordParameterUnlockingFailedRecordIsWriteLockedToUserParameter = 'Det gick inte att låsa upp posten \'{0}\'! Posten är skrivlåst till användaren \'{0}\'!';
	static EnableExternalIntraSystemConfirmation = 'Vill du verkligen aktivera företag i systemet? Företagsdata kommer att sparas i systemet när företaget sparas.';
	static UnkownErrorHasBeenOccured = 'Ett okänt fel har inträffat i systemet!';
	static RiskImpact4 = '-';
	static FieldParameterContainsInvalidCompanyCodeCharacters = 'Värdet på fältet \'{0}\' innehåller tecken som är olagliga i företagskoden (., &, :, \' \', ö, ä, à, å, Ö, Ä, À tai Å)!';
	static OtherSettings = 'Övriga egenskaper';
	static EventSettingsParameterNotFound = 'Incidentinställningarna \'{0}\' hittades inte!';
	static Competency = 'Kompetens';
	static NewRecordUserMustBeSavedBeforeFurtherEducationsCanBeAdded = 'Ny användarpost måste sparas innan utbildningar kan läggas till!';
	static SharedTaskTypes = '-';
	static WhistleBlowSeverityVeryLow = 'Väldigt låg';
	static LanguageNonLocalSwedish = 'Svenska';
	static Admin = 'Administratör';
	static TaskPriorityCodeIsAlreadyInUse = '-';
	static AddCompanyParameterWasSuccessful = 'Företaget \'{0}\' har lagts till!';
	static Continuous = '-';
	static TrainingEndDateCannotPrecedeTrainingStartDate = 'Slutdatum kan inte föregå startdatum!';
	static DoYouReallyWantToRemoveTaskDataRow = 'Vill du verkligen ta bort rad?';
	static FormDefaultValue = 'Standardvärde';
	static DeletingRecordFamiliarizationsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort bekantskapen \'{0}\'! Fel: \'{1}\'';
	static DoYouReallyWantToRemoveSelectedRiskCategories = '-';
	static ActiveState = 'stat';
	static ArchivingReportParameterWasSuccessful = '-';
	static CkickToChangeThePicture = 'Klicka för att ändra bilden';
	static SelectTaskDataRowTotalType = 'Välj sammanfattningsradvärde';
	static Comments = 'Kommentarer';
	static DeletingUserGroupUsersOfCompanyParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort användargruppsanslutningar relaterade till företaget \'{0}\', eftersom data i dessa användargruppanslutningar har ändrats samtidigt av en annan användare!';
	static RowForm = 'Radform';
	static FormShowCreateUser = '-';
	static LockedReportParameterCannotBeMovedToTrashBin = '-';
	static NoAddedEventTypes = 'Inga tillagda kategorier!';
	static FormCalculatedField = '-';
	static RiskStandardsInUse = '-';
	static DoYouReallyWantToRemoveRecordFamiliarizationParameter = 'Vill du verkligen ta bort bekantskapen "{0}"?';
	static FormSizeExtraLarge = 'Extra stor';
	static InstantMessageAttachmentFolderIsNotSpecified = 'Programbilaga för snabbmeddelanden är inte specificerad!';
	static SavingTaskDataRowWasSuccessful = '-';
	static DocumentsSelected = 'valda dokument';
	static VersionParameterPublishedAsPdfFile = 'Version {0} publiceras som pdf-fil';
	static PaymentSetting = 'Betalningsinställning';
	static AccessRightWrite_Message_A = '-';
	static PageBreakBetweenGroups = 'Lägg till sidbrytning mellan grupper';
	static EditUserGroup = 'Redigera användargrupp';
	static WhistleBlowResolutionRejected = 'avvisade';
	static Archived = 'Arkiverad';
	static DeletingMessageTypesParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort meddelandetyperna "{0}", eftersom data i meddelandetyperna har ändrats samtidigt av en annan användare!';
	static Settings = 'inställningar';
	static Months = 'månader';
	static FormDocumentReference = '-';
	static FormEventReference = '-';
	static NewRiskMustBeSavedBeforeRiskAssessmentsCanBeAdded = '-';
	static InstantMessageModuleInfoPermissions = 'Synlighet och åtkomsträttigheter för HoxUps diskussionskanal. Åtkomst kan inte beviljas QR-kodanvändare.';
	static LockedRiskAssessmentParameterCannotBeSaved = '-';
	static SavingChartWasSuccessful = 'Diagrammet har sparats!';
	static AccessRightRead_InstantMessageDescription = '-';
	static WhistleBlowEventTypeRead = '-';
	static DeletingRecordUserParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort användarposten "{0}", eftersom data i användarposten har ändrats samtidigt av en annan användare!';
	static FormulaDivision = 'Division';
	static SelectArchivingMethod = 'Välj Arkiveringsmetod';
	static ExitingInstantMessageChannelWasSuccessful = 'Chatten avslutades!';
	static DoYouReallyWantToRemoveDocumentParameter = 'Vill du verkligen ta bort filen/dokumentet "{0}"?';
	static PrintRow = 'Skriv ut rad';
	static MessageParameterNotFound = 'Meddelandet \'{0}\' hittades inte!';
	static Likelihood = '-';
	static DoYouReallyWantToEmailMessageParameter = 'Vill du verkligen skicka meddelandet \'{0}\' via e-post? Meddelande kan skickas via e-post endast en gång.';
	static FormNormalText = 'Text';
	static PublishVoucherInOutReportToFileSystem = 'Publicera kupongsammanfattning Skriv ut till filsystem';
	static VoucherSavePath = 'Voucher Spara sökväg';
	static DeletingWhistleBlowCategoryParameterWasSuccessful = 'Visselslagskategori \'{0}\' har tagits bort!';
	static RemoveParameterDocuments = 'Ta bort {0} filer/dokument';
	static DeletingWhistleBlowParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort visselstötsrapporten \'{0}\'! Fel: \'{1}\'';
	static InstantMessageChannelArchivingType = 'Hantering av arkiverad chatt';
	static ParameterMonthsAfterExpiration = '-';
	static EventModuleProperties = 'Incidenter Egenskaper';
	static DoYouWantToReplaceExistingSharedPanelParameter = '-';
	static DefaultEventTypes = 'Standardkategorier 1';
	static DoYouReallyWantToUnlockMessage = 'Vill du verkligen låsa upp meddelandet \'{0}\'?';
	static DeletingEventPartnerParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort incidentpartnern \'{0}\'! Fel: \'{1}\'';
	static PrintRecordUser = 'Skriv ut användarpost';
	static SavingDirectoryItemDocumentParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara filen \'{0}\'! Fel: \'{1}\'';
	static DeletingOneTimePasswordWasSuccessful = 'Engångslösenordet har tagits bort!';
	static UserRecordWillBeSharedWithCompanyParameter = 'Om användarkontot är kopplat till användarposten kommer användarposten att delas med företaget \'{0}\'.';
	static DeletingRiskStakeholdersParameterWasNotSuccessfulConcurrencyError = '-';
	static AssessorMustBeDefined = '-';
	static ErrorUserGroupChangeWouldLeadToInvalidDefaultEventHandlers = 'Ändringar av användargrupp kommer att leda till situationer där vissa standardincidenthanterare eller meddelade personer inte har behörighet att hantera incidenter med enheter. Ändringar som påverkar standardincidenthanterare eller meddelade personer kan endast göras i dialogrutan "Incidentegenskaper"!';
	static AddCompaniesParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till företag \'{0}\'! Fel: \'{1}\'';
	static NewPanel = 'Ny panel';
	static SavingRecordUserTransferredPropertyParameterWasSuccessful = 'Den överförda egenskapen \'{0}\' har sparats!';
	static SearchCondition = 'sökkriterier';
	static AddQrCodeUser = 'Lägg till QR-kodsanvändarkonto';
	static CopyOrMoveFilesDocuments = 'Kopiera eller flytta valda filer/dokument';
	static RestoringRiskParameterFromArchiveWasNotSuccessfulErrorParameter = '-';
	static MessageVisibilityPeriodNotActive = 'Meddelandets synlighetsperiod är inte aktiv!';
	static EditPayerSettings = 'Redigera betalarinställningar';
	static WeekAbbr = '-';
	static RemoveUserGroupExternalSystemsWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort användargruppslänkar från externa system! Fel: \'{0}\'';
	static SavingEventTypesWasNotSuccessfulErrorParameter = 'Det gick inte att spara kategori 1! Fel: \'{0}\'';
	static WhistleBlowCategoryParameterNotFound = 'Det gick inte att hitta kategorin "{0}" för visselblåsning!';
	static AddPartnerCompanies = 'Lägg till partners som innehåll kan delas med';
	static ReminderWeeksBefore = 'veckor innan';
	static RemoveRowConfirmation = 'Vill du verkligen ta bort rad {0}?';
	static AddFurtherEducation = 'Lägg till utbildning';
	static OldestModification = 'Äldsta ändring';
	static DeletingRiskStandardsParameterWasNotSuccessfulConcurrencyError = '-';
	static FormDecimals = 'Decimaler';
	static KeywordParameterNotFound = 'Sökordet \'{0}\' hittades inte!';
	static FormSizeDefault = 'Standard';
	static RiskDescriptionPlaceholder = '-';
	static ReadError = 'Läsfel!';
	static Search = 'Sök';
	static SavingUserGroupParameterWasSuccessful = 'Användargruppen \'{0}\' har sparats!';
	static InvalidValueParameter = 'Ogiltigt värde \'{0}\'!';
	static DocumentCreated = 'Skapad av';
	static PanelSize5 = '3 x 1';
	static AddToHomeScreen = 'Lägg till på hemskärmen';
	static Rows = 'rader';
	static DocumentNameConstainsIllegalCharacters = 'Dokumentnamnet innehåller förbjudna tecken (<, >, :, ", /, \, |, ? eller *) eller slutar med förbjudna tecken (., \' \')!';
	static TaskChartValueFieldCalculationTypeSum = '-';
	static AddingCalendarTaskHandlersWasSuccessful = 'Tillskottet av ansvariga personer var framgångsrikt!';
	static HasAttachments = 'Har bilagor';
	static ExternalSystemCodeClaimNotFound = 'Användarens anspråk \'externalSystemCode\' hittades inte!';
	static DeletingRecordBasicEducationsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort grundläggande utbildningar \'{0}\'! Fel: \'{1}\'';
	static DocumentRootPath = 'Dokumentrotsökväg';
	static SelectRecordUsers = 'Välj användarposter';
	static DeletingEventParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort incidenten \'{0}\'! Fel: \'{1}\'';
	static Month = 'Månad';
	static DeletingTaskTypesParameterWasSuccessful = '-';
	static AttachmentParameterNotFound = 'Det gick inte att hitta bilagan \'{0}\'!';
	static CalendarTaskChangeSelectedDateToSeeTheTasks = 'Ändra valt datum eller tillståndsfilter för att se händelserna';
	static WhistleBlowChannelWasNotFoundExplanation = 'Kontrollera internetadressen som angavs i webbläsarens adressfält.';
	static AccessRightWrite_Risk_A = '-';
	static UserPasswordMustBeDefined = 'Användarlösenord måste definieras!';
	static FamiliarizationIsApprovedByUser = 'Användaren har godkänt introduktionen';
	static CalendarTaskHandlerFilter = 'Ansvariga person';
	static LanguageSwedish = 'svenska';
	static ValueAddedTaxPercent = 'Mervärdesskatt %';
	static EmptyReportTrashBin = '-';
	static DeletingRecordBasicEducationParameterWasSuccessful = 'Grundutbildningen \'{0}\' har tagits bort!';
	static MovingFolderDirectoryItemParameterToFolderParameterWasSuccessful = 'Mappen \'{0}\' har flyttats till mappen \'{1}\'!';
	static SelectUnit = 'Välj Enhet';
	static AddChildEventTypeC = 'Lägg till underkategori 3';
	static EditableDocumentParameterNotFound = 'Dokumentet \'{0}\' hittades inte!';
	static StandardFiltersAndReports = 'Standardfilter och rapporter';
	static GroupByUnit = 'Gruppera efter enhet';
	static DoYouReallyWantToRemoveTaskParameterPermanenty = '-';
	static AddingWhistleBlowHandlersWasSuccessful = 'Hanterare har lagts till!';
	static Weekly = 'Varje vecka';
	static AddRiskTemplate = '-';
	static ReadingFolderParameter = 'Läser mappen \'{0}\'...';
	static DoYouReallyWantToPublishAppReportParameter = '-';
	static CompanyCodeContainsIllegalCharacters = 'Företagskoden innehåller tecken som är olagliga (., &, :, \' \', ö, ä, à, å, Ö, Ä, À tai Å)!';
	static TrainingStartDateStart = 'Startdatum - start';
	static Published = 'Publicerad';
	static WhistleBlowStatisticsResolvedRecords = 'Lösta rapporter';
	static RemoveTask = '-';
	static AddPayer = 'Lägg till betalare';
	static AccessRightNone_UserGroupDescription = '-';
	static Publisher = 'Publicerad av';
	static TheUserNameOrPasswordIsIncorrect = 'Ogiltigt användarnamn eller lösenord!';
	static DoYouReallyWantToRemoveInstantMessageChannelParameter = 'Vill du verkligen ta bort chatten "{0}"?';
	static AddUserParameterWasSuccessful = 'Användarkontot \'{0}\' har lagts till!';
	static TrainingStartDateEnd = 'Startdatum - slut';
	static StateOpen = 'Öppen';
	static FurtherEducationGroupParameterNotFound = 'Utbildningsgruppen \'{0}\' hittades inte!';
	static Effectiveness = 'Effektivitet';
	static FormDataReference = '-';
	static FormulaFloor = 'Avrundad till nedåt';
	static Closed = 'Stängd';
	static Keywords = 'Nyckelord';
	static DoYouReallyWantToRemoveSelectedRiskProcesses = '-';
	static FieldParameterValueMustBeDefined = 'Värdet för fältet \'{0}\' måste definieras!';
	static AddWhistleBlowChannelAdminParameterWasSuccessful = 'Administratören \'{0}\' har lagts till!';
	static SavingUnitsWasSuccessful = 'Enheter har sparats!';
	static AddInstantMessageUsersParameterWasSuccessful = 'Deltagarna "{0}" har lagts till!';
	static RestoringReportParameterFromArchiveWasSuccessful = '-';
	static FormMaximumValue = 'Maximalt värde';
	static OptionParameterNotFound = 'Systemalternativet \'{0}\' hittades inte!';
	static AdditionalPermissionBWhistleBlow = 'Tillståndshantering';
	static InstantMessageChannelInternal = 'Företag internt';
	static RemoveCompanyGroup = 'Ta bort företagsgrupp';
	static DoYouReallyWantToRemoveRecordFurtherEducationParameter = 'Vill du verkligen ta bort utbildning "{0}"?';
	static AddPartner = 'Lägg till partner';
	static DeletingRecordUserEmploymentParameterWasSuccessful = 'Anställningen \'{0}\' har tagits bort!';
	static AddRows = 'Lägg till rader';
	static DeletingRiskStandardParameterWasNotSuccessfulConcurrencyError = '-';
	static SaveCalendarTaskConfirmation = 'Vill du spara händelsen?';
	static RiskTraceabilityLow = '-';
	static DeletingKeywordParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort sökordet \'{0}\'! Fel: \'{1}\'';
	static AccessRightRead_LogDescription = '-';
	static Operation = 'Drift';
	static Assessments = '-';
	static EditableDocument = 'Dokumentera';
	static UpdateCompanyExternalSystemsWasSuccessful = 'Företag kopplat till externa system framgångsrikt!';
	static CompanyThatIsRelatedToExternalEventsCannotBeDeleted = '-';
	static PreviousCalendarYear = 'Föregående kalenderår';
	static LockedTaskDataRowCannotBeSaved = '-';
	static ImportingTaskDataRowsWasSuccessful = '-';
	static LockedOpportunityParameterCannotBeMovedToTrashBin = '-';
	static RiskProcessesMustBeDefinedBeforeAddingRisks = '-';
	static RecordFamiliarizationParameterNotFound = 'Bekantskap \'{0}\' hittades inte!';
	static ChartValueCalculation = '-';
	static RemoveTaskHandler = '-';
	static EditEventPartner = 'Redigera Incident Partner';
	static Template = '-';
	static Recurrence = 'Upprepning';
	static TreatmentTargetDate = '-';
	static Time = 'Tid';
	static SavingEventTypeCParameterWasSuccessful = 'Kategori 3 \'{0}\' har sparats!';
	static AddToFavorites = 'Lägg till i favoriter';
	static UserRecordStatisticsExpiringInSixMonthsFamiliarizations = 'Bekantskaper som löper ut om sex månader';
	static CompanyGroupCodeMustBeDefined = 'Koden för företagsgruppen måste definieras!';
	static SendEmailInvitation = 'Skicka inbjudan till systemet via e-post';
	static NewInstantMessageChannel = 'Ny chatt';
	static AccessRightRead_Event_A = '-';
	static SavingDirectoryItemPermissionsWasSuccessful = 'Mappbehörigheterna har sparats!';
	static SelectTaskRepetitionType = '-';
	static SavingJobParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara jobbet \'{0}\'! Fel: \'{1}\'';
	static EventTypesReportTableByTimeName = '-';
	static MessageTypesMustBeDefinedBeforeAddingMessages = 'Meddelandetyper måste definieras innan meddelanden läggs till!';
	static SendingEmailToParameter = '-';
	static SavingDirectoryItemFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara mappen \'{0}\'! Fel: \'{1}\'';
	static WhistleBlowDoesNotContainAnyMessage = 'Inga meddelanden skrivs för att rapportera om whistle blow.';
	static SavingRiskSettingWasNotSuccessfulConcurrencyError = '-';
	static PermissionsForSections = 'Avsnitt i bruk';
	static Schema = 'Schema';
	static DefaultEventHandlersAndNotifiedPersons = 'Standardincidenthanterare och meddelanden';
	static CalendarTaskCategories = 'Kategorier';
	static FormulaHypot = 'Hypotenusa';
	static RiskModuleInfoRiskTemplates = '-';
	static JobParameterNotFound = 'Jobbet \'{0}\' hittades inte!';
	static DeletingCompanyParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort företaget \'{0}\'! Fel: \'{1}\'';
	static Number = 'siffra';
	static Opportunity = '-';
	static NormalMessage = 'Normalt meddelande';
	static ByDate = 'Efter datum';
	static FormTitlePage = '-';
	static AddImage = '-';
	static UserRecords = 'Användarregister';
	static SavingPrintWasNotSuccessfulConcurrencyError = 'Det gick inte att spara utskriften "{0}", eftersom data i utskriften har ändrats samtidigt av en annan användare!';
	static DeletingWhistleBlowChannelAdminParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort administratören \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static EditableDocumentApproveConfirmation = 'Vill du godkänna dokumentet?';
	static SavingRecordUserTransferredPropertyParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara den överförda egenskapen \'{0}\'! Fel: \'{1}\'';
	static SelectReportInListToSeeThePreview = '-';
	static WhistleBlowSourceEmail = 'E-post';
	static LockedReportParameterCannotBeArchived = '-';
	static ParameterPercentOfFileStorageQuotaUsed = '{0}% av fillagringskvoten använd';
	static DefaultFurtherEducation = 'Standard utbildning';
	static AddCalendarTask = 'Lägg till händelse';
	static Approved = 'Godkänd';
	static AddChildRiskStakeholder = '-';
	static AddingRecordUserFamiliarizationHandlerWasNotSuccessfulErrorParameter = 'Misslyckades med att lägga till godkännare! Fel: \'{0}\'';
	static WorksWell = '-';
	static AccessRightWrite_MessageDescription_A = '-';
	static UserFirstNameMustBeDefined = 'Användarens förnamn måste definieras!';
	static SavingSharedPanelWasSuccessful = '-';
	static EventTypeCCodeMustBeDefined = 'Kategori 3 namn måste definieras!';
	static EditEditableDocument = 'Redigera dokument';
	static ToggleArchivedFurtherEducations = 'Visa/Göm arkiverade utbildningar';
	static PublicationOfEditableDocumentCannotBeRemoved = 'Publicering av dokumentet kan inte tas bort!';
	static Action = 'Handling';
	static SelectDocument = '-';
	static MaximumSizeOfDocumentThatCanBeAddedInBatchIsParameterMB = 'Den maximala totala storleken på dokument som kan läggas till i batch är {0} MB!';
	static NoFavoritesToShow = 'Inga favoriter att visa!';
	static Max = 'Max';
	static TaskDataRow = '-';
	static Path = 'Väg';
	static SendingPusNotificationsWasNotSuccessfulErrorParameter = 'Det gick inte att skicka push-meddelanden! Fel: \'{0}\'';
	static EditWhistleBlowChannel = 'Redigera Whistle Blow Channel';
	static UserSessionHasBeenExpired = 'Användarsessionen har löpt ut!';
	static UserAccountMustBeSelected = 'Användarkonto måste väljas!';
	static GeneralAttachments = 'Allmänna bilagor';
	static AdditionalPermissionAWhistleBlow = 'Kan kommunicera med informatör';
	static DeletingRiskProcessesParameterWasSuccessful = '-';
	static SavingEventTypeParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara kategori 1 \'{0}\', eftersom data i kategori 1 har ändrats samtidigt av en annan användare!';
	static FormPrint = 'Skriv ut';
	static SharedReports = 'Delade rapporter';
	static RiskProcess = '-';
	static InstantMessageChannelUser = 'Deltagare';
	static DeletingRecordUserParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort användarposten \'{0}\'! Fel: \'{1}\'';
	static EventTypeCParameterIsInUseInParameterEventsAndCannotBeDeleted = 'Kategori 3 \'{0}\' används i {1} incidenter och kan inte tas bort!';
	static UserGroupNameIsAlreadyInUse = 'Användargruppens namn används redan!';
	static ApplicationName = 'eSalkku';
	static AccessRightRead_MessageDescription = '-';
	static SelectDocumentTemplate = 'Välj Dokumentmall';
	static EditKeyword = 'Redigera nyckelord';
	static DeletingRecordUserTransferredPropertyParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort den överförda egenskapen \'{0}\'! Fel: \'{1}\'';
	static ClosedEvent = 'Stängd Incidenten';
	static DoYouReallyWantToRemoveSelectedReportTemplates = '-';
	static EventUrgencyClassParameterNotFound = 'Brådskande klass \'{0}\' hittades inte!';
	static MessageVisibilityPeriodNotStarted = 'Meddelandets synlighetsperiod har inte börjat!';
	static DeletingReportTemplatesParameterWasSuccessful = '-';
	static ApproveEventResolution = 'Godkänn incidentlösning';
	static CloseSystem = 'Stäng systemet';
	static DoYouReallyWantToUnlockReport = '-';
	static WebPushError = 'Web Push-fel';
	static UserModuleInfoQrCodeUserGroup = '-';
	static SendPasswordChangeEmailConfirmation = 'Vill du verkligen skicka lösenordsändringslänk via e-post?';
	static AddNew = 'Lägg till ny';
	static UnitNameMustBeDefined = 'Enhetens namn måste definieras!';
	static DoYouReallyWantToRemoveFileParameter = 'Vill du verkligen ta bort filen \'{0}\'?';
	static PersonalIdentityCode = 'Personlig identitetskod';
	static MoveDown = 'Flytta nedåt';
	static IgnoreFolderPatterns = 'Ignorera mappmönster';
	static RestoringOpportunityParameterFromArchiveWasNotSuccessfulConcurrencyError = '-';
	static FormRowColumn = 'Rad kolumn';
	static LogOut = 'Logga ut';
	static SavingUserParametersWasNotSuccessfulErrorParameter = 'Det gick inte att spara användaralternativ! Fel: \'{0}\'';
	static SavingEventPartnerParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara incidentpartnern \'{0}\' eftersom data i incidentpartnern har ändrats samtidigt av en annan användare!';
	static FormDatesAndTimes = 'Datum och tider';
	static EventTypeBCodeIsAlreadyInUse = 'Kategori 2-namnet används redan!';
	static DoYouReallyWantToUnlockRisk = '-';
	static AccessRightRead_AppReportDescription = '-';
	static PreviousCalendarWeek = 'Föregående kalendervecka';
	static Trigonometry = 'Trigonometri';
	static SavingRiskProcessParameterWasSuccessful = '-';
	static DeletingDefaultEventHandlerParameterWasSuccessful = 'Standardincidenthanteraren \'{0}\' har tagits bort!';
	static EmailNotificationInUse = 'Jag vill få e-postmeddelanden';
	static ChooseHowYouWantToReport = 'Välj hur du vill rapportera';
	static Favorites = 'Favoriter';
	static WhistleBlowEventTypeAttachmentsAdded = 'Bilagor har lagts till';
	static WhistleBlowState = 'Rapportera tillstånd';
	static UpdateUserGroupParameterExternalSystemsWasSuccessful = 'Användargruppen \'{0}\' har länkats till externa system framgångsrikt!';
	static Download = 'Ladda ner';
	static TaskLockingType = '-';
	static AddChildRiskCategory = '-';
	static RecordUserExcelSalary = 'Lön';
	static Line = 'Linje';
	static AddCompanyParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till företaget \'{0}\'! Fel: \'{1}\'';
	static EditTaskState = '-';
	static UnitIsRelatedToEventPartner = 'Enheten är relaterad till incidentpartner';
	static DeletingRiskTemplatesParameterWasNotSuccessfulErrorParameter = '-';
	static IdCard = 'ID-kort';
	static DefaultCalendarTaskCategories = 'Standardkategorier';
	static SomeInstantMessageUsersHaveReadMessage = 'Vissa mottagare har läst ditt meddelande';
	static SendEmailInvitationConfirmation = 'Vill du verkligen skicka inbjudan till systemet via e-post?';
	static FormCodeMustBeDefined = 'Formulärkod måste definieras!';
	static DefaultReportTemplates = '-';
	static RecordUserActiveStateChangePermissionDeniedInUnitParameter = 'Arkiverad tillståndsändring är inte tillåten i enheten \'{0}\'!';
	static RiskStakeholdersMustBeDefinedBeforeAddingRisks = '-';
	static RenamingFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att byta namn på mappen (\'{0}\' => \'{1}\') i filsystemet! Fel: \'{2}\'';
	static AddingTaskHandlerWasNotSuccessfulErrorParameter = '-';
	static MessageTypeCodeIsAlreadyInUse = 'Meddelandetypskoden används redan!';
	static AddCompany = 'Lägg till företag';
	static DoYouReallyWantToRemoveTaskHandlerParameter = 'Vill du verkligen ta bort hanteraren \'{0}\'?';
	static FormExpressionFormatMinutesToHoursAndMinutes = 'Från minuter till timmar och minuter';
	static EventHandlers = 'Handlare';
	static TaskDefaultStatesInUse = '-';
	static Entry = 'Inträde';
	static AddLogisticVoucherCompanyPaymentSetting = 'Lägg till betalningsinställning';
	static TaskStateCodeIsAlreadyInUse = '-';
	static AccessRightRead = '-';
	static AddRiskStandard = '-';
	static SelectCalendarTaskHandlers = 'Välj ansvariga personer';
	static RiskStandardParameterHasChildNodesAndCannotBeDeleted = '-';
	static WhistleBlowRecords = 'Uppgifter';
	static ArchivingTaskParameterWasNotSuccessfulErrorParameter = '-';
	static InstantMessageChannelArchivingTypeKeepMessages = 'Bevara arkiverad chatt och meddelanden';
	static NameMustBeDefined = 'Namn måste definieras!';
	static AllDataValuesAreZeroOrUndefined = '-';
	static ApprovalDate = '-';
	static AddAtleastOneInstantMessageChannelUsersToInstantMessageChannel = 'Lägg till minst en deltagare i chatten!';
	static NowRows = '-';
	static AllUsersOfTheUnit = 'Alla användare av enheten';
	static RemovingRiskTemplateUnitsWasNotSuccessfulErrorParameter = '-';
	static FormDateFieldIsNotSelected = '-';
	static EventTypeCodeMustBeDefined = 'Kategori 1 namn måste definieras!';
	static DeletingDirectoryItemFolderParameterWasSuccessful = 'Mappen \'{0}\' har tagits bort!';
	static DeletingWhistleBlowChannelAdminsParameterWasSuccessful = 'Administratörer "{0}" har tagits bort!';
	static EmploymentEndDate = 'Slutdatum för anställning';
	static ComparingFileSystemToDatabase = 'Jämför filsystem med databas...';
	static DeletingEventParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort incidenten \'{0}\' eftersom data i incidenten har ändrats samtidigt av en annan användare!';
	static AddTaskHandler = '-';
	static AllCompanyGroups = 'Alla företagsgrupper';
	static RecordEmailNotificationTypeLine2 = 'Rapporten innehåller data från alla användarposter som är synliga för användaren.';
	static DeletingRecordBasicEducationsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort grundläggande utbildningar \'{0}\', eftersom data i grundläggande utbildningar har ändrats samtidigt av en annan användare!';
	static EditMessageType = 'Redigera meddelandetyp';
	static DoYouReallyWantToRemoveRecordFurtherEducationGroupParameter = 'Vill du verkligen ta bort utbildningsgruppen \'{0}\'?';
	static InternalAttachments = 'Interna bilagor';
	static SelectEventHandler = 'Välj Hanterare';
	static LargeSize = 'Stor storlek';
	static ArchivingRiskParameterWasNotSuccessfulConcurrencyError = '-';
	static LockingEditableDocumentParameterWasNotSuccessful = 'Det gick inte att låsa dokumentet \'{0}\'!';
	static SavingRiskParameterWasNotSuccessfulConcurrencyError = '-';
	static SaveAndEmail = 'Spara och maila';
	static AType = 'Typ';
	static AccessRightNone_CompanyDescription = '-';
	static CalendarTask = 'Händelse';
	static DocumentsNotFound = 'Dokumenten hittades inte!';
	static FormCreateDate = '-';
	static UserNotAllowedToViewNotifier = 'Begränsad behandlingsrätt: Användaren har inte rätt att se anmälaren';
	static SelectRiskInListToSeeThePreview = '-';
	static EmailAddressMustBeValid = 'E-postadressen är inte giltig e-postadress!';
	static FormDecimalNumber = 'Decimaltal';
	static RemoveUserGroupExternalSystemsWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort användargrupplänkar från externa system, eftersom data har ändrats samtidigt av en annan användare!';
	static InstantMessageChannelOnlyAdministratorCannotExitInstantMessageChannel = 'Endast chattadministratören kan inte avsluta chatten!';
	static ThisMessageWasDeletedByInstantMessageChannelAdministrator = 'Det här meddelandet raderades av administratören, \'{0}\'';
	static SavingUserParameterParameterWasSuccessful = 'Användaralternativet \'{0}\' har sparats!';
	static DoYouReallyWantToSaveData = 'Vill du verkligen spara?';
	static WhistleBlowInformantMustBeNotifiedLatestAtParameter = 'Visselslagsrapport måste markeras som löst {0} senast!';
	static SavingApplicationPermissionsWasNotSuccessfulErrorParameter = 'Det gick inte att spara systembehörighetersi! Visar: \'{0}\'';
	static SavingEventDefaultHandlerParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara standardincidenthanteraren \'{0}\'! Fel: \'{1}\'';
	static DefaultLanguage = 'Språk';
	static EmailAddress = 'E-post';
	static DeletingKeywordsParameterWasSuccessful = 'Sökorden "{0}" har tagits bort!';
	static RemovingCalendarTaskHandlerWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort ansvariga personer! Fel: \'{0}\'';
	static SavingRecordEmploymentParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara anställning \'{0}\'! Fel: \'{1}\'';
	static SavingEditableDocumentParameterApprovalWasNotSuccessfulErrorParameter = 'Det gick inte att godkänna dokumentet \'{0}\'! Fel: \'{1}\'';
	static DocumentApproved = 'Godkänd av';
	static PanelVisible = 'Panel synlig';
	static Unlimited = 'Obegränsat';
	static RiskContainsOpportunity = '-';
	static ReadingFileParameterWasNotSuccessfulErrorParameter = 'Det gick inte att läsa filen \'{0}\' i filsystemet! Fel: \'{1}\'';
	static City = 'Stad';
	static DefaultTaskTypes = '-';
	static CalendarTaskRepetitionCountPrefix = 'Efter';
	static InstantMessageChannelContainsParameterInstantMessageUsersAndCannotBeDeleted = 'Chatten har andra deltagare och kan inte tas bort!';
	static NewEmploymentMustBeSavedBeforeAttachmentsCanBeAdded = 'Ny anställning måste sparas innan bilagor kan läggas till!';
	static ExitingInstantMessageChannelWasNotSuccessfulConcurrencyError = 'Det gick inte att avsluta chatten eftersom data i chatten har ändrats samtidigt av en annan användare!';
	static ExternalSystemCode = 'Kod i systemet';
	static MovingOpportunityParameterToTrashBinWasNotSuccessfulConcurrencyError = '-';
	static FileParameterDownloaded = 'Filen \'{0}\' har laddats ned.';
	static ResetDocumentVersion = 'Återställ dokumentversion';
	static TaskHandlers = '-';
	static Last7Days = 'Senaste 7 dagarna';
	static FormCheckbox = 'Kryssruta';
	static DeletingEditableDocumentParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort dokumentet \'{0}\' eftersom data i dokumentet har ändrats samtidigt av en annan användare!';
	static RiskCategory = '-';
	static AddingAddRecordUserFurtherEducationsWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till utbildningar! Fel: \'{0}\'';
	static CompanyLogo = 'Företagslogotyp';
	static DaysAgo120 = '120 dagar sedan';
	static OpportunityIsModifiedAfterItWasPublished = '-';
	static AccessRightNone_AppReportDescription = '-';
	static Copy = 'Kopiera';
	static AddDocumentTemplate = 'Lägg till dokumentmall';
	static PrintParameterDownloaded = 'Utskriften har laddats ner.';
	static MovingReportParameterToTrashBinWasNotSuccessfulConcurrencyError = '-';
	static PasswordIsTooShort = 'Lösenordet är för kort!';
	static RiskProcessParameterNotFound = '-';
	static WhistleBlowAnonymityAnonymous = 'Anonym';
	static DoYouReallyWantToRemoveRiskProcessParameter = '-';
	static NoneSelected = 'Ingen vald';
	static OpportunityBenefitMustBeDefined = '-';
	static SelectUserGroups = '-';
	static ChartBuilder = '-';
	static Save = 'Spara';
	static EventTypeCostsReportTableDirectCostsByCategoryName = '-';
	static DeletingUserParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort användarkontot \'{0}\'! Fel: \'{1}\'';
	static TaskChartGroupingFieldGroupingTypeWeek = '-';
	static AddUserParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till användarkontot \'{0}\', eftersom data har ändrats samtidigt av en annan användare!';
	static FormTextAreaSize = 'Höjd';
	static FormTitles = 'Titlar';
	static DoYouReallyWantToRemoveWhistleBlowCategoryParameter = 'Vill du verkligen ta bort kategorin \'{0}\'?';
	static SavePrintAs = 'Spara utskrift som';
	static Unkown = 'Okänt';
	static Public = 'offentlig';
	static NewFamiliarizationMustBeSavedBeforeAttachmentsCanBeAdded = 'Ny bekantskap måste sparas innan bilagor kan läggas till!';
	static FormUsableInSearchFilter = 'Användbar i sökfilter';
	static CalendarTaskRepetitionRepeatIntervalWeeklySuffix = 'veckor';
	static DeletingKeywordParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort sökordet "{0}", eftersom data i sökordet har ändrats samtidigt av en annan användare!';
	static CkickToChangeTheIcon = 'Klicka för att ändra ikonen';
	static DeletingRiskCategoriesParameterWasNotSuccessfulErrorParameter = '-';
	static LastListRow = 'Sista listraden';
	static LockedOpportunityParameterCannotBePublished = '-';
	static SelectUserGroupOrUser = 'Välj Användargrupp eller Användarkonto';
	static TaskDataRowMustBeSavedBeforeAttachmentsCanBeAdded = '-';
	static AccessRightRead_Event_AC = '-';
	static CopyDocumentsFromCompany = 'Kopiera dokument från detta företag';
	static FormFalse = 'Osann';
	static File = 'Fil';
	static TaskMustBeSavedBeforeCalendarTasksCanBeAdded = '-';
	static InstantMessagesMenuTitle = 'HoxUp';
	static Remove = 'Avlägsna';
	static MaximumSizeOfFilesThatCanBeAddedInBatchIsParameterMB = 'Den maximala totala storleken på filer som kan läggas till i batch är {0} MB!';
	static RiskThreat = '-';
	static SavingKeywordParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara sökordet \'{0}\'! Fel: \'{1}\'';
	static TargetsOtherCompanies = 'Synlighet - Andra företag';
	static ProjectNumber = 'Projektnummer';
	static SavingWhistleBlowChannelParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara whistle blow-kanalen \'{0}\', eftersom data i whistle blow-kanalen har ändrats samtidigt av en annan användare!';
	static Card = 'Kort';
	static YouHaveUnapprovedChangesDoYouWantApproveChanges = 'Du har inte godkänt ändringar som du har gjort. Vill du godkänna ändringar?';
	static AddMessage = 'Lägg till meddelande';
	static RecordUserFurtherEducationsBarChartByTimeName = '-';
	static NotValid = 'Inte giltig';
	static NewRecordUserMustBeSavedBeforeTransferredPropertiesCanBeAdded = 'Ny användarpost måste sparas innan överförda egenskaper kan läggas till!';
	static DoYouReallyWantToRemoveSelectedFileFilters = 'Vill du verkligen ta bort valda filfilter?';
	static ReplyToInstantMessage = 'Svara på meddelande';
	static CopyingFilesAndDocumentsToFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att kopiera filer/dokument till mappen \'{0}\'! Fel: \'{1}\'';
	static AddLogisticVoucherCustomer = 'Lägg till kund';
	static Wage = 'Lön';
	static PreviewIsNotSupportedForThisFileType = 'Förhandsgranskning stöds inte för den här filtypen!';
	static RemoveDefaultBasicEducation = 'Ta bort Standard Basic Education';
	static EditLogisticVoucherCompanyPaymentSetting = 'Redigera betalningsinställning';
	static SavingRecordFurtherEducationGroupParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara utbildningsgruppen \'{0}\'! Fel: \'{1}\'';
	static FormulaPI = 'Pi';
	static ChartParameterNotFound = '-';
	static Keyword = 'Nyckelord';
	static TaskPriorities = '-';
	static RemovingReportTemplateUnitsWasNotSuccessfulErrorParameter = '-';
	static WhistleBlowEventTypeHandlersAdded = 'Handlare har lagts till';
	static SavingWhistleBlowCategoryParameterWasSuccessful = 'Visselslagskategori \'{0}\' har sparats!';
	static AccessRightWrite_EventDescription_B = '-';
	static StateOpenPlural = 'Öppen';
	static RemoveCalendarTaskCategory = 'Ta bort kategori';
	static TakePicture = 'Ta bild';
	static InOneYear = 'På ett år';
	static RiskStandardParameterNotFound = '-';
	static AccessRightWrite_UserGroupDescription = '-';
	static DeletingUserParametersWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort användarparametrar! Fel: \'{0}\'';
	static SavingEventTypeBParameterWasSuccessful = 'Kategori 2 \'{0}\' har sparats!';
	static MessageType = 'Meddelandetyp';
	static EventModuleInfoSettings = 'Storleken på förhandsgranskningsbilder för incidenter som bifogas, om fältet "Observatörsåtgärd" ska inkluderas i incidenten och om platsdata ska inkluderas i incidenten.';
	static AgencyWorker = 'Byråarbetare';
	static TaskDataRowTotalTypeColAverage = '-';
	static TaskCalendarTasksPersonsInChargeWarning = '-';
	static ChartType = 'Diagramtyp';
	static EventParameterNotFound = 'Incidenten \'{0}\' hittades inte!';
	static FieldParameterConstainsIllegalCharactersForFileName = 'Värdet på fältet \'{0}\' innehåller tecken som är olagliga i filnamn (<, >, :, ", /, \, |, ? tai *) eller så slutar det med olagliga tecken (., \' \')!';
	static FormRadio = '-';
	static RiskStandardParameterIsInUse = '-';
	static SavingCalendarTaskCategoryParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara kategori \'{0}\'! Fel: \'{1}\'';
	static TargetsMyCompany = 'Synlighet - Mitt företag';
	static FormSizeSmall = 'Små';
	static NewUserMustBeSavedBeforeUserGroupsCanBeAdded = 'Ny användare måste sparas innan användargrupper kan läggas till!';
	static InvalidPasswordChangeRequestParameter = 'Ogiltig begäran om lösenordsändring \'{0}\'!';
	static RiskCreated = '-';
	static DeletingCalendarTaskCategoriesParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kategorierna "{0}", eftersom data i kategorier har ändrats samtidigt av en annan användare!';
	static LockedOpportunityParameterCannotBeUnpublished = '-';
	static DoYouReallyWantToPublishRiskParameter = '-';
	static WhistleBlowNonAnonymousReportInfo = 'Ditt namn kommer endast att vara känt för dem som hanterar din anmälan, och det kommer att förbli anonymt för alla andra.';
	static PrintFileName = 'Skriv ut_{0:åååå-MM-ddHH-mm}.pdf';
	static RiskCategoriesMustBeDefinedBeforeAddingRiskTemplates = '-';
	static DoYouReallyWantToRestoreOpportunityParameterFromArchive = '-';
	static WhistleBlowResolutionOther = 'Övrig';
	static RestoringTaskParameterFromTrashBinWasNotSuccessfulConcurrencyError = '-';
	static ReadingDatabaseParameter = 'Läser databasen \'{0}\'...';
	static CreatingNotifications = 'Skapar aviseringar...';
	static SharedResource = 'Delad resurs';
	static AddCompanyGroupParameterWasSuccessful = 'Företagsgruppen \'{0}\' har lagts till!';
	static Familiarizations = 'Bekantskaper';
	static OpenTrashBin = 'Öppna papperskorgen';
	static RecordUserFamiliarizationApprovalWasSuccessful = 'Bekantgöring godkänd!';
	static DoYouReallyWantToArchiveRiskParameter = '-';
	static CopyingFolderDirectoryItemParameterToFolderParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att kopiera mappen \'{0}\' till mappen \'{1}\', eftersom data i mappen har ändrats samtidigt av en annan användare!';
	static EditOpportunity = '-';
	static AssessmentCommentMustBeDefined = '-';
	static RemoveEditableDocument = 'Ta bort dokument';
	static SavingRiskStandardParameterWasSuccessful = '-';
	static SavingDirectoryItemDocumentParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara filen \'{0}\' eftersom data i filen har ändrats samtidigt av en annan användare!';
	static Companies = 'Företag';
	static RemoveUserFromUserGroup = 'Ta bort användarkonto från användargrupp';
	static DirectoryItemDocumentsNotFound = 'Filer/dokument gillar inte!';
	static RecordUserParameterNotFound = 'Användarposten \'{0}\' hittades inte!';
	static UnpublishingRiskParameterWasNotSuccessfulErrorParameter = '-';
	static Assessment = '-';
	static DeletingReportTemplateParameterWasSuccessful = '-';
	static EventTypesCReportName = '-';
	static SSRSRefreshFinishedInParameterSeconds = 'SSRS-uppdatering avslutad (varaktighet: {0:N0}s)';
	static EditTask = '-';
	static RiskStakeholdersInUse = '-';
	static LoadMore = 'Ladda mer';
	static AccountIBANNumber = 'Bankkonto IBAN-nummer';
	static DeletingRiskStakeholderParameterWasNotSuccessfulErrorParameter = '-';
	static UserGroups = 'Användargrupper';
	static InstantMessageUserInvitationAcceptTypeCannotInvite = 'Jag kan inte bli inbjuden att gå med i chatten';
	static UserCodeIsAlreadyInUse = 'Användarnamnet används redan!';
	static RiskCategoryParameterIsInUse = '-';
	static TaskRemainderCheckingAndNotificationStarted = '-';
	static MobileAppInUse = 'Mobilapp används';
	static AuthorizationLevelAdmin = 'Administratörer';
	static ImportingUsersParameterWasSuccessful = 'Användarkonton \'{0}\' har importerats!';
	static EventApprovalWasNotSuccessfulErrorParameter = 'Det gick inte att godkänna incidenten! Fel: \'{0}\'';
	static DeletingFileFiltersParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort filfiltren "{0}", eftersom data i filfiltren har ändrats samtidigt av en annan användare!';
	static DeletingInstantMessageUserParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort deltagaren \'{0}\'! Fel: \'{1}\'';
	static Repeated = 'Upprepad';
	static DeletingRecordUserEmploymentsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort anställningar "{0}", eftersom data i anställningar har ändrats samtidigt av en annan användare!';
	static DeletingFileFilterParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort filfiltret \'{0}\' eftersom data i filfiltret har ändrats samtidigt av en annan användare!';
	static SavingRecordBasicEducationParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara grundläggande utbildning \'{0}\'! Fel: \'{1}\'';
	static LoggedInUserAccountIsNotActive = 'Inloggad användare är inte aktiv!';
	static RemoveTaskType = '-';
	static DeletingRecordUserTransferredPropertyParameterWasSuccessful = 'Den överförda egenskapen \'{0}\' har tagits bort!';
	static Day = 'Dag';
	static AddPartners = 'Lägg till partners';
	static TaskParameterNotFound = '-';
	static ReportTemplateUnits = '-';
	static RiskTemplate = '-';
	static RiskProcessCodeIsAlreadyInUse = '-';
	static ReportTemplateUsedInAllUnits = '-';
	static CreateReport = 'Skapa rapport';
	static ChartValueFields = '-';
	static DaysAgo60 = '60 dagar sedan';
	static AccessRightRead_CalendarTaskDescription = '-';
	static UsedFileStorageQuota = 'Använd fillagringskvot';
	static RestoringRiskParameterFromArchiveWasSuccessful = '-';
	static Password = 'Lösenord';
	static RequestValidationErrorOnFieldParameterWithValueParameter = 'Värdet \'{1}\' i fältet \'{0}\' innehåller innehåll som anses vara farligt i webbapplikationer!';
	static OpportunityParameterNotFound = '-';
	static FormInitializeFromSavedRowDialog = 'Initiera standardvärde från sparad rad';
	static BarChart = '-';
	static RecordUserFurtherEducationsTableByTimeName = '-';
	static FormDisabled = 'Ingång avaktiverad';
	static Target = 'Mål';
	static UserIsPersonInCharge = '-';
	static AddQualification = 'Lägg till kvalifikation';
	static RecordUserExcelFurtherEducation = 'Utbildningar';
	static RecordParameterLockingFailedRecordIsWriteLockedToUserParameter = 'Det gick inte att låsa posten \'{0}\'! Posten är skrivlåst till användaren \'{0}\'!';
	static RiskModuleInfoUnits = '-';
	static RemoveRecordUserAndKeepUser = 'Ta bort användarpost och behåll användarkonto';
	static Name = 'namn';
	static SavingUserGroupParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara användargruppen \'{0}\'! Fel: \'{1}\'';
	static SavingDefaultHandlersWasNotSuccessfulConcurrencyError = 'Det gick inte att spara standardhanterare eftersom standardhanterare har ändrats samtidigt av en annan användare!';
	static MyFilters = 'Användarens filter';
	static ChartGenerationAborted = 'Skapandet av diagram avbröts!';
	static AddSharedDocumentTemplate = 'Lägg till delad dokumentmall';
	static PublishingOpportunityParameterWasNotSuccessfulErrorParameter = '-';
	static LockingEventParameterWasNotSuccessful = 'Det gick inte att låsa incidenten \'{0}\'!';
	static SavingTaskStateParameterWasNotSuccessfulConcurrencyError = '-';
	static AddedComment = 'Tillagd kommentar';
	static WebPageStyle = 'Sidstil';
	static TaskPriorityParameterNotFound = '-';
	static EditCompanyTaskType = '-';
	static ControlEffiency = '-';
	static DeletingEventPartnerParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort incidentpartnern \'{0}\' eftersom data i incidentpartnern har ändrats samtidigt av en annan användare!';
	static ApprovalAuthority = '-';
	static ExpiredPlural = 'Utgånget';
	static RecordUserLogEntryTypeReport = 'Rapportering';
	static LockedDocumentParameterCannotBeDeleted = 'Det låsta dokumentet \'{0}\' kan inte tas bort!';
	static AccessRightRead_InstantMessage_A = '-';
	static FormShowInRow = 'Använd i rad';
	static TaskTypesByUnits = '-';
	static DeletingWhistleBlowCategoriesParameterWasSuccessful = 'Visselslagskategorierna \'{0}\' har tagits bort!';
	static UserGroupParameterNotFound = 'Användargruppen \'{0}\' hittades inte!';
	static NewInstantMessageChannelMustBeSavedBeforeUsersCanBeAdded = 'Ny chatt måste sparas innan deltagare kan läggas till!';
	static MovedToTrashBin = 'Flyttade till papperskorgen';
	static Error = 'Fel';
	static DeletingInstantMessageUserParameterWasSuccessful = 'Deltagare \'{0}\' har tagits bort!';
	static DirectoryItemFolderParameterNotFound = 'Mappen \'{0}\' hittades inte!';
	static TimeSpanYear = 'År';
	static DeletingRecordQualificationsParameterWasSuccessful = 'Kvalifikationerna \'{0}\' har tagits bort!';
	static AddingRiskTemplateUnitsWasSuccessful = '-';
	static SavingOptionParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara alternativet \'{0}\'! Fel: \'{1}\'';
	static ArchiveWhistleBlows = 'Arkivera Whistle Blow-rapporter';
	static DoYouReallyWantToRemoveSelectedRecordFamiliarizations = 'Vill du verkligen ta bort valda ytterligare bekantskaper?';
	static Expired = 'Utgånget';
	static EventUrgencyClasses = 'Brådskande klasser';
	static AddWhistleBlow = 'Lägg till Whistle Blow Report';
	static DownloadAttachment = 'Ladda ner vald bilaga';
	static FurtherEductionGroupParameterContainsFurtherEducationsAndCannotBeDeleted = 'Utbildningsgruppen \'{0}\' innehåller utbildningar och kan inte tas bort!';
	static EditEventTypeCs = 'Redigera kategori 3';
	static UsersToBeImported = 'Användare som ska importeras';
	static EmailHasBeenAlreadySentForThisMessage = 'E-post har redan skickats för detta meddelande!';
	static RemoveNotifiedPerson = 'Ta bort person som ska meddelas';
	static PublishVoucherToFileSystem = 'Publicera voucher till filsystem';
	static AddChartValueField = '-';
	static RemoveLogisticVoucherCustomerPaymentSetting = 'Ta bort betalningsinställning';
	static RemoveUserAndRecordUser = 'Ta bort användarkonto och användarpost';
	static PermissionToCreateEventsToPartners = 'Tillstånd att skapa incidenter för partners';
	static PushEndpoint = 'Tryck på Endpoint';
	static OnlyOneChartValueFieldIsSupported = '-';
	static DoYouReallyWantToRemoveRecordQualificationParameter = 'Vill du verkligen ta bort kvalifikationen \'{0}\'?';
	static LockTaskTypeAfterSave = 'Lås form efter spara';
	static SavingEventSettingsWasNotSuccessfulErrorParameter = 'Det gick inte att spara incidentinställningarna! Fel: \'{0}\'';
	static SendReadReceiptConfirmation = 'Vill du skicka läskvitto?';
	static DeletingTaskStateParameterWasNotSuccessfulConcurrencyError = '-';
	static WhistleBlowChannelSettings = 'Inställningar för whistle Blow-kanal';
	static SavingEventTypeCParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara kategori 3 \'{0}\', eftersom data i kategori 3 har ändrats samtidigt av en annan användare!';
	static RestoringInstantMessageWasNotSuccessfulConcurrencyError = 'Det gick inte att återställa snabbmeddelandet eftersom data i snabbmeddelandet har ändrats samtidigt av en annan användare!';
	static FormShowCreateDate = '-';
	static ByRiskCategory = '-';
	static DoYouReallyWantToUnpublishOpportunityParameter = '-';
	static FileChangesCheckingAndEmailingFinishedInParameterSeconds = 'Filändringskontroll och e-post har slutförts (varaktighet: {0:N0}s, fel: {1}, filer: {2}, e-postmeddelanden: {3})';
	static InstantMessageChannelRemoveFromYourselfFromAdministratorsConfirmation = 'Vill du verkligen ta bort dig själv från administratörer? Endast administratörer kan hantera chatten.';
	static EmailingMessageWasNotSuccessfulErrorParameter = 'Det gick inte att skicka meddelande via e-post! Fel: \'{0}\'';
	static Addition = 'Tillägg';
	static LockedRiskParameterCannotBeDeleted = '-';
	static EditDefaultTaskState = '-';
	static OpenRow = '-';
	static DeletingRiskAssesmentParameterWasNotSuccessfulConcurrencyError = '-';
	static Date = 'Datum';
	static SavingPushSendLogParameterWasSuccessful = '-';
	static RemoveRiskStakeholder = '-';
	static Required = 'Nödvändig';
	static FormulaCeil = 'Avrundad till uppåt';
	static TaskDataRowTotalTypeText = '-';
	static SaveUserFurtherEducationConfirmation = 'Vill du spara utbildningen?';
	static Log = 'Loggar';
	static DoYouReallyWantToRemoveRecordBasicEducationParameter = 'Vill du verkligen ta bort grundläggande utbildning \'{0}\'?';
	static AddUserGroup = 'Lägg till användargrupp';
	static NewPassword = 'nytt lösenord';
	static WhistleBlowAttachmentAddReasonDefaultValue = 'Lade till en bilaga som inte innehåller onödig information (t.ex. personuppgifter).';
	static RecordBasicEducationCodeIsAlreadyInUse = 'Grundutbildningens namn används redan!';
	static DeletingDocumentTemplateParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort dokumentmallen \'{0}\', eftersom data i dokumentmallen har ändrats samtidigt av en annan användare!';
	static DeletingWhistleBlowCategoryParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kategorin "{0}" för whistle blow eftersom data i kategorin "whistle blow" har ändrats samtidigt av en annan användare!';
	static FormRemoveFieldConfirmation = 'Vill du verkligen ta bort fält från formuläret?';
	static FileParameterIsNotImage = 'Filen \'{0}\' är inte en bild!';
	static UserUnapproved = 'Jag har inte godkänt';
	static DeletingTaskStatesParameterWasNotSuccessfulConcurrencyError = '-';
	static FamiliarizationStartDate = 'Startdatum för bekantskap';
	static DocumentTemplates = 'Dokumentmallar';
	static EditBasicEducation = 'Redigera Grundutbildning';
	static FormColumnWidthPrint = 'Kolumnbredd i tryck';
	static EfficiencyPercentage = '-';
	static LockedRiskParameterCannotBePublished = '-';
	static MessageTypeParameterNotFound = 'Meddelandetypen \'{0}\' hittades inte!';
	static SelectEventPartner = 'Välj Incident Partner';
	static SavingUserParametersWasNotSuccessfulConcurrencyError = 'Det gick inte att spara användaralternativ, eftersom data i användaralternativen har ändrats samtidigt av en annan användare!';
	static RecordUserModuleInfoFamiliarizations = 'Bekantskapen är avsedd att användas för anställdas första introduktion till arbetsuppgifter, arbetsplatspraxis, system, ansvar och säkerhetsinstruktioner. Syftet är att säkerställa att den nyanställde får nödvändiga kunskaper och färdigheter för att utföra sina arbetsuppgifter smidigt redan från början.\n\nNotera! Separata utbildningar, kurser eller efterföljande kompetensutveckling antecknas inte i detta avsnitt – de hör hemma i utbildningsdelen.';
	static DoYouReallyWantToPublishOpportunityParameter = '-';
	static DeletingRecordFurtherEducationGroupParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort utbildningsgruppen \'{0}\'! Fel: \'{1}\'';
	static SavingEditableDocumentParameterApprovalWasSuccessful = 'Dokumentet \'{0}\' har godkänts!';
	static RiskTreatmentStateCompleted = '-';
	static SavingRecordEmploymentParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara anställningen \'{0}\', eftersom data i anställningen har ändrats samtidigt av en annan användare!';
	static LockedEventParameterCannotBeDeleted = 'Låst incident \'{0}\' kan inte tas bort!';
	static FormSelection = '-';
	static ActionIsNotAuthorized = 'Åtgärd är inte tillåten!';
	static Approve = 'Godkänna';
	static DoYouReallyWantToRemoveDocumentsParameter = 'Vill du verkligen ta bort {0} valda filer/dokument?';
	static NoEvents = 'Inga händelser';
	static SavingKeywordParameterWasSuccessful = 'Sökordet \'{0}\' har sparats!';
	static IncludeArchivedRecordUsers = 'Inkludera arkiverade användaruppgifter';
	static WhistleBlowStateReceived = 'Mottagen';
	static SavingUnitsWasNotSuccessfulErrorParameter = 'Det gick inte att spara enheter! Fel: \'{0}\'';
	static FurtherEducations = 'Utbildningar';
	static RemoveTaskState = '-';
	static BannerPath = 'Banner mapp';
	static EditPermission = 'Redigera behörighet';
	static FormTaskReferenceIsIsInvalid = '-';
	static SavingEditableDocumentParameterPublishWasSuccessful = 'Dokumentet \'{0}\' har publicerats framgångsrikt!';
	static RemovePermission = 'Ta bort behörighet';
	static TaskChartGroupingFieldGroupingTypeMonth = '-';
	static SourceDescription = 'Källbeskrivning';
	static CompanyParameterNotFound = 'Företaget \'{0}\' hittades inte!';
	static DoYouReallyWantToArchiveRecordUserParameter = '-';
	static SelectCategory = 'Välj kategori';
	static InheritedContentFilter = '(ärvt innehållsfilter)';
	static SavingRiskProcessParameterWasNotSuccessfulConcurrencyError = '-';
	static SuccessAudit = 'SuccessAudit';
	static RiskThreatPlaceholder = '-';
	static UserFilterActive = 'Aktiva användarkonton';
	static DeletingRecordUserEmploymentsParameterWasSuccessful = 'Anställningar "{0}" har tagits bort!';
	static AdministratorPasswordMustBeDefined = 'Administratörens lösenord måste definieras!';
	static DoYouReallyWantToUnlockEditableDocument = 'Vill du verkligen låsa upp dokumentet \'{0}\'?';
	static PersonsInChargeRemoveConfirmation = '-';
	static DefaultRiskTemplates = '-';
	static SharedTo = 'Delad till';
	static PaymentSettings = 'Betalningsinställningar';
	static FormWeb = 'Webb-app';
	static DeletingMessageTypeParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort meddelandetypen \'{0}\', eftersom data i meddelandetypen har ändrats samtidigt av en annan användare!';
	static ExpiresInParameterDays = 'Går ut om {0} dagar';
	static SelectTaskState = '-';
	static WhistleBlowSourcePhone = 'Telefon';
	static CourseCredits = 'Kurspoäng';
	static DeletingInstantMessageUsersParameterWasSuccessful = 'Deltagarna "{0}" har tagits bort!';
	static FormulaSqrt = 'Kvadratrot';
	static SavingReportParameterWasSuccessful = '-';
	static ClickToChangeTheLogo = 'Klicka för att ändra logotypen';
	static DoYouReallyWantToUnpublishRiskParameter = '-';
	static DeletingRiskTemplatesParameterWasNotSuccessfulConcurrencyError = '-';
	static WhistleBlowCreateTime = 'Rapportera skickad tid';
	static DoYouReallyWantToRestoreRiskParameterFromArchive = '-';
	static UserIsActiveInMobile = 'Användarkontot är aktivt i mobilapplikationen.';
	static LanguageEnglish = 'engelska';
	static CopyOrMoveFolderParameter = 'Kopiera eller flytta mapp \'{0}\'';
	static SelectReportTemplate = '-';
	static WhistleBlowDataInfo = 'Undvik att inkludera onödiga personuppgifter eller känslig information i rapportens detaljer eller meddelanden. Ange namn på personer endast om det är nödvändigt för att lösa ärendet.';
	static NewRiskMustBeSavedBeforeAttachmentsCanBeAdded = '-';
	static CalendarTaskCategoryCodeIsAlreadyInUse = 'Kategorinamnet används redan!';
	static SavingRecordFurtherEducationParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara utbildning \'{0}\'! Fel: \'{1}\'';
	static SavingRecordUserTransferredPropertyParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara den överförda egenskapen \'{0}\', eftersom data i den överförda egenskapen har ändrats samtidigt av en annan användare!';
	static UserFurtherEducationArhiveExpiredDurationInMonths = '-';
	static ListType = 'Listtyp';
	static ApplicationTempPathParameterNotFound = 'Tillämpningsmappen \'{0}\' hittades inte!';
	static Description = 'Beskrivning';
	static Interval = 'Intervall';
	static FilterCondition = 'Filtertillstånd';
	static KeywordsAndCondition = 'Alla valda nyckelord';
	static SelectInstantMessageChannelUser = 'Välj deltagare';
	static FiltersStandard = 'Standardfilter';
	static TaskRemainderCheckingAndNotificationFinishedInParameterSeconds = '-';
	static AddRiskAssessment = '-';
	static DeletingFileFilterParameterWasSuccessful = 'Filfiltret \'{0}\' har tagits bort!';
	static GroupByMonth = 'Gruppera efter månad';
	static RiskProcessName = '-';
	static NotApproved = 'Ej godkänd';
	static Competencies = 'Kompetenser';
	static TaskReport = '-';
	static RestoringOpportunityParameterFromArchiveWasSuccessful = '-';
	static DatabaseCheckingStarted = 'Databaskontroll startade';
	static FamiliarizationStartDateDateEnd = 'Bekantskap Startdatum - Slut';
	static NewPrint = 'Nytt utskrift';
	static SavingOneTimePasswordWasNotSuccessfulErrorParameter = 'Det gick inte att spara engångslösenordet! Fel: \'{0}\'';
	static FamiliarizationEndDate = 'Slutdatum för bekantskap';
	static RecordFurtherEducationParameterIsInUseInParameterRecordUsersAndCannotBeDeleted = 'Utbildning \'{0}\' används i {1} användarposter och kan inte tas bort!';
	static ContentFiltering = 'Innehållsfiltrering';
	static TaskTypes = '-';
	static ToDo = 'Saker att göra';
	static DeletingKeywordsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort sökorden "{0}", eftersom data i sökord har ändrats samtidigt av en annan användare!';
	static DisconnectFromMicrosoftAccount = '-';
	static MicrosoftSignInGuide = 'Microsofts inloggningsguide';
	static MoveToTrashBin = 'Flytta till papperskorgen';
	static ChartValueField = '-';
	static RecordUserFurtherEducationsPieChartEducationName = '-';
	static EventIsNotApprovedByUser = 'Användaren har inte godkänt händelsen';
	static KeywordCodeIsAlreadyInUse = 'Nyckelordskoden används redan!';
	static AddLogisticVoucherCustomerPaymentSetting = 'Lägg till betalningsinställning';
	static EventTypeTitle = 'Incidentidentifieringskategori 1';
	static EmailsSentSuccessfully = 'E-postmeddelanden har skickats!';
	static FormTaskReference = '-';
	static DeletingFileFilterParameterWasNotSuccessfulUsedInParameterFolders = 'Det gick inte att ta bort filfiltret "{0}", eftersom filfiltret används i mappen {1}!';
	static FormRowPrint = 'Radutskrift';
	static AddChildEventTypeB = 'Lägg till underkategori 2';
	static AddCommentsToEvent = 'Lägg till kommentar genom att trycka på plusknappen.';
	static RemoveEventType = 'Ta bort kategori 1';
	static ShowSchema = 'Visa schema';
	static Edit = 'Redigera';
	static WhistleBlowMessageHasNotBeenSentCloseConfirmation = 'Ett oavslutat meddelande har inte skickats ännu. Vill du stänga vyn?';
	static RiskCategoryMustBeDefined = '-';
	static MessageTitleMustBeDefined = 'Meddelandets titel till datum måste definieras!';
	static ValidityEndDate = 'Slutdatum för giltighet';
	static DocumentParameterOverwriteConfirmation = 'Filen \'{0}\' finns redan i mappen. Vill du skriva över den här filen?';
	static CalendarTaskSeries = 'Serie';
	static WhistleBlowSourceOral = 'Oral';
	static EditableDocumentCodeMustBeDefined = 'Dokumentnamn måste definieras!';
	static TaskDefaultStatesInstruction = '-';
	static DocumentZipFileName = 'Dokument_{0:åååå-MM-ddHH-mm}.zip';
	static Chart = '-';
	static FormFontSize = 'Textstorlek';
	static FileSynchronizationToDatabaseStarted = 'Filsystemsynkronisering med databas startade';
	static Contents = 'Innehåll';
	static PaymentVoucherCounter = 'Betalningskupongräknare';
	static DeletingReportParameterWasSuccessful = '-';
	static PartiallyWorks = '-';
	static DeletingRiskParameterWasNotSuccessfulErrorParameter = '-';
	static DeletingRecordUserTransferredPropertiesParameterWasSuccessful = 'Överförda egenskaper "{0}" har tagits bort!';
	static RiskProcesses = '-';
	static ExternalSystemCompanyCodeMustBeDefined = 'Företagskod i externt system måste definieras!';
	static QrCodeAuthenticationTimeoutHour = '1 timme';
	static RemovingRecordUserFamiliarizationHandlersWasSuccessful = 'Godkännare har tagits bort!';
	static SelectSubject = 'Välj ämne';
	static RecordUserFurtherEducationsPieChartName = '-';
	static Familiarization = 'Bekantskap';
	static WhistleBlowChannelMustHaveAtLeastOneAdministrator = 'Whistle blow-kanal måste ha minst en administratör!';
	static FileChangesCheckingAndEmailingStarted = 'Filändringskontroll och e-post har börjat';
	static TransferToChannel = 'Flytta till chatten';
	static NewCompanyInformation = 'Nytt företag';
	static Invited = 'Inbjudna';
	static ContactPerson = 'Kontaktperson';
	static ActionsAndRootCause = 'Åtgärder och rotorsak';
	static Descending = 'Nedåtgående';
	static ExpiresInParameterMonths = 'Går ut om {0} månader';
	static RiskModuleModuleInfoRiskTemplatesNotFound = '-';
	static FormBuilder = 'Formverktyg';
	static UserRecordsDashboard = 'Resursinstrumentpanel';
	static AddEmployments = 'Lägg till anställningar';
	static Scope = 'Omfattning';
	static InstantMessageParameterNotFound = 'Snabbmeddelandet \'{0}\' hittades inte!';
	static LogCleaning = 'Rensa logg';
	static DoYouReallyWantToRemoveSharedDocumentTemplateParameter = 'Vill du verkligen ta bort den delade dokumentmall \'{0}\'?';
	static DeletingCompanyParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort företaget \'{0}\' eftersom data i företaget har ändrats samtidigt av en annan användare!';
	static SavingWhistleBlowWasSuccessful = 'Whistle blow-rapporten har sparats!';
	static FormulaCbrt = 'Kubikrot';
	static SharedReportAllCompanies = 'Delas med alla företag';
	static ExpiredFamiliarizations = 'Utgångna bekantskaper';
	static VoucherInOutReportSavePath = 'Verifikationssammanfattning Skriv ut Spara sökväg';
	static RemovingEventHandlersWasSuccessful = 'Hanterare har tagits bort!';
	static AddRecordUserToUserAccount = 'Lägg till användarpost till befintligt användarkonto';
	static WelcomeToUseEsalkkuSystem = 'Välkommen att använda eSalkku! Det första steget är att ange ditt lösenord. Ditt användarnamn inkluderades i e-postinbjudan.';
	static ReminderMinutesBefore = 'minuter innan';
	static CalendarTaskRepetitionRepeatIntervalPrefix = 'Återkommer varje';
	static JobLineDataIsEmpty = 'Arbetslinjedata saknas!';
	static ModifiedBy = 'Modifierad av';
	static DeletingRecordFurtherEducationGroupParameterWasSuccessful = 'Utbildningsgruppen \'{0}\' har tagits bort!';
	static SavingRecordEmploymentParameterWasSuccessful = 'Anställningen \'{0}\' har sparats!';
	static TaskDefaultStates = '-';
	static LockedEventParameterCannotBeSaved = 'Incidenten \'{0}\' har låsts till en annan användare och den kan inte sparas!';
	static SavingUnitPermissionsWasSuccessful = 'Enhetsbehörigheterna har sparats!';
	static RemoveDocumentTemplate = 'Ta bort dokumentmall';
	static AddReport = '-';
	static PayeeUsersCanLogInToTheSystem = 'Företagsanvändare kan logga in i systemet';
	static IndefinitelyNoLocalization = 'Obegränsat';
	static UserInformation = 'Användarkonto';
	static UnlockingEventParameterWasNotSuccessful = 'Det gick inte att låsa upp incidenten \'{0}\'!';
	static Approvers = 'Godkännare';
	static Actions = 'Handlingar';
	static DeletingUserGroupsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort användargrupperna \'{0}\'! Fel: \'{1}\'';
	static Logo = 'Logotyp';
	static EventTypesMustBeDefinedBeforeAddingEvents = 'Kategori 1 måste definieras innan incidenter läggs till!';
	static AccessRightWrite_Task_C = '-';
	static WhistleBlowStatisticsReceivedRecords = 'Fick rapporter';
	static SavingEditableDocumentParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara dokumentet \'{0}\'! Fel: \'{1}\'';
	static NotifiedPersons = 'Aviseringar';
	static AddRisk = '-';
	static AddQualifications = 'Lägg till kvalifikationer';
	static QrCodeLoginInProgress = 'Inloggning med QR-kod pågår...';
	static AllInstantMessageUsersHaveReadMessage = 'Alla mottagare har läst ditt meddelande';
	static ShowArchived = 'Visa arkiverad';
	static AccessRightReadWhistleBlow = '-';
	static EventTypeCostsReportBarChartDirectCostsByCategoryName = '-';
	static ShowOnMap = 'Visa på kartan';
	static UserCodeClaimNotFound = 'Användarens anspråkskod hittades inte!';
	static CopyingFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att kopiera mappen \'{0}\' till mappen \'{1}\' i filsystemet! Fel: \'{2}\'';
	static RemoveQualification = 'Ta bort kvalifikation';
	static LanguageNonLocalEnglish = 'English';
	static AddWhistleBlowChannelAdminParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till administratören \'{0}\'! Fel: \'{1}\'';
	static FamiliarizationStartDateStart = 'Bekantskap Startdatum - Start';
	static CompanyRole = 'Företagsroll';
	static FormDropdown = 'Rullgardinslista';
	static Title = 'Titel';
	static AssessmentDateMustBeDefined = '-';
	static Ends = 'Slutar';
	static RiskCategories = '-';
	static WhistleBlowNonAnonymousReport = 'Avsändarinformation ingår i rapporten';
	static Payee = 'Betalningsmottagare';
	static RecordUserQualificationParameterNotFound = 'Användarpostens kvalificeringspost \'{0}\' hittades inte!';
	static DeletingWhistleBlowCategoriesParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kategorierna "{0}"! Fel: \'{1}\'';
	static CostCentreNumber = 'Kostnadsställenummer';
	static FormulaSubtraction = 'Subtraktion';
	static AddTransferredProperties = 'Lägg till överförda egenskaper';
	static StartDate = 'Synlig från';
	static DeletingInstantMessageChannelWasSuccessful = 'Chatten har tagits bort!';
	static DeletingPartnersParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort partner \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static SavingCompanyGroupParameterWasSuccessful = 'Företagsgruppen \'{0}\' har sparats!';
	static DeletingDocumentTemplateParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort dokumentmallen \'{0}\'! Fel: \'{1}\'';
	static AddEvent = 'Lägg till incident';
	static DoYouReallyWantToRestoreTaskParameterFromArchive = '-';
	static ArchivingRecordUserFamiliarizationsWasSuccessful = 'Bekantskaper arkiverade framgångsrikt!';
	static FormOtherInputs = 'Andra ingångar';
	static SavingOneTimePasswordWasNotSuccessfulConcurrencyError = 'Det gick inte att spara engångslösenordet eftersom data i engångslösenordet har ändrats samtidigt av en annan användare!';
	static ApprovedEvent = 'Godkände Incidenten';
	static ApprovalJustificationMustBeDefined = '-';
	static NewRecordUserMustBeSavedBeforeRowsCanBeAdded = 'Ny användarpost måste sparas innan rader kan läggas till!';
	static ResultGrouping = 'Resultatgruppering';
	static LogLine = 'Logglinje';
	static SavingRecordUserPartnerParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara resurspartnern \'{0}\' eftersom data i resurspartnern har ändrats samtidigt av en annan användare!';
	static DeletingInstantMessageWasSuccessful = 'Snabbmeddelandet har tagits bort!';
	static EditDefaultTaskType = '-';
	static SelectImageFile = 'Välj bildfil!';
	static SharedRiskTemplates = '-';
	static SavingEventTypeBParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara kategori 2 \'{0}\'! Fel: \'{1}\'';
	static Identification = 'Identifiering';
	static CompanyTaskTypesInstruction = '-';
	static DoYouReallyWantToRemoveUserGroupParameter = 'Vill du verkligen ta bort användargruppen \'{0}\'?';
	static Remainders = 'Rester';
	static DeletingRiskStakeholderParameterWasNotSuccessfulConcurrencyError = '-';
	static LockedDocumentParameterCannotBeMoved = 'Det låsta dokumentet \'{0}\' kan inte flyttas!';
	static AddTaskType = '-';
	static SavingRiskSettingWasSuccessful = '-';
	static LanguageNonLocalFinnish = 'Suomi';
	static DeletingTaskTypeParameterWasNotSuccessfulConcurrencyError = '-';
	static ChangedObserverAction = 'Ändrad händelseobservatörsåtgärd';
	static SelectCompanyGroupOrCompany = 'Välj Företagsgrupp eller Företag';
	static DeletingRiskCategoryParameterWasNotSuccessfulErrorParameter = '-';
	static AddAppReport = '-';
	static SavingWhistleBlowWasNotSuccessfulErrorParameter = 'Misslyckades med att spara whistle blow rapport! Fel: \'{0}\'';
	static UserReport = 'Användarens rapport';
	static RemovePartner = 'Ta bort partner';
	static SelectTaskInListToSeeThePreview = '-';
	static SetUnitPermissions = 'Ställ in enhetsbehörigheter';
	static NoEventsToShow = 'Inga incidenter att visa!';
	static UserRecordStatisticsExpiringInSixMonthsFurtherEducations = 'Utbildningar som löper ut om sex månader';
	static EditFamiliarization = 'Redigera bekantskap';
	static DoYouReallyWantToRemoveSelectedUserGroups = '-';
	static DeletingRiskStandardParameterWasNotSuccessfulErrorParameter = '-';
	static NewRecordUserMustBeSavedBeforeEmploymentsCanBeAdded = 'Ny användarpost måste sparas innan anställningar kan läggas till!';
	static SharedFilter = 'Delat filter';
	static NextOfKin = 'Närmast anhörig';
	static VersionProperties = 'Versionsegenskaper';
	static AddUserGroupParameterWasSuccessful = 'Användargruppen \'{0}\' har lagts till!';
	static AddRemainder = 'Lägg till resten';
	static TaskMustBeSavedBeforeNewDataRowsCanBeAdded = '-';
	static DeletingEventTypeBParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kategori 2 \'{0}\', eftersom data i kategori 2 har ändrats samtidigt av en annan användare!';
	static SavingRiskParameterWasNotSuccessfulErrorParameter = '-';
	static NoRisksToShow = '-';
	static CalendarTaskRepetitionCountSuffix = 'uppspelning';
	static EventTypeCostsReportTableDirectCostsByTimeName = '-';
	static DeletingUsersParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort användarkonton "{0}", eftersom data har ändrats samtidigt av en annan användare!';
	static SearchStartDate = 'Start datum';
	static DeletingUserGroupUsersOfCompanyParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort användargruppsanslutningar relaterade till företaget \'{0}\'! Fel: \'{1}\'';
	static AccessRightWrite_AppReportDescription_A = '-';
	static NoMessagesToShow = 'Inga meddelanden att visa!';
	static CompanyNameMustBeDefined = 'Företagets namn måste anges!';
	static RiskIsModifiedAfterItWasPublished = '-';
	static ReferenceNumberPrefix = 'Referensnummerprefix';
	static CopyingFolderDirectoryItemParameterToFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att kopiera mappen \'{0}\' till mappen \'{1}\'! Fel: \'{2}\'';
	static ReadReceipts = 'Läsa kvitton';
	static InstantMessageChannelOneUser = 'Chatt';
	static DeletingEventTypeBParameterWasSuccessful = 'Kategori 2 \'{0}\' har tagits bort!';
	static WhistleBlowStatisticsRecordCount = 'Aktiva rapporter';
	static SavingCalendarTaskParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara händelsen \'{0}\', eftersom uppgiften har ändrats samtidigt av en annan användare!';
	static ClearSubUnitDefaultHandlers = 'Rensa underenhets standardhanterare';
	static SaveDraft = 'Spara utkast';
	static AccessRightWrite_TaskDescription = '-';
	static RiskContents = '-';
	static OpportunityDescriptionPlaceholder = '-';
	static AllEventHandlersHaveReadMessage = 'Alla incidenthanterare har läst din kommentar';
	static DoYouReallyWantToRemoveTaskStateParameter = '-';
	static LockedReportParameterCannotBeDeleted = '-';
	static DoYouReallyWantToRemoveSelectedUsers = 'Vill du verkligen ta bort valda användare?';
	static SelectChart = '-';
	static RestoringTaskParameterFromArchiveWasNotSuccessfulConcurrencyError = '-';
	static DefaultRiskCategories = '-';
	static DeletingWhistleBlowCategoriesParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kategorierna "{0}" eftersom data i kategorierna för visselslag har ändrats samtidigt av en annan användare!';
	static AddInstantMessageUserParameterWasSuccessful = 'Deltagare \'{0}\' har lagts till!';
	static WhistleBlowNotFound = 'Visslingsrapport hittades inte!';
	static RemoveDefaultFurtherEducation = 'Ta bort standard utbildning';
	static TaskChartValueFieldCalculationTypeMin = '-';
	static DeletingUserGroupsParameterWasSuccessful = 'Användargrupperna \'{0}\' har tagits bort!';
	static SelectComponentInFormToSeeComponentProperties = 'Välj en komponent från formuläret för att se dess egenskaper';
	static Channels = 'Chattar';
	static TaskDefaultPriorities = '-';
	static AccessRightRead_EventDescription = '-';
	static DocumentPublished = 'Publicerad av';
	static Phone = 'Telefon';
	static DeletingTaskTypeParameterWasSuccessful = '-';
	static EventTypeBTitle = 'Incidentidentifiering Kategori 2';
	static DeletingRiskStakeholderParameterWasSuccessful = '-';
	static RiskTemplates = '-';
	static SavingRiskAssessmentParameterWasNotSuccessfulErrorParameter = '-';
	static EmailSendDate = 'E-post skickat datum';
	static EventSenderIsPartnerCompany = 'Incidentavsändaren är partnerföretag';
	static LogEventType = 'Typ';
	static NotificationsQueuedSuccessfully = 'Avisering planerad att skickas!';
	static RiskTreatmentStateNotNeeded = '-';
	static InviteInstantMessageChannelUser = 'Bjud in deltagare';
	static LockedTaskParameterCannotBeArchived = '-';
	static ServiceFeePercent = 'Serviceavgift (%)';
	static RiskReportForEmployees = '-';
	static OneTimeForm = 'Engångsform';
	static RecordUserLogEntryTypeSave = 'Modifiering';
	static NotSet = 'Inte inställd';
	static ReportDialogInfoText = 'Rapporten kommer att baseras på sökta/filtrerade rader.';
	static DefaultFurtherEducations = 'Standard utbildningar';
	static ExpiresInYear = 'Går ut om år';
	static EmptyingReportTrashBinWasNotSuccessfulErrorParameter = '-';
	static ReadMode = 'Läsläge';
	static DoYouReallyWantToRestoreAppReportParameterFromArchive = '-';
	static AddAttachementsMobile = 'Lägg till bilaga genom att trycka på plusknapparna.';
	static RowsIncludedInPrint = '-';
	static Users = 'Användarkonton';
	static RenewPersonalizationWithUser = 'Ersätt anpassning med valt användarkonto';
	static LineChart = '-';
	static UploadDocument = 'Ladda upp fil';
	static DeletingRecordQualificationParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kvalifikationen \'{0}\' eftersom data i kvalificeringen har ändrats samtidigt av en annan användare!';
	static DeletingRiskStakeholdersParameterWasSuccessful = '-';
	static WhistleBlowGuide = 'Guide för rapportering';
	static OpportunityBenefitPlaceholder = '-';
	static WhistleBlowAnonymityNonAnonymous = 'Icke anonym';
	static Attention = '-';
	static RiskTraceabilityMedium = '-';
	static SavingInstantMessageChannelParameterWasSuccessful = 'Chatten "{0}" har sparats!';
	static PasswordHasBeenSetSuccessfully = 'Lösenordet har ställts in. Flytta till inloggningssidan.';
	static ProcessingFolderParameter = '* Bearbetar mappen \'{0}\'...';
	static SavingEventTypeCParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara kategori 3 \'{0}\'! Fel: \'{1}\'';
	static PrintParameterNotFound = 'Det gick inte att hitta utskriften \'{0}\'!';
	static BankBICCode = 'Bankens BIC-kod';
	static CurrentTopics = 'Aktuella ämnen';
	static DeletingRiskTemplateParameterWasSuccessful = '-';
	static List = 'Lista';
	static AccessRightRead_DocumentDescription = '-';
	static ExitingInstantMessageChannelWasNotSuccessfulErrorParameter = 'Det gick inte att avsluta chatten! Fel: \'{0}\'';
	static DeletingTaskPriorityParameterWasNotSuccessfulErrorParameter = '-';
	static DeletingUsersParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort användarkonton \'{0}\'! Fel: \'{1}\'';
	static AttachmentIsEmpty = 'Bilaga \'{0}\' är tom!';
	static SearchDocuments = 'Sök i dokument';
	static AddCompanies = 'Lägg till företag';
	static StudyWeeks = 'Studieveckor';
	static Choose = 'Välja';
	static DeletingRiskTemplateParameterWasNotSuccessfulConcurrencyError = '-';
	static RestoringRiskParameterFromTrashBinWasNotSuccessfulErrorParameter = '-';
	static WhistleBlowStatisticsAnonymousRecords = 'Anonyma rapporter';
	static ModifiedDescription = 'Ändrad beskrivning';
	static Base64EncodedBinaryData = '-';
	static Filters = 'Filter';
	static EventTypesReportTableByCategoryName = '-';
	static DocumentModuleInfoPublishVersionHistorySize = 'Antalet tidigare publicerade versioner behålls när dokumentet publiceras.';
	static RiskAssesmentFrequency = '-';
	static AddLogisticVoucherTransportCompany = 'Lägg till transportföretag';
	static DefaultRiskStandards = '-';
	static FileParameterNotFound = 'Filen \'{0}\' hittades inte!';
	static DeletingCompanyGroupsParameterWasSuccessful = 'Företagsgrupperna \'{0}\' har tagits bort!';
	static PreviewWeb = 'Förhandsgranska (webb)';
	static LockedRiskParameterCannotBeMovedToTrashBin = '-';
	static DeletingMessageTypeParameterWasNotSuccessfulUsedInParameterMessages = 'Det gick inte att ta bort meddelandetypen \'{0}\', eftersom meddelandetypen används i {1} meddelanden!';
	static CompanyCodeClaimNotFound = 'Användaranspråket "företagskod" hittades inte!';
	static RiskApprovalNotApproved = '-';
	static SavingTaskTypeParameterWasSuccessful = '-';
	static PostalAddress = 'Gatuadress';
	static OldPassword = 'Gammalt lösenord';
	static TaskModuleProperties = '-';
	static UserRecordStatisticsUserAccountConnectedCards = 'Användarkonto anslutna kort';
	static SearchCurrentTopics = 'Sök efter aktuella ämnen';
	static ArchivingTaskParameterWasNotSuccessfulConcurrencyError = '-';
	static RemoveCompany = 'Ta bort företag';
	static AddDefaultTaskState = '-';
	static OpportunityDescriptionMustBeDefined = '-';
	static TaskHandlerParameterNotFound = '-';
	static CompanyGroup = 'Företagsgrupp';
	static AccountNumberTkbInCredit = 'Försäljningskonto';
	static SetPermissions = 'Ange behörigheter';
	static ContentVersion = 'Innehållsversion';
	static Identifier = 'Identifierare';
	static PageName = 'Sidnamn';
	static FieldParameterMaxLengthIsParameter = 'Fältet \'{0}\' maxlängd är {0} tecken!';
	static Partner = 'Partner';
	static MyReports = 'Användarens rapporter';
	static SavingCalendarTaskCategoryParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara kategori \'{0}\', eftersom data i kategorin har ändrats samtidigt av en annan användare!';
	static DeletingRecordUserPartnerParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort resurspartner \'{0}\'! Fel: \'{1}\'';
	static PasswordConfirmationDoesNotMatchPassword = 'Lösenordet matchar inte bekräftelselösenordet!';
	static CompanyGroupNameMustBeDefined = 'Företagsgruppens namn måste anges!';
	static EditDefaultHandlers = 'Redigera standardhanterare';
	static CalendarTaskRemoveSeries = 'Ta bort serien';
	static Receiver = 'Mottagare';
	static Sorting = 'Sortering';
	static LogSizeInDays = 'Loggstorlek i dagar (0 = ingen gräns)';
	static UnpublishingOpportunityParameterWasNotSuccessfulConcurrencyError = '-';
	static RemovingTaskTypeUnitsWasSuccessful = '-';
	static AllJobTitles = 'Alla jobbtitlar';
	static EventPartnerIsAlreadyInDefined = 'Incidentpartner är redan definierad!';
	static ApprovalJustification = '-';
	static SavingRecordFamiliarizationParameterWasSuccessful = 'Bekantskap \'{0}\' har sparats!';
	static PublishingReportParameterWasNotSuccessfulConcurrencyError = '-';
	static GeneralInfo = 'Allmän';
	static RiskTreatmentStateLate = '-';
	static EventApprovalWasSuccessful = 'Incidenten godkänd!';
	static ProcessingTimeDays = 'Behandlingstid (d)';
	static SavingRiskStandardParameterWasNotSuccessfulConcurrencyError = '-';
	static ArchivingWhistleBlowsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att arkivera rapporterna "{0}"! Fel: \'{1}\'';
	static SelectTaskType = '-';
	static DeletingTaskDataRowWasNotSuccessfulConcurrencyError = '-';
	static DoYouReallyWantToArchiveOpportunityParameter = '-';
	static SavingEventTypeParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara kategori 1 \'{0}\'! Fel: \'{1}\'';
	static State = 'stat';
	static ParameterIsNotValidAccountIBANNumber = '\'{0}\' är inte ett giltigt bankkonto IBAN-nummer!';
	static WhistleBlowPasswordConfirmed = 'Whistle blow rapport har skickats. Du kan kontrollera statusen för din rapport genom att klicka på knappen "Följ rapport" på huvudsidan.';
	static DoYouReallyWantToRestoreAppReportParameterFromATrashBin = '-';
	static FormulaMax = 'Maximal';
	static SavingRecordUserQualificationParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara kvalifikationen \'{0}\'! Fel: \'{1}\'';
	static WhistleBlowResolutionCanceled = 'Inställt';
	static AddRiskFromTemplate = '-';
	static BasicInformation = 'Allmän';
	static MaximumSizeOfSingleAttachment = 'Maximal storlek på en bilaga är {0} MB!';
	static AddingAttachmentParameterWasSuccessful = 'Bilaga \'{0}\' har lagts till!';
	static WhistleBlowReportIHaveSavedThePassword = 'Jag har lagrat lösenordet i den säkra lagringen så att jag kan använda det för att kontrollera status för min rapport.';
	static MicrosoftAccount = '-';
	static AccessRightWrite_CalendarTaskDescription = '-';
	static SavingRiskTemplateParameterWasNotSuccessfulErrorParameter = '-';
	static AddingTaskHandlersWasSuccessful = '-';
	static FileParameterAlreadyExistsInFileSystem = 'Filen \'{0}\' finns redan i filsystemet!';
	static DoYouWantToPublishEvent = 'Vill du publicera händelsen?';
	static AddingAttachmentParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till bilagan \'{0}\'! Fel: \'{1}\'';
	static FormMaxTextLength = 'Maximal textlängd';
	static UserRecordStatisticsActiveCards = 'Aktiva kort';
	static NoCalendarTasksToShow = 'Inga händelser att visa';
	static WhistleBlowDescriptionMustBeDefined = '-';
	static AddingReportTemplateUnitsWasNotSuccessfulErrorParameter = '-';
	static TransferredPropertyType = 'Överlåten egenskapstyp';
	static Employment = 'Sysselsättning';
	static Files = 'Filer';
	static AddUsersParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till användarkonton "{0}", eftersom data har ändrats samtidigt av en annan användare!';
	static Close = 'Stänga';
	static DeletingTaskStatesParameterWasNotSuccessfulErrorParameter = '-';
	static DeletingRecordUserEmploymentParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort anställningen \'{0}\', eftersom data i anställningen har ändrats samtidigt av en annan användare!';
	static AllCalendarTaskUsers = 'Alla kalenderanvändare';
	static FormExpressionEditor = 'Uttrycksredigerare';
	static DoYouReallyWantToRemoveUserParameter = 'Vill du verkligen ta bort användaren \'{0}\'?';
	static DeletingRiskCategoriesParameterWasSuccessful = '-';
	static ExpireTime = 'Utgångstid';
	static SavingEventUrgencyClassParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara brådskande klass \'{0}\', eftersom data i brådskande klassen har ändrats samtidigt av en annan användare!';
	static FileParameterIsNotOpenXmlWorkbook = 'File \'{0}\' is not open xml workbook (.xlsx tai .xlsm)!';
	static ChartProperties = 'Diagramegenskaper';
	static RestoringOpportunityParameterFromArchiveWasNotSuccessfulErrorParameter = '-';
	static EmptyingTaskTrashBinWasNotSuccessfulConcurrencyError = '-';
	static DoYouReallyWantToRemoveSelectedApprovers = 'Vill du verkligen ta bort valda godkännare?';
	static DeletingCompaniesParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort företag \'{0}\'! Fel: \'{1}\'';
	static RecordUserReport = 'Användarpostrapport';
	static LogIn = 'Logga in';
	static UserGroupsMustBeDefined = 'Användargrupper måste definieras!';
	static SystemAdminMessage = 'Meddelande till alla systemanvändare';
	static GroupByPerson = 'Gruppera efter person';
	static DefaultEventHandlers = 'Standardincidenthanterare';
	static SavingRecordUserQualificationParameterWasSuccessful = 'Kvalifikationen \'{0}\' har sparats!';
	static FileStorageQuotaGB = 'Fillagringskvot (GB)';
	static SavingUnitsWasNotSuccessfulConcurrencyError = 'Det gick inte att spara enheter eftersom data i enheter har ändrats samtidigt av en annan användare!';
	static DeletingRiskProcessParameterWasNotSuccessfulErrorParameter = '-';
	static AuthorizationLevelSystemAdmin = 'Systemadministratör';
	static DeletingTaskPriorityParameterWasSuccessful = '-';
	static DeletingTaskParameterWasNotSuccessfulErrorParameter = '-';
	static AddTask = '-';
	static SavingImagesWasSuccessful = 'Bilderna har sparats!';
	static Parameters = 'Parametrar';
	static TasksFound = '-';
	static ModifiedActions = 'Ändrade åtgärder';
	static MessageMustBeSavedBeforeAttachmentsCanBeAdded = 'Meddelandet måste sparas innan bilagor kan läggas till!';
	static EmailAddressParameterIsInvalid = 'E-postadressen "{0}" är inte giltig!';
	static EditRemainder = 'Redigera resten';
	static SavingMessageTypeParameterWasSuccessful = 'Meddelandetypen \'{0}\' har sparats!';
	static SavingEventParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara incidenten \'{0}\' eftersom data i incidenten har ändrats samtidigt av en annan användare!';
	static RequestParameterNotFound = 'Begäran \'{0}\' hittades inte!';
	static Filtered = '-';
	static Handlers = 'Hanterare';
	static WhistleBlowSeverityLow = 'Låg';
	static AddingRecordUserSalaryRowsWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till lönerader! Fel: \'{0}\'';
	static SavingWhistleBlowChannelParameterWasSuccessful = 'Whistle blow-kanalen \'{0}\' har sparats!';
	static EmploymentType = 'Anställnings typ';
	static EventTypeMustBeDefined = 'Kategori 1 måste definieras!';
	static EmployeeTypeMustBeDefined = 'Anställningsform måste definieras!';
	static WhistleBlowFollowReport = 'Följ Rapport';
	static ControlEffiencyMustBeDefined = '-';
	static FormulaExponent = 'Exponent';
	static DoYouReallyWantToRemoveChartPanelParameter = 'Vill du verkligen ta bort diagrammet \'{0}\'?';
	static DefaultEventHandlerParameterNotFound = 'Det gick inte att hitta standardincidenthanteraren \'{0}\'!';
	static EmptyTaskTrashBinConfirmation = '-';
	static SystemSettings = 'Systeminställningar';
	static LockingTaskParameterWasNotSuccessful = '-';
	static NoInstantMessageChannelsToShow = 'Inga chattar att visa!';
	static FormExpressionMustBeDefined = 'Ekvationen måste definieras!';
	static SavingUserParameterParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara användaralternativet \'{0}\'! Fel: \'{1}\'';
	static RiskControls = '-';
	static ReportsModified = 'Favoritrapporter';
	static Hours = 'timmar';
	static PasswordMustContainUppercaseChar = 'Lösenordet måste innehålla versaler!';
	static AddingEventHandlersWasSuccessful = 'Hanterare har lagts till!';
	static WhistleBlowUrl = 'Whistle Blow Channel webbadress';
	static SavingTaskStateParameterWasNotSuccessfulErrorParameter = '-';
	static DocumentModuleInfoFileFilters = 'Dokumentfilfilter används för att begränsa synligheten för filer i mappen. Synligheten är begränsad för användare som har läsåtkomst till mappen.';
	static SharedReportCompany = 'Delas med företaget';
	static WhistleBlowCategories = 'Whistle Blow kategorier';
	static TheSystemDoesNotSupportYourWebBrowserUpdateToLatestBrowserVersion = 'Detta system stöder inte din webbläsare. Uppdatera din webbläsare till senaste versionen.';
	static DocumentHasBeenModifiedAfterItWasPublished = '-';
	static NewComment = 'Ny kommentar';
	static AccessRightWrite_InstantMessageDescription = '-';
	static DoYouReallyWantToRemoveFileFilterParameter = 'Vill du verkligen ta bort filfiltret \'{0}\'?';
	static AppReportTemplateModuleInfoCompanyReportTemplatesNotFound = '-';
	static WhistleBlowInformantHasReadMessage = 'Informatören i en visselblåsningsrapport har läst ditt meddelande';
	static AccessRightNone_LogDescription = '-';
	static Opportunities = '-';
	static WageGroup = 'Lönegrupp';
	static ValidPlural = 'Giltig';
	static DeletingTaskParameterWasSuccessful = '-';
	static ProjectName = 'Projektnamn';
	static ApproveEventHandlerConfirmation2 = 'Vill du verkligen godkänna incidenten?';
	static RemoveInstantMessageChannelUser = 'Ta bort deltagare';
	static RemoveEventTypeB = 'Ta bort kategori 2';
	static InTrashBin = '-';
	static ErrorUserChangeWouldLeadToInvalidDefaultEventHandlers = 'Användarändringar kommer att leda till situationer där vissa standardincidenthanterare eller meddelade personer inte har behörighet att hantera incidenter med enheter. Ändringar som påverkar standardincidenthanterare eller meddelade personer kan endast göras i dialogrutan "Incidentegenskaper"!';
	static DoYouReallyWantToRemoveCalendarTaskParameter = 'Vill du verkligen ta bort händelsen \'{0}\'?';
	static RelatedToDatabaseRecordType = 'Relaterat till';
	static Selected = 'Vald';
	static RestoringReportParameterFromArchiveWasNotSuccessfulErrorParameter = '-';
	static LastNameMustBeDefined = 'Efternamn måste definieras!';
	static FileFilterCodeIsAlreadyInUse = 'Filfilterkoden används redan!';
	static DeletingDefaultEventHandlerParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort standardincidenthanteraren \'{0}\', eftersom data i standardincidenthanteraren har ändrats samtidigt av en annan användare!';
	static DeletingTaskPriorityParameterWasNotSuccessfulConcurrencyError = '-';
	static SavingJobParameterWasSuccessful = 'Jobbet \'{0}\' har sparats!';
	static Orientation = 'Orientering';
	static LastYear = 'Förra året';
	static RestoringTaskParameterFromTrashBinWasNotSuccessfulErrorParameter = '-';
	static DoYouReallyWantToRemoveSelectedTaskStates = '-';
	static Usage = 'Användande';
	static RequestPasswordChangeLinkHasBeenSentTitle = '-';
	static AddQualificationToMultipleUserRecords = 'Lägg till kvalificering till flera användarposter';
	static Qualifications = 'Kvalifikationer';
	static AddUsers = 'Lägg till användarkonton';
	static RemoveAttachment = 'Ta bort bilaga';
	static DoYouReallyWantToRemoveEventTypeCParameter = 'Vill du verkligen ta bort kategori 3 \'{0}\'?';
	static AddEventUrgencyClass = 'Lägg till brådskande klass';
	static ThisChannelHasBeenArchived = 'Den här chatten har arkiverats!';
	static RiskProcessParameterIsInUse = '-';
	static WhistleBlowReportHasBeenSaved = 'Whistle blow-rapporten har sparats';
	static AddCompanyGroupsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till företagsgrupper "{0}", eftersom data har ändrats samtidigt av en annan användare!';
	static EditLogisticVoucherCustomerPaymentSetting = 'Redigera betalningsinställning';
	static Functions = 'Funktioner';
	static PersonInCharge = '-';
	static ChangedUrgencyClass = 'Ändrad incident brådskande klass';
	static LastName = 'Efternamn';
	static CopyingFilesAndDocumentsToFolderParameterWasSuccessful = 'Filer/dokument har kopierats till mappen \'{0}\'!';
	static Undefined = '-';
	static RemoveSharedDocumentTemplate = 'Ta bort mall för delat dokument';
	static AddTaskState = '-';
	static ReportTemplate = '-';
	static ImportingTaskDataRowsWasNotSuccessfulErrorParameter = '-';
	static ApprovalAuthorityMustBeDefined = '-';
	static Landscape = 'Landskap';
	static AccessRightRead_Task_C = '-';
	static InTesting = 'I testning';
	static FormTextAlignmentRight = 'Högerjustera text';
	static SavePrint = 'Spara utskrift';
	static CalendarTaskRepetitionEndDatePrefix = 'Efter datum';
	static GroupByEducation = 'Gruppera efter utbildning';
	static SelectCompanyGroup = 'Välj Företagsgrupp';
	static ANew = 'Ny';
	static MessagePreservationTime = 'Meddelande bevarandetid';
	static EventTypeCostsReportTableIndirectCostsByCategoryName = '-';
	static AllSelected = 'Alla valda';
	static ModifyExistingSharedDocumentTemplate = 'Ändra befintlig delad dokumentmall';
	static RemoveFilter = 'Ta bort filter';
	static RestoreFromArchive = '-';
	static InstantMessageAttachmentFolderParameterNotFound = 'Programmets bifogade mappen \'{0}\' hittades inte!';
	static DocumentTemplateCodeIsAlreadyInUse = 'Dokumentmallskoden används redan!';
	static DefaultStyle = 'Standard';
	static EventSettings = 'Incidentinställningar';
	static ShowReportRowAmountInFrontPage = 'Visa rapportradbelopp på förstasidan';
	static Properties = 'Egenskaper';
	static RequestPasswordChangeLinkHasBeenSent = '-';
	static SeasonalWorker = 'Säsongsarbetare';
	static DeletingAttachmentsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort bilagorna \'{0}\'! Fel: \'{1}\'';
	static EditEventTypeBs = 'Redigera kategori 2';
	static AccessRightWriteWhistleBlow = '-';
	static DeletingWhistleBlowParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort visselblåsningsrapporten "{0}", eftersom data i visselblåsningsrapporten har ändrats samtidigt av en annan användare!';
	static RestoreTaskFromTrashBin = '-';
	static QrCodeUsers = 'QR-kod användarkonton';
	static AttachmentParameterDownloaded = 'Bilaga har laddats ner.';
	static PrintRowInformation = '-';
	static Task = '-';
	static AddCompanyTaskType = '-';
	static RiskModuleInfoRiskCategories = '-';
	static CreatingPrint = 'Skapar utskrift...';
	static SavingWhistleBlowChannelParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara kanalen \'{0}\'! Fel: \'{1}\'';
	static Sending = 'Sändning...';
	static PermissionsToCreateEventsToEventPartner = 'Tillstånd att skapa incidenter till partner';
	static UserParameterHasInvitedYouToJoinInstantMessageChannelParameter = 'Användaren \'{0}\' har bjudit in dig att gå med i chatten';
	static AuthorizationLevelNone = 'Inga rättigheter';
	static FiscalNumber = 'Skattenummer';
	static Code = 'Koda';
	static RiskLevelNegligible = '-';
	static AccessRightWrite_AppReport_A = '-';
	static Panels = 'Paneler';
	static AllDay = 'Hela dagen';
	static AccessRightWrite_InstantMessage_A = '-';
	static CurrentWorkPlaceNotAdded = 'Nuvarande arbetsplats har inte lagts till!';
	static DeletingCalendarTaskCategoryParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kategorin "{0}", eftersom data i kategorin har ändrats samtidigt av en annan användare!';
	static AccessRightWrite_Record = '-';
	static SavingSettingsWasSuccessful = 'Inställningarna har sparats!';
	static SavingDirectoryItemFolderParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara mappen \'{0}\' eftersom data i mappen har ändrats samtidigt av en annan användare!';
	static RecordFurtherEducationCodeIsAlreadyInUse = 'Utbildningens namn används redan!';
	static DeletingOneTimePasswordWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort engångslösenordet! Fel: \'{0}\'';
	static Others = 'Andra';
	static SavingUserGroupParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara användargruppen \'{0}\', eftersom data i användargruppen har ändrats samtidigt av en annan användare!';
	static ReportGenerationAborted = 'Rapportskapandet avbröts!';
	static AdminMessage = 'Meddelande till chefer';
	static MovingOpportunityParameterToTrashBinWasNotSuccessfulErrorParameter = '-';
	static DeletingInstantMessageWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort snabbmeddelandet eftersom data i snabbmeddelandet har ändrats samtidigt av en annan användare!';
	static NewCompanyGroupMustBeSavedBeforeUsersCanBeAdded = 'Ny företagsgrupp måste sparas innan företag kan läggas till!';
	static RiskApprovalApproved = '-';
	static UserParameterNotFound = 'Användaren \'{0}\' hittades inte!';
	static DocumentModuleProperties = 'Dokumentegenskaper';
	static AccessRightNone_RiskDescription = '-';
	static NotInUse = 'Används inte';
	static AddImageFromClipboard = 'Lägg till bild från urklipp';
	static SaveReport = 'Spara rapport';
	static AddEventTypeCsToEvent = '-';
	static FormTime = 'Tid (< 24 timmar)';
	static CopyingFileParameterWasNotSuccessfulErrorParameter = 'Det gick inte att kopiera filen \'{0}\' som filen \'{1}\' i filsystemet! Fel: \'{2}\'';
	static AccessRightNone_CalendarTaskDescription = '-';
	static AnyTime = 'När som helst';
	static EnterUserName = '-';
	static AddDefaultEventHandler = 'Lägg till standardincidenthanterare';
	static RenamingFileParameterWasNotSuccessfulErrorParameter = 'Det gick inte att byta namn på filen (\'{0}\' => \'{1}\') i filsystemet! Fel: \'{2}\'';
	static Salary = 'Lön';
	static DeletingEditableDocumentParameterWasSuccessful = 'Dokumentet "{0}" har tagits bort!';
	static AccessRightRead_Message_A = '-';
	static FilesParameterAreEmpty = 'Filerna \'{0}\' är tomma!';
	static SavingRecordUserParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara användarposten "{0}", eftersom användarpostens data har ändrats samtidigt av en annan användare!';
	static RiskAssessment = '-';
	static RecordBasicEducationParameterIsInUseInParameterRecordUsersAndCannotBeDeleted = 'Grundutbildning \'{0}\' används i {1} användarposter och kan inte tas bort!';
	static SavingFileFilterParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara filfiltret \'{0}\', eftersom data i filfiltret har ändrats samtidigt av en annan användare!';
	static DoYouReallyWantToUnlockEvent = 'Vill du verkligen låsa upp incidenten \'{0}\'?';
	static DoYouReallyWantToRemoveCompanyParameter = 'Vill du verkligen ta bort företaget \'{0}\'?';
	static RiskLikelihood5 = '-';
	static RiskLikelihood4 = '-';
	static FormTexts = '-';
	static RiskLikelihood2 = '-';
	static RiskLikelihood1 = '-';
	static DocumentNameIsIllegal = 'Dokumentnamn är inte tillåtet (reserverat namn)!';
	static WhistleBlowSourceOther = 'Övrig';
	static LastParameterYears = 'Senaste {0} åren';
	static DeletingKeywordParameterWasSuccessful = 'Sökordet "{0}" har tagits bort!';
	static SelectedDocumentTypes = 'Visa endast valda dokumenttyper';
	static SelectEventType = 'Välj kategori 1';
	static SavingTaskPriorityParameterWasSuccessful = '-';
	static RiskManagement = '-';
	static AddUsersParameterWasSuccessful = 'Användarkonton \'{0}\' har lagts till!';
	static SavingApplicationPermissionsWasNotSuccessfulConcurrencyError = 'Det gick inte att spara systembehörigheter eftersom data i systembehörigheter har ändrats samtidigt av en annan användare!';
	static DoYouReallyWantToExitInstantMessageChannel = 'Vill du verkligen avsluta chatten?';
	static CurrentWorkPlace = 'Nuvarande arbetsplats';
	static AddUserToUserGroup = 'Lägg till användarkonto i användargruppen';
	static FormulaSin = 'Sinus';
	static FormIntegerNumber = 'Heltal';
	static Info = 'Info';
	static ReportTemplateParameterNotFound = '-';
	static AddRow = 'Lägg till rad';
	static DeletingInstantMessageChannelWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort chatten! Fel: \'{0}\'';
	static ViewLogLine = 'Visa logglinje';
	static AddPartnersParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till partner \'{0}\'! Fel: \'{1}\'';
	static DoYouReallyWantToMoveTaskParameterToTrashBin = '-';
	static Reminders = 'Påminnelser';
	static UserIdClaimNotFound = 'Användarens anspråk \'id\' hittades inte!';
	static ReportBuilder = '-';
	static DeletingDocumentTemplatesParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort dokumentmallarna "{0}", eftersom data i dokumentmallarna har ändrats samtidigt av en annan användare!';
	static SavingEventMessageWasSuccessful = 'Kommentaren har sparats!';
	static CalendarTaskRepetitionEnd = 'Avsluta';
	static WhistleBlowChannelPageNameCodeIsAlreadyInUse = 'Visselblåsningschanel-sidans namn används redan!';
	static Remainder = 'Återstoden';
	static DeletingRecordUserTransferredPropertiesParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort överförda egenskaper "{0}", eftersom data i överförda egenskaper har ändrats samtidigt av en annan användare!';
	static LockedReportParameterCannotBeSaved = '-';
	static RiskStandardCodeIsAlreadyInUse = '-';
	static InstantMessageChannelAdministrator = 'Administratör';
	static SavingRiskCategoryParameterWasNotSuccessfulConcurrencyError = '-';
	static TaskTypeSchemaMustBeDefined = '-';
	static MovingFilesAndDocumentsToFolderParameterWasSuccessful = 'Filer/dokument har flyttats till mappen \'{0}\' framgångsrikt!';
	static UserClaimParameterNotFoundNotFound = 'Användaranspråk \'{0}\' hittades inte!';
	static EditDefaultEventType = 'Redigera standardkategori 1';
	static QrCode = 'QR-kod';
	static CustomerNumber = 'Kundnummer';
	static Browse = 'Bläddra';
	static HoursPerTrainingDay = 'Timmar per träningsdag';
	static DeletingInstantMessageUserParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort deltagaren \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static FrontPageDocuments = 'eSalkku Instruktioner';
	static WorkShift = 'Arbetsskift';
	static Uploaded = 'Uppladdad';
	static ToggleSidePanel = '-';
	static SharedReportTemplates = '-';
	static DocumentModified = 'Senast ändrad av';
	static PublishingOpportunityParameterWasSuccessful = '-';
	static RemoveEventTypeC = 'Ta bort kategori 3';
	static RecordUserExcelFamiliarization = 'Bekantskaper';
	static TaskDataRowsToBeImported = '-';
	static ChangeToReadMode = 'Byt till läsläge';
	static Previous = 'Tidigare';
	static RequestPasswordChangeMessage3 = '-knappen. E-post som innehåller information om hur du återställer ditt lösenord kommer att skickas till den e-postadress som är kopplad till ditt användarkonto.';
	static RequestPasswordChangeMessage2 = 'Skicka';
	static RequestPasswordChangeMessage1 = 'Om du har glömt ditt lösenord fyll i ditt nuvarande eSalkku-användarnamn nedan och klicka på ';
	static AddPanel = 'Lägg till panel';
	static EditSharedDocumentTemplate = 'Redigera mall för delat dokument';
	static AddEmployment = 'Lägg till anställning';
	static DocumentParameterAlreadyExists = 'Dokumentet \'{0}\' finns redan i mappen!';
	static RiskCategoryParameterHasChildNodesAndCannotBeDeleted = '-';
	static EmptyDocument = 'Tomt dokument';
	static WhistleBlowReportHasBeenSavedBottomText = 'Du måste lagra lösenordet innan du kan stänga den här sidan.';
	static FolderCannotBeMovedToItsSubFolder = 'Mapp kan inte flyttas i sin egen undermapp!';
	static DeletingUserGroupUsersOfCompanyParameterWasSuccessful = 'Användargruppsanslutningar relaterade till företaget \'{0}\' har tagits bort!';
	static PublishingOpportunityParameterWasNotSuccessfulConcurrencyError = '-';
	static AddFileOrTakePicture = 'Lägg till en fil eller ta en bild';
	static Minutes = 'Minuter';
	static RemovingRiskAssessmentHandlersWasNotSuccessfulErrorParameter = '-';
	static ReminderDaysBefore = 'dagar innan';
	static DocumentNameParameterConstainsIllegalCharacters = 'Dokumentnamnet \'{0}\' innehåller förbjudna tecken (<, >, :, ", /, \, |, ? eller *) eller slutar med förbjudna tecken (., \' \')!';
	static WhistleBlowDescriptionEditReasonDefaultValue = 'Personuppgifter som inte är nödvändiga för att hantera ärendet har tagits bort från rapporten. Borttagningen påverkar inte hanteringen av rapporten.';
	static QrCodeUserGroups = 'QR-kodanvändargrupper';
	static SendingEmail = 'Skickar e-post...';
	static AddUserGroups = 'Lägg till användargrupper';
	static RemoveRecordUserAndUser = 'Ta bort användarpost och användarkonto';
	static DeletingRecordBasicEducationParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort grundutbildningen \'{0}\', eftersom data i grundutbildningen har ändrats samtidigt av en annan användare!';
	static RecordUserModuleInfoUnits = 'Enheter kan användas för att gruppera användarposter.';
	static EventTypeCParameterNotFound = 'Kategori 3 \'{0}\' hittades inte!';
	static InUse = 'I användning';
	static TaskHandler = '-';
	static YouHaveNotSavedChangesSaveChangesBeforePublishingTaskType = '-';
	static DeletingRiskTemplatesParameterWasSuccessful = '-';
	static ScopeUnit = 'Enhet';
	static ArchivingRiskParameterWasNotSuccessfulErrorParameter = '-';
	static AccessRightNone_RecordDescription = '-';
	static RiskLevel = '-';
	static UnitParameterNotFound = 'Enheten \'{0}\' hittades inte!';
	static Invoicing = 'Fakturering';
	static SortOrder = 'Sorteringsordning';
	static CurrentCalendarYear = 'Aktuellt kalenderår';
	static FileFilterNameMustBeDefined = 'Filfilternamn måste definieras!';
	static Start = 'Start';
	static FormCalculated = 'Beräknad';
	static DocumentProperties = 'Fil-/dokumentegenskaper';
	static EventTypeBParameterNotFound = 'Kategori 2 \'{0}\' hittades inte!';
	static FolderProperties = 'Mappegenskaper';
	static Send = 'Skicka';
	static SavingMessageParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara meddelandet \'{0}\' eftersom data i meddelandet har ändrats samtidigt av en annan användare!';
	static MaximumPasswordLengthCanParameterCharacters = 'Maximal lösenordslängd kan vara {0} tecken!';
	static SavingRecordUserPartnerParameterWasSuccessful = 'Resurspartner \'{0}\' har sparats!';
	static EventTypeCostsReportPieChartDirectCostsName = '-';
	static WhistleBlowMustBeReceivedLatestAtParameter = 'Visselslagsrapport måste markeras som mottagen {0} senast!';
	static AccessRightRead_RiskDescription = '-';
	static UnpublishingRiskParameterWasSuccessful = '-';
	static FormBooleans = 'Sant/falskt';
	static DeletingRiskCategoryParameterWasNotSuccessfulConcurrencyError = '-';
	static PrivacyPolicy = 'Integritetspolicy';
	static DeletingRecordBasicEducationsParameterWasSuccessful = 'Grundutbildningen \'{0}\' har tagits bort!';
	static ActiveUserRightsCannotBeCopiedToDirectoryItemFolderParameter = 'Aktiva behörigheter kan inte kopieras till mappen \'{0}\'!';
	static NoFurtherEducationsToShow = 'Inga utbildningar att visa!';
	static EditTaskPriority = '-';
	static Permissions = 'Behörigheter';
	static FormSortField = 'Sorteringsfält';
	static RemoveRiskCategory = '-';
	static RiskTemplateUsedInAllUnits = '-';
	static MessageModuleProperties = 'Egenskaper för aktuella ämnen';
	static RiskTemplatesMustBeDefinedBeforeAddingRisks = '-';
	static RecordBasicEducationParameterNotFound = 'Grundläggande utbildning \'{0}\' hittades inte!';
	static AddWhistleBlowChannelAdminsParameterWasSuccessful = 'Administratörer "{0}" har lagts till!';
	static CalendarTaskRepetitionRepeatIntervalMonthPrefix = 'Dag';
	static InstantMessageChannelArchivingTypeRemoveChannelAtDateParameter = 'Ta bort arkiverad chatt och meddelanden på {0}';
	static FurtherEducationReports = 'Rapporter om utbildning';
	static EditableDocumentCodeIsAlreadyInUse = 'Dokumentnamnet används redan!';
	static SearchEndDate = 'Slutdatum';
	static FormulaDateAndTimeDiffInTimeSpan = 'Tidsskillnad i timmar';
	static EventsDashboard = 'Instrumentpanel för evenemang';
	static AssesmentPeriod = '-';
	static DeletingAttachmentParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort bilagan \'{0}\', eftersom data har ändrats samtidigt av en annan användare!';
	static ApprovalJustificationPlaceholder = '-';
	static SendPasswordChangeEmail = 'Skicka lösenordsändringslänk via e-post';
	static AllPartners = '"Alla partners"';
	static ActiveUserRights = 'Aktiva behörigheter';
	static TaskDefaultPrioritiesInUse = '-';
	static PasswordHasBeenCopiedToClipboard = 'Lösenordet har kopierats till urklipp!';
	static InstantMessageChannelUsersNotUsable = 'Användaren tillhör inte längre chattdeltagare';
	static NotImplementedYet = '-';
	static AccessRightWrite = '-';
	static FormVerticalDirection = '-';
	static LockedCalendarTaskParameterCannotBeSaved = '-';
	static DeletingWhistleBlowChannelAdminsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort administratörer \'{0}\'! Fel: \'{1}\'';
	static ChartGenerationFailed = 'Det gick inte att skapa diagram!';
	static RemoveReport = 'Ta bort rapport';
	static RestoreReportFromTrashBin = '-';
	static SavingTaskStateParameterWasSuccessful = '-';
	static CheckingExistanceOfFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att kontrollera existensen av mappen \'{0}\' i filsystemet! Fel: \'{1}\'';
	static RiskLikelihood3 = '-';
	static AddAttachment = 'Bifoga fil';
	static WhistleBlowStatisticsInProgressRecords = 'Pågående rapporter';
	static SelectRiskCategory = '-';
	static AllLogisticVoucherCustomers = 'Alla kunder';
	static Change = 'Förändra';
	static AddOpportunity = '-';
	static CourseCredit = 'Kurskredit';
	static PasswordMustBeDefined = 'Lösenord måste definieras!';
	static DeletingUserGroupParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort användargruppen \'{0}\'! Fel: \'{1}\'';
	static RiskLevelCritical = '-';
	static NewMenu = 'Ny meny';
	static ClearSubUnitDefaultHandlersAndNotifiedPersons = 'Rensa underenhets standardhanterare och anmälda personer';
	static DocumentTypes = 'Dokumenttyper';
	static RecordUserWithSameFirstNameMiddleNameAndLastNameAlreadyExists = 'Användarpost med samma förnamn \'{0}\', efternamn \'{2}\' och mellannamn \'{1}\' finns redan!';
	static WhistleBlowInternalMessageConfirmation = 'Vill du spara ett nytt internt meddelande?';
	static RemovingCalendarTaskHandlersWasSuccessful = 'Ansvariga personer har tagits bort!';
	static SelectRemovingMethod = 'Välj ta bort metod';
	static RestoreFromTrashBin = '-';
	static ClearSubFolderPermissions = 'Rensa undermappsbehörigheter';
	static MinimumPasswordLength = 'Minsta lösenordslängd';
	static DocumentNameIsTooLong = 'Dokumentnamnet \'{0}\' är för långt!';
	static FormTextArea = 'Lång textinmatning';
	static SavingInstantMessageChannelUserUserWasSuccessful = 'Deltagaren har sparats!';
	static EventModuleInfoPermissions = 'Synlighet och åtkomsträttigheter för incidentkanaler. Åtkomst kan beviljas QR-kodanvändare.';
	static RecordUserSettingsParameterNotFound = '-';
	static Administrator = 'Administratör';
	static EventTypeCParameterChildrenAreInUseInParameterEventsAndCannotBeDeleted = 'Kategori 3 "{0}" underkategorier används i {1} incidenter och kategori 3 kan inte tas bort!';
	static AddingRiskAssessmentHandlersWasSuccessful = '-';
	static User = 'Användarkonto';
	static IncludeOnlyActiveUsers = 'Inkludera endast användare med aktivt användarkonto och nuvarande arbetsplats';
	static RiskModuleInfoRiskStandards = '-';
	static UserIsSystemAdminClaimNotFound = 'Användaranspråket "userIsSystemAdmin" hittades inte!';
	static JobTypePushNotification = 'Push Notification';
	static SharedReport = 'Delad rapport';
	static SavePasswordAndMoveToLoginPage = 'Spara lösenord och flytta till inloggningssidan';
	static RemoveCompanyTaskType = '-';
	static AddEventType = 'Lägg till kategori 1';
	static DeletingRecordUserPartnerParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort resurspartnern \'{0}\' eftersom data i resurspartnern har ändrats samtidigt av en annan användare!';
	static EditLogisticVoucherTransportCompany = 'Redigera Transportföretag';
	static LogEventTime = 'Tid';
	static Intern = 'Internera';
	static SaveAsFavorite = 'Spara som favorit';
	static AddPermission = 'Lägg till rättighet';
	static SavingEventTypeParameterWasSuccessful = 'Kategori 1 \'{0}\' har sparats!';
	static HandlersMustBeDefined = 'Hanterare måste definieras!';
	static MessageModuleInfoPermissions = 'Synlighet och åtkomsträttigheter för Aktuella ämnen-kanaler. Åtkomst kan beviljas QR-kodanvändare.';
	static RemoveRiskPermanently = '-';
	static MovingFolderDirectoryItemParameterToFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att flytta mappen \'{0}\' till mappen \'{1}\'! Fel: \'{2}\'';
	static Ascending = 'Stigande';
	static SavingSharedPanelWasNotSuccessfulConcurrencyError = '-';
	static EventTypeCodeIsAlreadyInUse = 'Kategori 1-namn används redan!';
	static ExpiringIn90Days = 'Inkludera utbildningar som löper ut om 90 dagar';
	static DeletingRecordUserEmploymentParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort anställningen \'{0}\'! Fel: \'{1}\'';
	static WhistleBlowSeverityNormal = 'Vanligt';
	static Empty = 'Tömma';
	static ExternalIntraSystemCompanyTokenMustBeDefined = 'Företagstoken i externt eSalkku-system måste definieras!';
	static Aprint = 'Utskrift';
	static AddDefaultHandler = 'Lägg till standardhanterare';
	static DownloadDocument = 'Öppna/ladda ner valda filer/dokument';
	static PersonsInCharge = '-';
	static DeletingDirectoryItemFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort mappen \'{0}\'! Fel: \'{1}\'';
	static CompanyGroupParameterNotFound = 'Företagsgruppen \'{0}\' hittades inte!';
	static QualificationRequirementParameterValid = 'Kvalifikation: {0} giltiga utbildningar';
	static RiskTemplateRemoveConfirmation = '-';
	static NotificationsSentSuccessfully = 'Aviseringar har skickats!';
	static LockedTaskParameterCannotBeMovedToTrashBin = '-';
	static AddFamiliarizationToMultipleUserRecords = 'Lägg till bekantskap till flera användarposter';
	static FormulaDateAndTimeDiffInMinutes = 'Tidsskillnad i minuter';
	static FormCalculatedDecimalNumber = 'Beräknat decimaltal';
	static SavingRiskAssessmentParameterWasSuccessful = '-';
	static PrintOrientation = 'Skriv ut orientering';
	static CalendarTaskCategoryParameterIsInUseInParameterCalendarTasksAndCannotBeDeleted = 'Kategori \'{0}\' används i {1} händelser och kan inte tas bort!';
	static AddFolder = 'Lägg till mapp';
	static SavingRecordUserSettingsWasSuccessful = '-';
	static WorkShiftType = 'Arbetsskiftstyp';
	static FormShowModifyUser = 'Visa ändra användare';
	static ArchivingOpportunityParameterWasNotSuccessfulErrorParameter = '-';
	static ConfirmPassword = 'Bekräfta lösenord';
	static QualificationIsInvalid = 'Kvalifikationen är inte giltig!';
	static MovingTaskParameterToTrashBinWasNotSuccessfulErrorParameter = '-';
	static DeletingAttachmentParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort bilagan \'{0}\'! Fel: \'{1}\'';
	static ThisWeek = 'Denna vecka';
	static SavingWhistleBlowWasNotSuccessfulConcurrencyError = 'Det gick inte att spara whistle blow-rapporten eftersom data i rapporten har ändrats samtidigt av en annan användare!';
	static TasksExcelByTaskRows = '-';
	static AccessRightWrite_RecordDescription_A = '-';
	static SavingRiskCategoryParameterWasSuccessful = '-';
	static CurrentAndPreviousCalendarMonth = '-';
	static UpdateUserGroupParameterExternalSystemsWasNotSuccessfulErrorParameter = 'Det gick inte att länka användargruppen \'{0}\' till externa system! Fel: \'{1}\'';
	static InstantMessageChannelParameterNotFound = 'Chatten \'{0}\' hittades inte!';
	static ReportIsModifiedAfterItWasPublished = '-';
	static PanelSize3 = '1 x 2';
	static Comment = 'Kommentar';
	static Banner = 'Baner';
	static SharedFiltersAndReports = 'Delade filter och rapporter';
	static RiskAssessmentParameterNotFound = '-';
	static InvalidInvitationParameter = 'Ogiltig inbjudan \'{0}\'!';
	static ChangedEventUnit = 'Bytt incidentenhet';
	static DeletingCompanyParameterWasSuccessful = 'Företaget \'{0}\' har tagits bort!';
	static FormTextPreWrap = 'Bevara textradbrytningar';
	static AddEventTypesToEvent = '-';
	static SavingRecordBasicEducationParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara grundutbildningen \'{0}\', eftersom data i grundutbildningen har ändrats samtidigt av en annan användare!';
	static Created = 'Skapad av';
	static CanShareContentToCompanies = 'Innehåll kan delas med dessa partner';
	static DeletingEventUrgencyClassesParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort brådskande klasser "{0}", eftersom data i brådskande klasser har ändrats samtidigt av en annan användare!';
	static DeletingEventTypeParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kategori 1 \'{0}\'! Fel: \'{1}\'';
	static PasswordMustContainLowercaseChar = 'Lösenordet måste innehålla gemener!';
	static DeletingCompanyGroupParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort företagsgruppen \'{0}\'! Fel: \'{1}\'';
	static RiskOwnerMustBeDefined = '-';
	static MessageStartDateMustBeDefined = 'Meddelande synligt fram till datum måste definieras!';
	static AllDocumentTypes = 'Visa alla dokumenttyper';
	static TitleIsAlreadyInUse = 'Titeln används redan!';
	static CalendarTaskRepetitionEndDateSuffix = '';
	static SavingRecordFurtherEducationGroupParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara utbildningsgruppen \'{0}\', eftersom data i utbildningsgruppen har ändrats samtidigt av en annan användare!';
	static DeletingRiskAssesmentParameterWasSuccessful = '-';
	static DoYouReallyWantToRemoveFolderParameter = 'Vill du verkligen ta bort mappen \'{0}\'?';
	static RecurringCalendarTaskCannotHaveMoreThanParameterOccurences = '-';
	static JobTypeEmail = 'E-mailar';
	static SelectUserGroup = 'Välj Användargrupp';
	static UserCodeUpdateWasNotSuccessfulErrorParameter = 'Det gick inte att uppdatera användarkoden! Fel: \'{0}\'';
	static ShowDraftVersion = 'Visa utkastinnehåll';
	static TaskMustBeSavedBeforeAttachmentsCanBeAdded = '-';
	static DeletingCalendarTaskParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort händelsen \'{0}\'! Fel: \'{1}\'';
	static FormDocumentReferenceWarning = '-';
	static SavingOpportunityParameterWasSuccessful = '-';
	static SavingOptionParameterWasSuccessful = 'Alternativet \'{0}\' har sparats!';
	static DeletingPartnersParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort partners{0}! Fel: \'{1}\'';
	static CompanyCodeMustBeDefined = 'Koden för företaget måste definieras!';
	static UnreadMessagesParameter = 'Olästa meddelanden: {0}';
	static TaskDefaultPrioritiesInstruction = '-';
	static SavingTaskTypeParameterWasNotSuccessfulConcurrencyError = '-';
	static DeletingFileFilterParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort filfiltret \'{0}\'! Fel: \'{1}\'';
	static FormulaTrunc = 'Heltalsdel';
	static DoYouReallyWantToRemoveSelectedRiskStakeholders = '-';
	static Admins = 'Administratörer';
	static EditUser = 'Redigera användarkonto';
	static Summary = 'Sammanfattning';
	static RiskStandards = '-';
	static SendMessage = 'Skicka meddelande';
	static SelectApprovers = 'Välj godkännare';
	static RefreshList = 'Uppdatera listan';
	static InstantMessageSettings = 'Inställningar för snabbmeddelanden (HoxUp)';
	static DoYouReallyWantToSave = 'Vill du spara?';
	static NoUnusedFormFieldsAvailable = '-';
	static Locked = 'Låst';
	static AccessRightWrite_UserDescription = '-';
	static AddHandlers = 'Lägg till hanterare';
	static SendReadReceiptInfo = 'Skicka läskvitto genom att trycka på &#10003; knapp.';
	static SavingInstantMessageChannelUserWasNotSuccessfulErrorParameter = 'Det gick inte att spara deltagare! Fel: \'{0}\'';
	static TaskPriorityCodeMustBeDefined = '-';
	static SendReadReceipt = 'Skicka läskvitto';
	static PermissionToIdentificateEvents = 'Tillstånd att skapa och identifiera incidenter';
	static DefaultHandlers = 'Standardhanterare';
	static RemovingTaskHandlerWasNotSuccessfulErrorParameter = '-';
	static Unlock = 'Låsa upp';
	static FormOption = '-';
	static UserRecordStatisticsMissingQualifications = 'Saknade kvalifikationer';
	static SelectDocumentInListToSeeThePreview = 'Välj dokument i listan för att se förhandsgranskningen';
	static BasicEducationsMustBeDefinedBeforeAddingRecordUsers = 'Grundutbildningar måste definieras innan användarposter läggs till!';
	static EmptyRiskTemplate = '-';
	static ReportGenerationFailed = 'Det gick inte att skapa rapporten!';
	static PrintIsEmpty = 'Utskriften är tom!';
	static OpportunityBenefit = '-';
	static SavingEditableDocumentParameterPublishWasNotSuccessfulErrorParameter = 'Det gick inte att publicera dokumentet \'{0}\'! Fel: \'{1}\'';
	static FileParameterDoesNotContainAnyTaskDataRows = '-';
	static Valid = 'Giltig';
	static UserHasNotLoggedIn = 'Användaren har aldrig loggat in i systemet.';
	static MyFiltersAndReports = 'Användarens filter och rapporter';
	static UserPasswordMustBeValid = 'Lösenordet måste vara minst 8 tecken långt och det måste innehålla små bokstäver, versaler och minst en siffra eller specialtecken.';
	static CurrentAndPreviousCalendarYear = '-';
	static AdditionalFunctions = 'Ytterligare funktioner';
	static FormInitializeFromSavedRow = 'Initiera från sparad rad';
	static SaveReportAs = 'Spara rapport som';
	static SavingEventUrgencyClassParameterWasSuccessful = 'Brådskande klass \'{0}\' har sparats!';
	static ArchiveExpiredFamiliarizations = 'Arkivera utgångna bekantskaper';
	static PasteDefaultHandlers = 'Klistra in standardhanterare';
	static EventModuleInfoDefaultHandlers = 'Standardhanteraren/-erna för en incident och, om det behövs, mottagaren/mottagarna av meddelandet ställs in individuellt för varje enhet.';
	static EditEventTypeC = 'Redigera kategori 3';
	static Font = 'Font';
	static AddEventMessage = 'Lägg till kommentar';
	static WhistleBlowDateAndTimeCannotBeInFuture = 'Incident tid kan inte vara i framtiden!';
	static EventTypeC = 'Kategori 3';
	static UserGroupParameterIsInUseInParameterUsersAndCannotBeDeleted = 'Användargruppen \'{0}\' används av {1} användare och kan inte tas bort!';
	static UserCanBeSelectedAsEventHandler = 'Användare kan väljas som incidenthanterare';
	static EventTypeBParameterIsInUseInParameterEventsAndCannotBeDeleted = 'Kategori 2 \'{0}\' används i {1} incidenter och kan inte tas bort!';
	static Custom = 'Beställnings';
	static TasksExcelByTasks = '-';
	static Charts = '-';
	static LockedOpportunityParameterCannotBeRestored = '-';
	static SearchCalendarTasks = 'Sök händelser';
	static AddCompanyToCompanyGroup = 'Lägg till företag i företagsgruppen';
	static ShowPublishVersion = 'Visa publicerad version';
	static FormProperties = 'Egenskaper';
	static IncludeArchivedFurtherEducations = 'Inkludera arkiverade vidareutbildningar';
	static WhistleBlowResolutionJunk = 'Skräppost';
	static RecordUserFamiliarizationApprovalWasNotSuccessfulErrorParameter = 'Kunde inte godkänna introduktionen! Fel: \'{0}\'';
	static AdditionalSettings = 'Ytterligare inställningar';
	static WhistleBlowWasNotFoundExplanation = 'Kontrollera lösenordet för whistleblow-rapporten.';
	static TargetDoesNotHaveFoldersWithWritePermissions = 'Target har inga mappar med skrivbehörighet!';
	static DoYouReallyWantToRemoveRecordUserTransferredPropertyParameter = 'Vill du verkligen ta bort den överförda egenskapen \'{0}\'?';
	static WhistleBlowEventTypeReadDescription = '-';
	static WhistleBlowDateAndTime = 'Incident tid';
	static AuthorizationLevel = 'Behörighetsnivå';
	static OperationNotAllowedForRootFolderParameter = 'Operation är inte tillåten för rotmappen \'{0}\'!';
	static PathMustBeDefined = 'Vägen måste definieras!';
	static MovingRiskParameterToTrashBinWasNotSuccessfulConcurrencyError = '-';
	static Approver = 'Godkännare';
	static DoYouReallyWantToRemoveRecordUserEmploymentParameter = 'Vill du verkligen ta bort anställning \'{0}\'?';
	static RemovingWhistleBlowHandlerWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort hanterare! Fel: \'{0}\'';
	static DocumentModuleInfoDocumentTemplates = 'Mallar för systemdokument. Mallarna används när nya dokument skapas.';
	static Events = 'Incidenter';
	static ChartAtLeastOneValueFieldMustBeDefined = '-';
	static DoYouReallyWantToReplaceDocumentTemplateParameter = 'Vill du verkligen ersätta dokumentmallen \'{0}\'?';
	static SelectOperatorOrFunction = 'Välj operatör eller funktion';
	static LockedReportParameterCannotBeUnpublished = '-';
	static WhistleBlowDescriptionEditReason = '-';
	static SelectUser = 'Välj Användarkonto';
	static SavingRecordFurtherEducationParameterWasSuccessful = 'Utbildning \'{0}\' har sparats!';
	static SavingDirectoryItemPermissionsWasNotSuccessfulConcurrencyError = 'Det gick inte att spara mappbehörigheter eftersom mappar har ändrats samtidigt av en annan användare!';
	static MissingPlural = 'Saknas';
	static DocumentParameterDownloaded = 'Dokumentet har laddats ner.';
	static DeletingAttachmentsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort bilagorna \'{0}\', eftersom data har ändrats samtidigt av en annan användare!';
	static ValidityStartDate = 'Giltighetsstartdatum';
	static RemoveLogisticVoucherCustomer = 'Ta bort kund';
	static RemoveUserGroupExternalSystemsWasSuccessful = 'Användargruppslänkar till externa system har tagits bort!';
	static UserAccountConnected = 'Användarkonto anslutet';
	static FieldParameterContainsInvalidCodeCharacters = 'Värdet på fältet \'{0}\' innehåller tecken som är olagliga i koder ( \, ^, ?, &, <, >, /, +, :) eller så slutar det med olagliga tecken (.)!';
	static PropertyTransferred = 'Överförd';
	static ExternalSystemCompanyCodeClaimNotFound = 'Användarens anspråk \'externalSystemCompanyCode\' hittades inte!';
	static ChangeLanguage = 'Ändra språk';
	static TaskStateParameterNotFound = '-';
	static DoYouReallyWantToUnpublishAppReportParameter = '-';
	static SavingTaskPriorityParameterWasNotSuccessfulErrorParameter = '-';
	static EmploymentEndDateCannotPrecedeEmploymentStartDate = 'Anställningens slutdatum kan inte föregå anställningens startdatum!';
	static DoYouReallyWantToUnlockTask = '-';
	static SavingUserParametersWasSuccessful = 'Användaralternativ har sparats!';
	static DoYouReallyWantToArchiveAppReportParameter = '-';
	static WhistleBlowArchivingTypeChangeStateAndRemoveAllData = 'Ändra tillstånd för rapport till "Arkiverad" och behåll endast information som behövs för statistik';
	static RestoringReportParameterFromTrashBinWasNotSuccessfulConcurrencyError = '-';
	static SavingApplicationPermissionsWasSuccessful = 'Systembehörigheterna har sparats!';
	static EditableDocumentUnpublishConfirmation = 'Vill du ta bort den publicerade filen?';
	static DoYouReallyWantToRemoveUnitParameter = 'Vill du verkligen ta bort enheten \'{0}\'?';
	static RecordUserExcelUserList = 'Personal';
	static OtherInformation = 'Annan information';
	static FolderParameterAlreadyExistsInFileSystem = 'Mappen \'{0}\' finns redan i filsystemet!';
	static Messages = 'Meddelanden';
	static ReadReceiptNotGiven = 'Kvittot ej skickat';
	static UserIsInstantMessageChannelOnlyAdministratorInParameterInstantMessageChannels = 'Användaren är bara chattadministratör i {0} chattar!';
	static AddPartnerParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till partner \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static StudyWeek = 'Studievecka';
	static RemoveCalendarTask = 'Ta bort händelse';
	static Anonymity = 'Anonymitet';
	static DoYouReallyWantToRemoveMessageTypeParameter = 'Vill du verkligen ta bort meddelandetypen \'{0}\'?';
	static DocumentVersionParameterNotFound = 'Dokumentversion \'{0}\' hittades inte!';
	static WhistleBlowStateInProgress = 'Pågående';
	static AddCompaniesParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till företag \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static EventTypeCostsReportPieChartIndirectCostsName = '-';
	static Yearly = 'Årlig';
	static RecordFamiliarizationCodeIsAlreadyInUse = 'Bekantskapsnamnet används redan!';
	static FileFilterCodeMustBeDefined = 'Filfilterkod måste definieras!';
	static Units = 'Enheter';
	static IdentificationDetails = 'Identifieringsdetaljer';
	static EventsFound = 'Incidenter hittades';
	static CopyDefaultHandlers = 'Kopiera standardhanterare';
	static SavingRiskSettingWasNotSuccessfulErrorParameter = '-';
	static TaskChartShowDataLabels = '-';
	static NewWhistleBlowMustBeSavedBeforeHandlersCanBeAdded = 'Ny rapport måste sparas innan rader kan läggas till!';
	static FormTitlePageLayout1 = '-';
	static ModifyExistingDocumentTemplate = 'Ändra befintlig dokumentmall';
	static DraftCannotBeApprovedDoYouWantToSaveDraftAnyway = 'Utkast kan inte godkännas! Vill du ändå spara utkast (godkännande kommer inte att sparas)?';
	static DeletingOneTimePasswordWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort engångslösenordet eftersom data i engångslösenordet har ändrats samtidigt av en annan användare!';
	static PrintSelectedRows = '-';
	static CalendarTaskEndDateMustBeAfterStartDate = 'Händelsens sluttid måste vara efter starttiden!';
	static LockedOpportunityParameterCannotBeSaved = '-';
	static EditCompany = 'Redigera företag';
	static ExternalSystemUserCodeClaimNotFound = 'Användaranspråket \'externalSystemUserCode\' hittades inte!';
	static DeletingInstantMessageUsersParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort deltagare "{0}", eftersom data har ändrats samtidigt av en annan användare!';
	static SavingUnitPermissionsWasNotSuccessfulConcurrencyError = 'Det gick inte att spara enhetsbehörigheter eftersom behörigheterna har ändrats samtidigt av en annan användare!';
	static DefaultRiskStakeholders = '-';
	static DeletingCompaniesParameterWasSuccessful = 'Företagen \'{0}\' har tagits bort!';
	static YouHaveNotSavedChangesDoYouWantToSaveChanges = 'Du har inte sparat ändringar som du har gjort. Vill du spara ändringar?';
	static DeletingCalendarTaskParameterWasSuccessful = 'Händelsen \'{0}\' har tagits bort!';
	static All = 'Allt';
	static DocumentTemplateCodeMustBeDefined = 'Dokumentmallskod måste definieras!';
	static SavingCalendarTaskParameterWasSuccessful = 'Händelsen \'{0}\' har sparats!';
	static LastWeek = 'Förra veckan';
	static RecordUserPartnerParameterNotFound = 'Resurspartnern \'{0}\' hittades inte!';
	static DefaultLanguageHasBeenChanged = 'Språket har ändrats!';
	static DeletingRecordQualificationParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kvalifikationen \'{0}\'! Fel: \'{1}\'';
	static SavingDefaultHandlersWasNotSuccessfulErrorParameter = 'Det gick inte att spara standardhanterare! Fel: \'{0}\'';
	static DoYouReallyWantToCreateRemainderInPast = 'Vill du verkligen skapa rester i det förflutna?';
	static FamiliarizationTime = 'Bekantskapstid';
	static AddUserGroupsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till användargrupper "{0}"! Fel: \'{1}\'';
	static RiskProcessParameterHasChildNodesAndCannotBeDeleted = '-';
	static PasswordChangeRequestHasBeenExpired = 'Begäran om lösenordsändring \'{0}\' har löpt ut!';
	static AllUnits = 'Alla enheter';
	static ReportTemplateCodeIsAlreadyInUse = '-';
	static MovingReportParameterToTrashBinWasNotSuccessfulErrorParameter = '-';
	static AccessRightWrite_RiskDescription = '-';
	static PublishDate = 'Utgivningsdatum';
	static ReadOnly = '-';
	static CompanyGroupModuleProperties = 'Företagsgruppers fastigheter';
	static Other = 'Övrig';
	static AccessRightWrite_DocumentDescription = '-';
	static AdditionalIdentifier = 'Ytterligare identifierare';
	static DoYouReallyWantToUnlockCalendarTask = '-';
	static TiedostoturvaUseType = 'Tiedostoturva';
	static MessageEndDate = 'Synlig till';
	static DoYouReallyWantToRemoveEventTypeParameter = 'Vill du verkligen ta bort kategori 1 \'{0}\'?';
	static DraftCannotBeApproved = 'Utkast kan inte godkännas!';
	static RememberMe = 'Kom ihåg mig';
	static FormExpressionFormat = 'Formatering av uttrycksresultat';
	static DefaultFamiliarizations = 'Standard bekantskaper';
	static DoYouReallyWantToRemoveSelectedCalendarTaskHandlers = 'Vill du verkligen ta bort de valda ansvariga personerna?';
	static FormReportReferenceIsIsInvalid = '-';
	static SavingRecordUserSettingsWasNotSuccessfulErrorParameter = '-';
	static UserRecordStatisticsSavedCards = 'Sparade kort';
	static AdminMustBeDefined = 'Administratör måste definieras!';
	static Validity = 'Giltighet';
	static ReadReceiptRequired = 'Läskvitto krävs';
	static TaskChartGroupingFieldGroupingTypeHalfYear = '-';
	static AccessRightWrite_AppReportDescription = '-';
	static SomeEventHandlersHaveReadMessage = 'Vissa incidenthanterare har läst din kommentar';
	static AddUsersParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till användarkonton \'{0}\'! Fel: \'{1}\'';
	static NewCompanyMustBeSavedBeforeCompanyGroupsCanBeAdded = 'Nytt företag måste sparas innan företagsgrupper kan läggas till!';
	static DeletingTaskPrioritiesParameterWasNotSuccessfulErrorParameter = '-';
	static EventReport = 'Skaderapport';
	static RecordUserModuleInfoBasicEducations = 'Ange de grundläggande utbildningar som ska användas i användarposter.';
	static ExternalIntraSystems = 'Externa eSalkku-system';
	static SavingEventTypeCsWasSuccessful = 'Kategori 3 har sparats framgångsrikt!';
	static ExternalIntraSystemUserTokenMustBeDefined = 'Användartoken i externt eSalkku-system måste definieras!';
	static FolderNameIsTooLong = 'Mappnamnet \'{0}\' är för långt!';
	static RiskStakeholderParameterHasChildNodesAndCannotBeDeleted = '-';
	static TaskModuleInfoPermissions = '-';
	static CopyingFilesAndDocumentsToFolderParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att kopiera filer/dokument till mappen "{0}", eftersom data i mappen har ändrats samtidigt av en annan användare!';
	static PreviousCalendarMonth = 'Föregående kalendermånad';
	static MinimumPasswordLengthMustBeAtLeastParameterCharacters = 'Minsta lösenordslängd måste vara minst {0} tecken!';
	static RemoveBasicEducation = 'Ta bort grundutbildning';
	static DeletingTaskDataRowWasSuccessful = '-';
	static ArchiveExpiredFurtherEducations = 'Arkivera utgångna utbildningar';
	static RequestPasswordChangeTitle = 'Glömt lösenordet?';
	static ArchivingOpportunityParameterWasSuccessful = '-';
	static RestoringTaskParameterFromArchiveWasNotSuccessfulErrorParameter = '-';
	static UserRecordCards = 'Användarregister';
	static LockingTaskDataRowWasNotSuccessful = '-';
	static AccessRightNone_InstantMessageDescription = '-';
	static EventModuleInfoEventTypes = 'Kategorier används för att filtrera och rapportera incidenter. Vid behov kan en kategori göras valbar av den person som rapporterar incidenten.';
	static LoginAddress = 'Inloggningsadress';
	static EventTypeB = 'Kategori 2';
	static SharePanelParametrToUserGroups = '-';
	static SavingEventTypeBsWasSuccessful = 'Kategori 2 har sparats framgångsrikt!';
	static SavingReportTemplateParameterWasNotSuccessfulErrorParameter = '-';
	static SavingRiskTemplateParameterWasNotSuccessfulConcurrencyError = '-';
	static LockedRiskParameterCannotBeSaved = '-';
	static PrivacyPolicyUrl = 'Sekretesspolicy webbadress';
	static MonthAbbr = '-';
	static SavingRiskStakeholderParameterWasNotSuccessfulConcurrencyError = '-';
	static TasksInUse = '-';
	static AccessRightRead_TaskDescription_BC = '-';
	static NewUserGroupMustBeSavedBeforeUsersCanBeAdded = 'Ny användargrupp måste sparas innan användare kan läggas till!';
	static FormWidthPrint = 'Bredd i tryck';
	static SavingRecordFurtherEducationGroupParameterWasSuccessful = 'Utbildningsgruppen \'{0}\' har sparats!';
	static UpdateCompanyExternalSystemsWasNotSuccessfulErrorParameter = 'Det gick inte att länka företaget till externa system! Fel: \'{0}\'';
	static ChangeCompany = 'Byt företag';
	static AddFurtherEducationGroup = 'Lägg till utbildningsgrupp';
	static WhistleBlowInformantInstuctions = 'Informantinstruktioner';
	static UnpublishingReportParameterWasNotSuccessfulConcurrencyError = '-';
	static RemovePicture = 'Ta bort bild';
	static AddCompanyGroupParameterWasNotSuccessfulConcurrencyError = 'Misslyckades med företagsgruppen \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static Calendar = 'Kalender';
	static MessageTypes = 'Meddelandetyper';
	static LockedRiskParameterCannotBeUnpublished = '-';
	static FirstNameMustBeDefined = 'Förnamn måste definieras!';
	static PanelName = 'Panelnamn';
	static RiskApprovalConditional = '-';
	static WhistleBlowReport = 'Whistle Blow Report';
	static InstantMessageChannelUserParameterNotFound = 'Chattpartiet \'{0}\' hittades inte!';
	static Update = 'Uppdatering';
	static DoYouReallyWantToRemovePrintParameter = 'Vill du verkligen ta bort utskriften "{0}"?';
	static DoYouReallyWantToRemoveWhistleBlowParameter = 'Vill du verkligen ta bort whistle blow-rapporten \'{0}\'?';
	static Groups = 'Grupper';
	static DeletingRecordFurtherEducationsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort utbildningar \'{0}\', eftersom data i utbildningar har ändrats samtidigt av en annan användare!';
	static DeletingEventParameterWasSuccessful = 'Incidenten \'{0}\' har tagits bort!';
	static FormulaCos = 'Cosinus';
	static AddTaskPriority = '-';
	static DefaultEventUrgencyClassParameterCannotBeDeleted = 'Standard brådskande klass kan inte tas bort!';
	static RecordBasicEducationCodeMustBeDefined = 'Grundutbildningens namn måste definieras!';
	static ImmediateAction = 'Avhjälpande åtgärd';
	static SavingUnitPermissionsWasNotSuccessfulErrorParameter = 'Det gick inte att spara enhetsbehörigheter! Fel: \'{0}\'';
	static FormCodeIsAlreadyInUse = 'Formulärnamnet används redan!';
	static UpdateUserParameterExternalSystemsWasNotSuccessfulErrorParameter = 'Det gick inte att länka användaren \'{0}\' till externa system! Fel: \'{1}\'';
	static DocumentRootPathMustBeDefined = 'Dokumentets rotsökväg måste definieras!';
	static EmptyingTaskTrashBinWasSuccessful = '-';
	static SelectRiskType = '-';
	static AddPhotosAndAttachmentsMobile = 'Lägg till foto eller bilaga genom att trycka på kameran eller plusknapparna.';
	static RiskStakeholderParameterIsInUse = '-';
	static CompanyIdClaimNotFound = 'Användaranspråket "företags-id" hittades inte!';
	static AccessRightWriteInstantMessages = '-';
	static PreviewPrint = 'Förhandsgranska (skriv ut)';
	static OtherForms = '-';
	static UserProfile = 'Användarkonto';
	static AccessRightRead_EventDescription_A = '-';
	static DeletingUserParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort användarkontot \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static TrendingDown = '-';
	static ReadImp = 'Läsa';
	static TaskTypeNameMustBeDefined = '-';
	static PublishingRiskParameterWasNotSuccessfulErrorParameter = '-';
	static RemoveDefaultTaskState = '-';
	static FileRemovalWasSuccessful = 'Filen har tagits bort!';
	static AssessmentTreatmentsMustBeDefined = '-';
	static ValidityEndDateEnd = 'Giltighet Slutdatum - Slut';
	static RestoringReportParameterFromTrashBinWasSuccessful = '-';
	static PersonsRemoveConfirmation = '-';
	static RemovingTaskHandlersWasSuccessful = '-';
	static DeletingWhistleBlowChannelAdminParameterWasSuccessful = 'Administratören \'{0}\' har tagits bort!';
	static EmailMessage = 'Skicka meddelande via e-post';
	static FolderParameterAlreadyExists = 'Mappen \'{0}\' finns redan!';
	static RecordUserFurtherEducationParameterNotFound = 'Utbildning \'{0}\' hittades inte!';
	static ValidityEndDateStart = 'Giltighetsslutdatum - Start';
	static DeletingRecordFamiliarizationParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort bekantskapen \'{0}\', eftersom data i bekantskapen har ändrats samtidigt av en annan användare!';
	static SelectState = 'Välj stat';
	static SearchEvents = 'Sök incidenter';
	static TaskStateCodeMustBeDefined = '-';
	static AddChildRiskProcess = '-';
	static DoYouReallyWantToRemoveRecordUserParameter = 'Vill du verkligen ta bort användarposten "{0}"?';
	static RecordParameterLockingFailed = 'Det gick inte att låsa posten \'{0}\'!';
	static InvitationParameterNotFound = 'Inbjudan \'{0}\' hittades inte!';
	static AuthorizationLevelQrCodeUser = 'QR-kodanvändare';
	static NoLocking = 'Ingen låsning';
	static AccessRightWrite_Event_B = '-';
	static LogDocumentPreview = 'Logga dokumentförhandsgranskning';
	static SavingInstantMessageWasSuccessful = 'Snabbmeddelandet har sparats!';
	static RemovingReportTemplateUnitsWasSuccessful = '-';
	static ObserverAction = 'Observatörsåtgärd';
	static NoFilters = 'Inga filter!';
	static FormHeight = 'Höjd';
	static SavingKeywordParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara sökordet "{0}", eftersom data i sökordet har ändrats samtidigt av en annan användare!';
	static WhistleBlowUrlInfo = 'Endast systemadministratören kan ändra adressen';
	static SavingWhistleBlowMessageWasSuccessful = 'Meddelandet har sparats!';
	static TaskState = '-';
	static EditCalendarTask = 'Redigera händelse';
	static LoginAllowMicrosoft = '-';
	static SavingPrintWasSuccessful = 'Utskriften har sparats!';
	static ModifyDateEndDate = 'Senast ändrad till';
	static DoYouReallyWantToUnlockOpportunity = '-';
	static UserToken = 'Användartoken';
	static RiskTemplateParameterNotFound = '-';
	static RemoveEvent = 'Ta bort incidenten';
	static DeletingRecordUserEmploymentsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort anställningar \'{0}\'! Fel: \'{1}\'';
	static CurrentTopicsAbbr = 'Aktuell';
	static RemoveCompanyFromCompanyGroup = 'Ta bort företag från företagsgruppen';
	static SavingRiskParameterWasSuccessful = '-';
	static EditTransferredProperty = 'Redigera överförd egendom';
	static EventsExcel = 'Incidenter - Excel';
	static RemoveComment = 'Ta bort kommentar';
	static WhistleBlowInformantDescription = 'Beskriv vad som hänt';
	static DeletingRecordFurtherEducationGroupParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort utbildningsgruppen "{0}", eftersom data i utbildningsgruppen har ändrats samtidigt av en annan användare!';
	static SavingEventSettingsWasNotSuccessfulConcurrencyError = 'Det gick inte att spara incidentinställningarna eftersom incidentinställningarna har ändrats samtidigt av en annan användare!';
	static Report = 'Rapportera';
	static ImportUsers = 'Importera användarkonton';
	static TaskPriorityParameterIsInUseInParameterTasksAndCannotBeDeleted = '-';
	static DeletingEventTypeParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kategori 1 \'{0}\' eftersom data i kategori 1 har ändrats samtidigt av en annan användare!';
	static NextAssessmentDateMustBeDefined = '-';
	static TogglePreviewPanel = 'Visa/dölj förhandsgranskning';
	static RemoveFile = 'Ta bort fil';
	static ShowUserGroups = 'Visa användargrupper';
	static EventType = 'Kategori 1';
	static EditRow = 'Redigera rad';
	static MessageDateMustBeDefined = 'Meddelandedatum måste anges!';
	static EmptyingRiskManagementTrashBinWasNotSuccessfulErrorParameter = '-';
	static OperationAborted = 'Operationen avbröts!';
	static TaskTypeUnits = '-';
	static PasswordChangeRequestParameterNotFound = 'Begäran om lösenordsändring \'{0}\' hittades inte!';
	static NoPermission = 'Inga tillstånd';
	static FormTitle2 = 'Titel 2';
	static RiskProcessesInUse = '-';
	static SearchRisks = '-';
	static AccessRightWrite_MessageDescription = '-';
	static UserIsCompanyAdminClaimNotFound = 'Användaranspråket "userIsCompanyAdmin" hittades inte!';
	static Errors = 'Fel';
	static SavingRecordFamiliarizationParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara bekantskapen \'{0}\', eftersom data i bekantskapen har ändrats samtidigt av en annan användare!';
	static AssessmentCommentPlaceholder = '-';
	static FormulaMultiplication = 'Multiplikation';
	static FormTaskTypeIsNotSelected = '-';
	static SaveMessage = 'Spara meddelande';
	static DoYouReallyWantToRemoveSelectedRiskAssessments = '-';
	static TaskPriority = '-';
	static MoneyOut = 'Pengar ut';
	static ImpactMustBeDefined = '-';
	static SelectFurtherEducation = 'Välj utbildning';
	static DeletingEventUrgencyClassParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort brådskande klass \'{0}\', eftersom data i brådskande klass har ändrats samtidigt av en annan användare!';
	static CompanyTaskTypeSettings = '-';
	static SavingUserParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara användaren \'{0}\'! Fel: \'{1}\'';
	static RemoveRemainder = 'Ta bort resten';
	static CopyContentToDocumentContent = 'Kopiera innehåll till dokumentinnehåll';
	static Cancel = 'Annullera';
	static TrainingEndDate = 'Slutdatum';
	static FormSignature = 'Signatur';
	static AddUserGroupParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till användargruppen \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static DocumentModuleInfoKeywords = 'Nyckelord kan användas i dokument. Nyckelorden används för att filtrera dokument.';
	static ClickToCancelAutomaticLogout = 'Användarsessionen är på väg att löpa ut, klicka på den här dialogrutan för att förhindra automatisk utloggning.';
	static SharedFilters = 'Delade filter';
	static EventTypeCostsReportBarChartDirectCostsByTimeName = '-';
	static DoYouReallyWantToRemovePartnerParameter = 'Vill du verkligen ta bort partner \'{0}\'?';
	static AccessRightRead_RecordDescription = '-';
	static WhistleBlowReportHasBeenSavedTopText = 'Lagra under lösenordet i säker lagring. Lösenorden ger dig tillgång till din rapport. Dela inte lösenord med någon!';
	static Maximum = 'Maximal';
	static DeletingCompanyGroupParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort företagsgruppen \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static WhistleBlowEventTypeAttachmentsRemoved = 'Bilagor har tagits bort';
	static DoYouReallyWantToUnlockTaskDataRow = '-';
	static AllCompanies = 'Alla företag';
	static SavingUserParameterParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara användaralternativet \'{0}\', eftersom data i användaralternativet har ändrats samtidigt av en annan användare!';
	static Unpublish = 'Avpublicera';
	static TrainingStartDate = 'Startdatum';
	static FolderNameConstainsIllegalCharacters = 'Mappnamnet innehåller olagliga tecken (<, >, :, ", /, \, |, ? tai *) eller så slutar det med olagliga tecken (., \' \')!';
	static EventTypeBCodeMustBeDefined = 'Kategori 2 namn måste definieras!';
	static RemoveInvalidDefaultEventHandlersConfirmation = 'Vissa standardincidenthanterare eller anmälda personer har inte behörighet att hantera incidenter med enheter. Vill du automatiskt ta bort dessa incidenthanterare eller meddelade personer innan du sparar nya inställningar?';
	static SendinEmailNotificationsWasNotSuccessfulErrorParameter = 'Det gick inte att skicka aviseringar till via e-post! Fel: \'{0}\'';
	static PrintEvent = 'Skriv ut incident';
	static TaskCalendarTasksInfo = '-';
	static NoFamiliarizationsToShow = 'Inga bekanta exempel att visa!';
	static RemoveRiskAssessment = '-';
	static AddDefaultEventType = 'Lägg till standardkategori 1';
	static RecordEmailNotificationShowExpired = 'Inkludera utgångna utbildningar';
	static Year = 'År';
	static Row = 'rad';
	static ExternalSystemCompanyTokenParameterIsAlreadyInUse = 'Företagstoken \'{0}\' används redan!';
	static RiskReportExtensive = '-';
	static CopyUnitDefaultHandlersAndNotifiedPersonsToAllSameLevelUnits = 'Kopiera standardhanterare och anmälda personer till alla enheter på samma nivå';
	static Expand = 'Bygga ut';
	static TaskTypeUsedInAllUnits = '-';
	static WhistleBlowEditDescription = '-';
	static CompetencyGroup = 'Kompetensgrupp';
	static SourceFolderAndTargetFolderAreSame = 'Källmapp och målmapp är lika!';
	static Removed = 'Tog bort';
	static DeletingCalendarTaskCategoryParameterWasSuccessful = 'Kategori \'{0}\' har tagits bort!';
	static AddingRecordUserFamiliarizationsWasSuccessful = 'Bekantskaper har lagts till!';
	static EditInstantMessageChannel = 'Redigera chatt';
	static DoYouReallyWantToRemoveEditableDocumentParameter = 'Vill du verkligen ta bort dokumentet \'{0}\'? Alla filer som är relaterade till dokumentet kommer att tas bort.';
	static FormMinimumValue = 'Minsta värde';
	static RemoveEmployment = 'Ta bort anställning';
	static OtherCompanies = 'Andra företag';
	static UserGroup = 'Användargrupp';
	static AccessRightWrite_RiskDescription_A = '-';
	static WhistleBlowDashboard = 'Whistleblower instrumentbräda';
	static FailureAudit = 'FailureAudit';
	static NewMessage = 'Nytt meddelande';
	static DeletingTaskDataRowWasNotSuccessfulErrorParameter = '-';
	static DeletingRiskAssesmentsParameterWasSuccessful = '-';
	static CalendarTaskRepetitionRepeatIntervalYearlySuffix = 'år';
	static AccessRightWrite_Record_A = '-';
	static TaskChartValueFieldCalculationTypeCount = '-';
	static MessageMustBeDefined = 'Meddelandets innehåll måste definieras!';
	static CalendarTaskEditOccurrence = 'Redigera förekomst';
	static ChartGroupingField = '-';
	static ReadReceiptGivenPlur = 'Läskvitto skickat';
	static ExternalSystemDatabaseInterfaceError = 'Externt eSalkku-systemdatabasgränssnittsfel!';
	static CompanyWithSysAdminAuthorizationLevelNotFound = 'Företaget som är relaterat till användargruppen \'Systemadministratör\' hittades inte!';
	static MarkMessageAsRead = 'Markera meddelandet som läst';
	static DeletingRiskStandardParameterWasSuccessful = '-';
	static ProcessingTime = 'Behandlingstid';
	static DeletingEventUrgencyClassesParameterWasSuccessful = 'Brådskande klasser \'{0}\' har tagits bort!';
	static DocumentNameParameterIsIllegal = 'Dokumentnamn \'{0}\' är inte tillåtet (reserverat namn)!';
	static TaskChartGroupingFieldGroupingTypeQuartal = '-';
	static RemoveRiskTemplate = '-';
	static SavingInstantMessageChannelParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara chatten \'{0}\'! Fel: \'{1}\'';
	static InternalMessages = 'Interna meddelanden';
	static FormExpression = 'Uttryck';
	static EmployeeTypeIsNotSupported = 'Anställd typ \'{0}\' stöds inte!';
	static RiskTemplateUnits = '-';
	static ShowOnlyUnitsThatAreInUse = 'Visa endast enheter som används';
	static EventTypeParameterNotFound = 'Kategori 1 \'{0}\' hittades inte!';
	static DeletingRecordQualificationsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort kvalifikationerna "{0}", eftersom data i kvalifikationer har ändrats samtidigt av en annan användare!';
	static FolderPath = 'Mappväg';
	static ImportTaskDataRowsDialogInstruction = '-';
	static SharedDocumentTemplates = 'Delade dokumentmallar';
	static NoDataToShow = 'Inga data att visa!';
	static AddPartnerParameterWasSuccessful = 'Partner \'{0}\' har lagts till!';
	static EditAll = 'Redigera alla';
	static BrowserInfo = 'Webbläsare';
	static PersonsInChargeMustBeDefined = '-';
	static DeletingOptionParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort alternativet \'{0}\'! Fel: \'{1}\'';
	static Last180Days = 'Senaste 180 dagarna';
	static AddApprovers = 'Lägg till godkännare';
	static ExpiringIn120Days = 'Inkludera utbildningar som löper ut om 120 dagar';
	static SavingDefaultHandlersWasSuccessful = 'Standardhanterare har sparats!';
	static AddInstantMessageUsersParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till deltagare \'{0}\'! Fel: \'{1}\'';
	static RecentlyUpdated = 'Nyligen uppdaterad';
	static MaxSearchResultCount = 'Max antal sökresultat';
	static IgnoreFilePatterns = 'Ignorera filmönster';
	static EditEventType = 'Redigera kategori 1';
	static SaveInstantMessageChannel = 'Spara Chatt';
	static FormLineBreak = 'Linjebrytning';
	static CalendarTaskStateNotStarted = 'Inte startat';
	static RecordUserModuleProperties = 'Egenskaper för användarposter';
	static SearchFurtherEducations = 'Sök utbildningar';
	static MessageUnit = 'Förlagsenhet';
	static SaveFilter = 'Spara filter';
	static MessageModuleInfoUnits = 'Enheten är en kanal där meddelanden om aktuella ämnen publiceras.';
	static DeletingRecordFamiliarizationParameterWasSuccessful = 'Bekantskapen \'{0}\' har tagits bort!';
	static ShortName = 'Kort namn';
	static RemovingEventHandlerWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort hanterare! Fel: \'{0}\'';
	static MoveTaskToTrashBin = '-';
	static DoYouReallyWantToRemoveSelectedHandlers = 'Vill du verkligen ta bort valda hanterare?';
	static SavingEventSettingsWasSuccessful = 'Incidentinställningarna har sparats!';
	static ManageSharedPanels = '-';
	static CalendarTaskModuleInfoCategories = 'Kategorier kan tilldelas kalenderposter för att klassificera dem. Dessa kategorier används för att filtrera posterna.';
	static FormWidth = 'Bredd';
	static LockedTaskParameterCannotBeDeleted = '-';
	static InvitationParameterHasBeenExpired = 'Inbjudan \'{0}\' har löpt ut!';
	static WhistleBlowInformantTitle = 'Vad handlar din rapport om?';
	static WhistleBlowResolutionResolved = 'Löst';
	static FieldsToBePrinted = 'Fält som ska skrivas ut';
	static UpdatingApplication = 'Uppdaterar app...';
	static FurtherEducationCompetencyMustBeSelected = 'Utbildning / kompetens måste väljas!';
	static ReminderNone = 'Ingen påminnelse';
	static CopyGroupPermissions = 'Kopiera gruppbehörigheter till minnet';
	static DescriptionMustBeDefined = 'Beskrivning måste definieras!';
	static SavingTaskParameterWasSuccessful = '-';
	static ShowInheritedPermissions = 'Visa ärvda behörigheter';
	static SavingRecordUserParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara användarposten \'{0}\'! Fel: \'{1}\'';
	static DeletingRiskProcessesParameterWasNotSuccessfulErrorParameter = '-';
	static RiskAssessmentApprovalWasNotSuccessfulErrorParameter = '-';
	static RemoveRiskStandard = '-';
	static Event = 'Incident';
	static InParameterYears = 'På {0} år';
	static GetPhoto = 'Skaffa foto';
	static AdditionalInformation = 'ytterligare information';
	static ApplicationTempPathIsNotSpecified = 'Application temp-mapp är inte specificerad!';
	static EducationsAndCompetencies = 'Utbildningar och kompetenser';
	static Version = 'Version';
	static DoYouReallyWantToRemoveSelectedDocumentTemplates = 'Vill du verkligen ta bort valda dokumentmallar?';
	static GetMore = 'Visa mer';
	static InstantMessageChannel = 'Chatt';
	static FormTitle1 = 'Titel 1';
	static FormCompactStyle = 'Kompakt';
	static ReportTemplateRemoveConfirmation = '-';
	static Import = 'Importera';
	static SelectEventReceiver = 'Välj Incident Receiver';
	static UserEndDate = 'Giltighet löper ut';
	static Company = 'Företag';
	static InstantMessageChannelGroupExternal = 'Grupp (intercompany)';
	static DoYouReallyWantToRemoveRiskStandardParameter = '-';
	static DeletingEventTypeCParameterWasSuccessful = 'Kategori 3 \'{0}\' har tagits bort!';
	static UnpublishingOpportunityParameterWasSuccessful = '-';
	static IHaveForgotMyPassword = 'Jag har glömt mitt lösenord';
	static FormCreateUser = '-';
	static LockedCalendarTaskParameterCannotBeDeleted = '-';
	static FormShowModifyDate = 'Visa ändringsdatum';
	static AccessRightWrite_CompanyGroupDescription = '-';
	static VersionHistory = 'Versionshistorik';
	static ExitInstantMessageChannel = 'Avsluta chatten';
	static Reminder = 'Påminnelse';
	static AddingEventHandlerWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till hanterare! Fel: \'{0}\'';
	static SavingInstantMessageWasNotSuccessfulErrorParameter = 'Det gick inte att spara snabbmeddelandet! Fel: \'{0}\'';
	static AddEventHandlersToEvent = 'Lägg till hanterare genom att trycka på plusknappen.';
	static RemoveUnit = 'Ta bort enheten';
	static EditEmployment = 'Redigera anställning';
	static WhistleBlowEventTypeMessageAdded = 'Meddelande har lagts till';
	static FormDocumentReferenceDocumentNotFound = '-';
	static RiskTreatmentStateInProgress = '-';
	static ActiveUserTasks = '-';
	static ReadReceiptGiven = 'Kvitto skickat';
	static SavingEditableDocumentParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara dokumentet \'{0}\' eftersom data i dokumentet har ändrats samtidigt av en annan användare!';
	static DeletingAttachmentParameterWasSuccessful = 'Bilaga \'{0}\' har tagits bort!';
	static InvalidValueInArgumentParameter = 'Ogiltigt värde i argumentet \'{0}\'!';
	static PaymentTermInDays = 'Betalningstid i dagar';
	static SavingRecordFurtherEducationParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara utbildningen \'{0}\', eftersom data i utbildningen har ändrats samtidigt av en annan användare!';
	static DetectingLocation = 'Upptäcker plats...';
	static DeletingDocumentTemplateParameterWasSuccessful = 'Dokumentmallen \'{0}\' har tagits bort!';
	static DeletingDirectoryItemFolderParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort mappen \'{0}\' eftersom data i mappen har ändrats samtidigt av en annan användare!';
	static FormRecordReference = '-';
	static RiskModuleInfoRiskProcesses = '-';
	static TransportCompany = 'Transportföretag';
	static MovingFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att flytta mappen \'{0}\' till mappen \'{1}\' i filsystemet! Fel: \'{2}\'';
	static FormRowSettings = '-';
	static Rejected = 'avvisade';
	static CalendarTaskRepetitionRepeatIntervalMonthSuffix = 'i månaden';
	static DoYouReallyWantToRemoveDocumentTemplateParameter = 'Vill du verkligen ta bort dokumentmallen \'{0}\'?';
	static EditRisk = '-';
	static DeletingTaskPrioritiesParameterWasSuccessful = '-';
	static ExpiringIn180Days = 'Inkludera utbildningar som löper ut om 180 dagar';
	static AddTaskTypeFromTemplate = '-';
	static ShowExpired = 'Visa Utgången';
	static AddingRecordUserFamiliarizationHandlersWasSuccessful = 'Godkännare har lagts till!';
	static AmountOfComments = 'Antal kommentarer';
	static Tasks = '-';
	static RiskTreatmentIsLate = '-';
	static RemoveUserAndKeepRecordUser = 'Ta bort användarkonto och behåll användarregister';
	static RestoringReportParameterFromTrashBinWasNotSuccessfulErrorParameter = '-';
	static ExpiredFurtherEducations = 'Utgångna utbildningar';
	static DoYouReallyWantToRemoveSelectedCalendarTaskCategories = 'Vill du verkligen ta bort valda kategorier?';
	static Returned = 'Returnerad';
	static AddFileFilter = 'Lägg till filfilter';
	static ModifyDateStartDate = 'Senast ändrad från';
	static RemoveLogisticVoucherPaymentSetting = 'Ta bort betalningsinställning';
	static EventIsApprovedByUser = 'Användaren har godkänt incidenten';
	static DoYouReallyWantToRemoveEventTypeBParameter = 'Vill du verkligen ta bort kategori 2 \'{0}\'?';
	static DependencyResolvingFailedForInterfaceParameter = 'Det gick inte att hitta implementeringen för gränssnittet \'{0}\'!';
	static UsersOfThisCompany = 'Användare av Mitt företag';
	static EventUrgencyClassParameterIsInUseInParameterEventsAndCannotBeDeleted = 'Brådskande klass \'{0}\' används i {1} incidenter och kan inte tas bort!';
	static UnpublishingEditableDocumentParameterWasSuccessful = 'Dokumentet \'{0}\' har avpublicerats!';
	static RiskStandard = '-';
	static CreatingFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att skapa mappen \'{0}\' i filsystemet! Fel: \'{1}\'';
	static UserParameterPermissionDeniedForUnitParameter = 'Användaren \'{0}\' har inga nödvändiga behörigheter för enheten \'{1}\'!';
	static UnlockingEditableDocumentParameterWasNotSuccessful = 'Det gick inte att låsa upp dokumentet \'{0}\'!';
	static MovingOpportunityParameterToTrashBinWasSuccessful = '-';
	static WhistleBlowChannelWasNotFound = 'Whistle blow kanal hittades inte!';
	static SavingDocumentTemplateParameterWasSuccessful = 'Dokumentmallen \'{0}\' har sparats!';
	static EditUnit = 'Redigera enhet';
	static SavingEventTypesWasSuccessful = 'Kategori 1 har sparats framgångsrikt!';
	static TrendingUp = '-';
	static RecordUserFurtherEducationsTableByEducationName = '-';
	static KeywordCodeMustBeDefined = 'Nyckelord måste definieras!';
	static JobTypeEventNotification = 'Incidentmeddelande';
	static WhistleBlowReceiver = 'Mottagare';
	static InvalidReCAPTCHA = 'Mänsklig verifiering misslyckades! Är du en robot?';
	static DefaultBasicEducations = 'Grundläggande utbildningar';
	static SavingReadReceiptWasSuccessful = 'Läskvitto har sparats!';
	static SavingOpportunityParameterWasNotSuccessfulConcurrencyError = '-';
	static RestoreRiskOrOpportunityFromTrashBin = '-';
	static SavingTaskTypeParameterWasNotSuccessfulErrorParameter = '-';
	static DoYouReallyWantToArchiveTaskParameter = '-';
	static PanelIsSharedWithoutUserGroups = '-';
	static Observer = 'Observatör';
	static ArchivingRecordUserFamiliarizationsWasNotSuccessfulErrorParameter = 'Det gick inte att arkivera ytterligare bekantskaper! Fel: \'{0}\'';
	static Default = 'Standard';
	static NormalSize = 'Normal storlek';
	static DeletingRecordFamiliarizationsParameterWasSuccessful = 'Bekantskapen \'{0}\' har tagits bort!';
	static FormCoverPage = '-';
	static CopyPermissionToAllSameLevelUnits = 'Kopiera tillstånd till alla enheter på samma nivå';
	static AddingRiskTemplateUnitsWasNotSuccessfulErrorParameter = '-';
	static CompanyGroupCodeIsAlreadyInUse = 'Koden för företagsgruppen används redan!';
	static TaskStatesMustBeDefinedBeforeAddingTasks = '-';
	static View = 'Se';
	static SaveAndSend = 'Spara och skicka';
	static EditableDocumentVersionMustBeDefined = 'Dokumentets versionsnummer måste definieras!';
	static TaskDataRowTotalTypeExpression = '-';
	static FullNameClaimNotFound = 'Användaranspråket "namn" hittades inte!';
	static AddingRiskAssessmentHandlersWasNotSuccessfulErrorParameter = '-';
	static RemoveImage = '-';
	static SavingImagesNotSuccessfulErrorParameter = 'Det gick inte att spara bilder! Fel: \'{0}\'';
	static TaskTypeNotAnyAllowedForUser = '-';
	static SavingRecordUserParameterWasSuccessful = 'Användarposten \'{0}\' har sparats!';
	static FormSortAscending = 'Stigande ordning';
	static DefaultRiskProcesses = '-';
	static FolderTreePermissions = 'Mappträdsbehörigheter';
	static SelectEventTypeC = 'Välj kategori 3';
	static FurtherEducation = 'Utbildning';
	static EmptyReportTrashBinConfirmation = '-';
	static AccessRightRead_TaskDescription_C = '-';
	static Picture = 'Bild';
	static DoYouReallyWantToRemoveRiskStakeholderParameter = '-';
	static AccessRightWrite_EventDescription = '-';
	static ChartRemoveFieldConfirmation = '-';
	static RecordUserExcelTabName = 'Användarregister';
	static FormField = 'Fält';
	static AddMessageType = 'Lägg till meddelandetyp';
	static FormEventReferenceIsIsInvalid = '-';
	static AddCompanyParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till företaget \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static UsedInParameterTasks = '-';
	static RecordUsersFound = 'Användarposter hittades';
	static ReminderWeekBefore = 'veckan innan';
	static EditEventTypeB = 'Redigera kategori 2';
	static EventTypesBReportName = '-';
	static DocumentTemplateParameterNotFound = 'Dokumentmallen \'{0}\' hittades inte!';
	static AddRecordUserAndUserAccount = 'Lägg till användarpost och nytt användarkonto';
	static AuthorizationLevelUser = 'Användare';
	static CalendarTaskOpenSeries = 'Öppen serie';
	static ReminderHoursBefore = 'timmar innan';
	static DeletingFileFiltersParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort filfiltren \'{0}\'! Fel: \'{1}\'';
	static UserGroupModuleProperties = 'Egenskaper för användargrupper';
	static EventTypeBParameterChildrenAreInUseInParameterEventsAndCannotBeDeleted = 'Kategori 2 "{0}" underkategorier används i {1} incidenter och kategori 2 kan inte tas bort!';
	static DeletingEventPartnerParameterWasSuccessful = 'Incidentpartnern \'{0}\' har tagits bort!';
	static SavingEmailSendLogParameterWasNotSuccessfulErrorParameter = '-';
	static GroupByFamiliarization = 'Gruppera efter bekantskap';
	static DoYouReallyWantToRemoveEventUrgencyClassParameter = 'Vill du verkligen ta bort brådskande klass \'{0}\'?';
	static Last30Days = 'Senaste 30 dagarna';
	static UserRecordStatisticsUnapprovedFamiliarizations = 'Ej godkända introduktioner';
	static RestoringOpportunityParameterFromTrashBinWasSuccessful = '-';
	static AccountNumberTkbInDebit = 'Försäljningsfordringar konto';
	static AuthorizationLevelSuperUser = 'Superanvändare';
	static InstantMessageChannelMustHaveAtLeastOneAdministrator = 'Chatten måste ha minst en administratör!';
	static Hidden = 'Dold';
	static WhistleBlowCategoryCodeIsAlreadyInUse = 'Namnet på visselblåsningskategorin används redan!';
	static UserCannotRecieveEmailNotifications = 'Användaren kommer inte att få e-postmeddelanden';
	static MovingFolderDirectoryItemParameterToFolderParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att flytta mappen \'{0}\' till mappen \'{1}\', eftersom data i mappen har ändrats samtidigt av en annan användare!';
	static DeletingUsersParameterWasSuccessful = 'Användarkonton \'{0}\' har tagits bort!';
	static RiskStandardsMustBeDefinedBeforeAddingRisks = '-';
	static CompanyGroups = 'Företagsgrupper';
	static FormBoldFont = 'Fet stil';
	static WhistleBlowStateArchived = 'Arkiverad';
	static RecordUser = 'Användarpost';
	static DefaultEventUrgencyClasses = 'Standard brådskande klasser';
	static CalendarTaskRemoveOccurrence = 'Ta bort förekomst';
	static Images = 'Bilder';
	static EmptyRiskManagementTrashBin = '-';
	static UserClaimsNotFound = 'Användaranspråk hittades inte!';
	static ShowChartInFrontPage = '-';
	static CalendarTaskOpenOccurrence = 'Öppna Förekomst';
	static FileFilterParameterNotFound = 'Filfiltret \'{0}\' hittades inte!';
	static CreatingFileParameterWasNotSuccessfulErrorParameter = 'Det gick inte att skapa filen \'{0}\' i filsystemet! Fel: \'{1}\'';
	static WholeHistory = 'Hela historien';
	static DeletingWhistleBlowChannelAdminsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort administratörer "{0}", eftersom data har ändrats samtidigt av en annan användare!';
	static AddFurtherEducationToMultipleUserRecords = 'Lägg till utbildning till flera användarposter';
	static SavingEventParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara incidenten \'{0}\'! Fel: \'{1}\'';
	static DeletingRecordUserParameterWasSuccessful = 'Användarposten \'{0}\' har tagits bort!';
	static FormDocumentReferenceDocumentIdIsInvalid = '-';
	static WhistleBlowAttachmentRemoveReasonDefaultValue = 'Tagit bort en bilaga som innehöll onödig information (t.ex. personuppgifter).';
	static EmptyingTaskTrashBinWasSuccessfulErrorParameter = '-';
	static InheritedUserRights = 'Ärvda behörigheter';
	static RemoveEventPartner = 'Ta bort Incident Partner';
	static NewPasswordMustBeDefined = 'Nytt lösenord måste definieras!';
	static LogoSquare = 'Liten logotyp';
	static UnitHandlingIncomingEvents = 'Enhet som hanterar incidenter som skickas av partnern';
	static Yes = 'Ja';
	static ReportTemplateNotAnyAllowedForUser = '-';
	static DeletingTaskStateParameterWasSuccessful = '-';
	static RiskModuleInfoPermissions = '-';
	static SavingOpportunityParameterWasNotSuccessfulErrorParameter = '-';
	static PublishingRiskParameterWasSuccessful = '-';
	static AllWhistleBlowHandlersHaveReadMessage = 'Alla som hanterar whistleblow-rapporter har läst ditt meddelande';
	static UseInheritedContentFiltering = 'Använd ärvt innehållsfiltrering';
	static PublishEvent = 'Publicera incidenten';
	static WhistleBlowArchivingTypeChangeStateAndRemoveInformantData = 'Ändra tillstånd för rapport till "Arkiverad" och ta bort informantdata';
	static ReportTemplateRemoveFieldConfirmation = '-';
	static AddEventPartner = 'Lägg till Incident Partner';
	static EmptyReport = '-';
	static DoCleanLog = 'Rensa logg';
	static DeletingReportTemplatesParameterWasNotSuccessfulErrorParameter = '-';
	static UserFilterExpired = 'Utgånget';
	static FileFilters = 'Filfilter';
	static FamiliarizationTrainer = 'Tränare';
	static SavingInstantMessageChannelParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara chatten "{0}", eftersom data i chatten har ändrats samtidigt av en annan användare!';
	static SearchFamiliarizations = 'Sök bekantskaper';
	static LockedToUser = 'Låst av användare';
	static AccessRightNone_DocumentDescription = '-';
	static AccessRightNone_CompanyGroupDescription = '-';
	static WriteBelowFieldWordParameterToConfirmTheOperation = 'Skriv ordet \'{0}\' i fältet nedan för att bekräfta åtgärden';
	static Amount = 'Belopp';
	static UserGroupCodeMustBeDefined = 'Användargruppskod måste definieras!';
	static EInvoiceAddress = 'E-faktura adress';
	static Monthly = 'Månatlig';
	static RecordFurtherEducationGroupCodeIsAlreadyInUse = 'Utbildningsgruppen namn används redan!';
	static DoYouReallyWantToRemoveRiskParameterPermanently = '-';
	static Missing = 'Saknas';
	static SavingEventTypeCsWasNotSuccessfulErrorParameter = 'Det gick inte att spara kategori 3! Fel: \'{0}\'';
	static PageFooterText = 'Systemsidans sidfotstext';
	static HandlersAndAttachments = 'Hantare och tillbehör';
	static AddInstantMessageChannel = 'Lägg till chatt';
	static SavingDirectoryItemFolderParameterWasSuccessful = 'Mappen \'{0}\' har sparats!';
	static FolderNameMustBeDefined = 'Mappnamn måste definieras!';
	static DeletingUserParametersWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort användarparametrar eftersom data i parametrarna har ändrats samtidigt av en annan användare!';
	static SelectRiskTemplate = '-';
	static DeletingRiskParameterWasSuccessful = '-';
	static DoYouReallyWantToRemoveCalendarTaskCategoryParameter = 'Do you really want to remove category \'{0}\'?';
	static RemoveDefaultEventHandler = 'Ta bort standardincidenthanteraren';
	static ProcessedFolderParameterErrorCountParameter = '* Mappen \'{0}\' slutförd, fel: {1}';
	static InstantMessageUserInvitationAcceptTypeAutoAcceptInvitation = 'Jag accepterar automatiskt inbjudan att gå med i chatten';
	static DeletingMessageTypesParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort meddelandetyperna \'{0}\'! Fel: \'{1}\'';
	static ObserverActionMustBeDefined = 'Observatörens agerande måste definieras!';
	static LogisticVoucher = 'Transportfaktura';
	static DoesNotWork = '-';
	static RecordUserUser = 'Användarregister användarkonto';
	static Payer = 'Betalare';
	static RestoringInstantMessageWasSuccessful = 'Snabbmeddelandet har återställts!';
	static AddEventTypeBsToEvent = '-';
	static DeletingRiskCategoryParameterWasSuccessful = '-';
	static DeletingUserGroupParameterWasSuccessful = 'Användargruppen \'{0}\' har tagits bort!';
	static SavingAttachmentsWasNotSuccessfulErrorParameter = 'Det gick inte att spara bilagor! Fel: \'{0}\'';
	static Or = 'Eller';
	static EventTypeCs = 'Kategori 3';
	static Group = 'Grupp';
	static WhistleBlowParameterNotFound = 'Visselslagsrapporten \'{0}\' hittades inte!';
	static SelectReminder = 'Välj påminnelse';
	static Message = 'Meddelande';
	static CalendarTaskModuleInfoPermissions = 'Synlighet och åtkomsträttigheter för kalenderfunktionen. Åtkomst kan beviljas QR-kodanvändare.';
	static ImportTaskDataRows = '-';
	static InstantMessageChannelInformation = 'Chattinformation';
	static WhistleBlowSourceSystem = 'Systemet';
	static SummaryRow = 'Sammanfattningsrad';
	static PositionErrorTimeout = 'Tidsgräns för läsning av platsinformation.';
	static DeletingWhistleBlowParameterWasSuccessful = 'Visselblåsningsrapporten \'{0}\' har tagits bort!';
	static SavingRiskStandardParameterWasNotSuccessfulErrorParameter = '-';
	static DeletingRecordFamiliarizationParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort bekantskapen \'{0}\'! Fel: \'{1}\'';
	static EditableDocumentSaveBeforeApproveConfirmation = 'Vill du spara ändringar i dokumentet innan godkännande?';
	static DoYouReallyWantToRemoveTaskPriorityParameter = '-';
	static DoYouReallyWantToRemoveSelectedRiskTemplates = '-';
	static WhistleBlowDescription = 'Incidentbeskrivning';
	static DownloadFileTemplate = 'Ladda ner filmall';
	static DoYouReallyWantToRemoveThisInstantMessage = 'Vill du verkligen ta bort det här snabbmeddelandet? Snabbmeddelanden kommer att tas bort från alla parter.';
	static EditDefaultBasicEducation = 'Redigera Standard Grundutbildning';
	static TaskTypeParameterNotFound = '-';
	static DeletingFileParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort filen \'{0}\' i filsystemet! Fel: \'{1}\'';
	static UserRecordStatisticsArchivedCards = 'Arkiverade kort';
	static SavingRecordUserSettingsWasNotSuccessfulConcurrencyError = '-';
	static WhistleBlowStatisticsNonAnonymousRecords = 'Icke anonyma rapporter';
	static SavingRiskProcessParameterWasNotSuccessfulErrorParameter = '-';
	static AccessRightRead_TaskDescription = '-';
	static RemoveTransferredProperty = 'Ta bort överförd egendom';
	static AddCompanyGroupsParameterWasSuccessful = 'Företagsgrupper "{0}" har lagts till!';
	static SavingDirectoryItemDocumentParameterWasSuccessful = 'Filen \'{0}\' har sparats!';
	static EditDocumentTemplate = 'Redigera dokumentmall';
	static MaximumSizeOfImageIsParameterMB = '-';
	static CompanyGroupAll = '"Alla företag"';
	static AddingAddRecordUserQualificationsWasSuccessful = 'Kvalifikationer har lagts till!';
	static NoToDos = 'Inga öppna saker att göra';
	static FrontPage = 'instrumentbräda';
	static RiskStakeholder = '-';
	static FormulaMin = 'Minimum';
	static MoveUp = 'Flytta uppåt';
	static MovingRiskParameterToTrashBinWasSuccessful = '-';
	static RemoveLogisticVoucherCompanyPaymentSetting = 'Ta bort betalningsinställning';
	static ConnectToMicrosoftAccount = '-';
	static WhistleBlowSeverityHigh = 'Hög';
	static ChartTestData = '-';
	static CopyDefaultHandlersToAllSameLevelUnits = 'Kopiera standardhanterare till alla enheter på samma nivå';
	static TrashBin = 'Soptunna';
	static SelectDate = 'Välj Datum';
	static PanelSize1 = '1 x 1';
	static SavingChartWasNotSuccessfulErrorParameter = 'Det gick inte att spara diagrammet! Fel: \'{0}\'';
	static ArchivingReportParameterWasNotSuccessfulConcurrencyError = '-';
	static WhistleBlowInformantMessageConfirmation = 'Vill du skicka ett nytt meddelande till uppgiftslämnaren?';
	static DeletingRecordFurtherEducationsParameterWasSuccessful = 'Utbildningar \'{0}\' har tagits bort!';
	static DoYouReallyWantToRemoveRiskAssessmentParameter = '-';
	static EditMessage = 'Redigera meddelande';
	static FormRelativeDefinition = 'Relativ definition';
	static SavingEventTypeBParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara kategori 2 \'{0}\', eftersom data i incidentkategori 2 har ändrats samtidigt av en annan användare!';
	static FamiliarizationEndDateCannotPrecedeFamiliarizationStartDate = 'Slutdatum kan inte föregå startdatum!';
	static SendingEmails = 'Skickar e-postmeddelanden...';
	static Attachments = 'Bilagor';
	static TaskType = '-';
	static IncludeArchivedFamiliarizations = 'Inkludera arkiverade bekantskaper';
	static RestoringRiskParameterFromArchiveWasNotSuccessfulConcurrencyError = '-';
	static IntervalMustBeDefined = '-';
	static CurrentCalendarMonth = 'Aktuell kalendermånad';
	static MovingFilesAndDocumentsToFolderParameterWasNotSuccessfulErrorParameter = 'Det gick inte att flytta filer/dokument till mappen \'{0}! Fel: \'{1}\'';
	static AddingAddRecordUserFurtherEducationsWasSuccessful = 'Utbildningar har lagts till framgångsrikt!';
	static DeletingInstantMessageChannelWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort deltagare eftersom data har ändrats samtidigt av en annan användare!';
	static EventPartnerParameterNotFound = 'Incidentpartner \'{0}\' hittades inte!';
	static UnreadInstantMessages = 'Olästa meddelanden';
	static RemoveWhistleBlowCategory = 'Ta bort kategorin Whistle Blow';
	static AddChildRiskStandard = '-';
	static OpenWhistleBlowInstruction = 'Ange lösenordet som du fick när whistleblow-rapporten skickades in.';
	static EventCreator = 'Skapare';
	static PasswordMustContainDigitOrSpecialCharacter = 'Lösenordet måste innehålla nummer eller specialtecken!';
	static EditFileFilter = 'Redigera filfilter';
	static NoFilesToAdd = 'Inga filer att lägga till!';
	static RemoveDefaultEventType = 'Ta bort standardkategori 1';
	static TaskDashboard = '-';
	static SavingFileFilterParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara filfiltret \'{0}\'! Fel: \'{1}\'';
	static DoYouReallyWantToRemoveReportParameter = 'Vill du verkligen ta bort rapporten \'{0}\'?';
	static WhistleBlowSendReport = 'Skicka rapport';
	static FormTrue = 'Sann';
	static CalendarTaskFilterByState = 'Filtrera efter stat';
	static ExternalSystems = 'Externa system';
	static FormTimeSpan = 'Tidsbelopp (h:mm)';
	static TreatmentEfficiency = '-';
	static FormMobile = 'Mobil app';
	static RiskTreatmentsPlaceholder = '-';
	static SavingRecordUserPartnerParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara resurspartner \'{0}\'! Fel: \'{1}\'';
	static Distribution = '-';
	static WhistleBlowSeverityUnspecified = 'Ospecificerad';
	static ZipFileCreationFailed = 'Det gick inte att skapa zip-fil! Fel: \'{0}\'';
	static EventModuleInfoUrgencyClasses = 'Brådskande klasser som används vid incidenter. Dessa klasser används för att sortera, filtrera och rapportera incidenter.';
	static CommentMustNotBeEmpty = 'Kommentar får inte vara tom!';
	static EventTypeParameterChildrenAreInUseInParameterEventsAndCannotBeDeleted = 'Kategori 1 "{0}" underkategorier används i {1} incidenter och kategori 1 kan inte tas bort!';
	static VerifyUserName = 'Kontrollera att användarnamnet är korrekt (\'{0}\')!';
	static DoYouReallyWantToMoveRiskParameterToTrashBin = '-';
	static RecordUserPartners = 'Resurspartners';
	static AccessRightNone_TaskDescription = '-';
	static RemoveRecordUserAndUserSetExpired = 'Ta bort användarpost och ange användarkonto har löpt ut';
	static DeletingRecordUserTransferredPropertyParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort den överförda egenskapen \'{0}\', eftersom data i den överförda egenskapen har ändrats samtidigt av en annan användare!';
	static UserName = 'Användarnamn';
	static FilterIsActive = 'Filtret är aktivt';
	static PublishVersion = 'Publicera version';
	static SavingMessageParameterWasSuccessful = 'Meddelandet \'{0}\' har sparats!';
	static ApprovalComment = 'Godkännandekommentar';
	static UserHasUsedMobile = 'Användarkontot har varit aktivt i mobilapplikationen under de senaste 30 dagarna.';
	static SavingPushSendLogParameterWasNotSuccessfulErrorParameter = '-';
	static ReportContents = '-';
	static FormTextInputs = 'Textinmatning';
	static ChangesMaxAmount = 'Maximalt antal ändringar';
	static RecordFurtherEducationGroupParameterNotFound = 'Utbildningsgruppen \'{0}\' hittades inte!';
	static UserRecordStatisticsExpiredFamiliarizations = 'Utgångna bekantskaper';
	static AccessRightNone_EventDescription = '-';
	static Reports = 'Rapporter';
	static MoneyIn = 'Pengar in';
	static SavingCompanyParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara företaget \'{0}\'! Fel: \'{1}\'';
	static SelectChartToSeeChartProperties = '-';
	static And = 'och';
	static DoYouReallyWantToRemovePartnersParameter = 'Vill du verkligen ta bort partner "{0}"?';
	static AddSalaryRowToMultipleUserRecords = 'Lägg till lönerad till flera användarposter';
	static AccountNumberTkbOutDebit = 'Leverantörsskuldkonto';
	static EventTypesReportBarChartByCategoryName = '-';
	static EmploymentStartDate = 'Anställningens startdatum';
	static Process = '-';
	static CalendarTaskRepetitionRepeatIntervalDayMonthSeparator = 'i';
	static EventTypeCTitle = 'Incidentidentifieringskategori 3';
	static UserCodeMustBeValid = 'Användarnamnet måste vara 8-50 tecken långt och det får inte innehålla blanksteg.';
	static DoYouReallyWantToRemoveDefaultEventHandlerParameter = 'Vill du verkligen ta bort standardincidenthanteraren \'{0}\'?';
	static WhistleBlowArchivingTypeChangeState = 'Ändra tillstånd för rapport till "Arkiverad"';
	static FolderParameterAlreadyExistsInTargetFolder = 'Mappen \'{0}\' finns redan i målmappen!';
	static CalendarTaskCategoryParameterNotFound = 'Kategori \'{0}\' hittades inte!';
	static RiskStakeholderParameterNotFound = '-';
	static DeletingCalendarTaskCategoriesParameterWasSuccessful = 'Kategorierna "{0}" har tagits bort!';
	static WhistleBlowStateResolved = 'Löst';
	static InvitationPasswordReset = 'Inbjudan/lösenordsåterställning';
	static FormColumnTitle = 'Kolumns titel';
	static SavingFilterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara filtret eftersom data i filtret har ändrats samtidigt av en annan användare!';
	static ReportsStandard = 'Standardrapporter';
	static RestoringTaskParameterFromArchiveWasSuccessful = '-';
	static OnlyImageAndPdfAttachmentsAreAllowedInvalidAttachmentParamater = 'Endast bild- och pdf-bilagor är tillåtna! Bilagorna "{0}" är ogiltiga.';
	static NotUsableForSelectedTaskType = '-';
	static WhistleBlow = 'Whistleblower';
	static SavingEventTypeBsWasNotSuccessfulErrorParameter = 'Det gick inte att spara kategori 2! Fel: \'{0}\'';
	static DeletingRecordUserTransferredPropertiesParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort överförda egenskaper \'{0}\'! Fel: \'{1}\'';
	static ThisPartOfApplicationIsNotInUse = 'Denna del av applikationen används inte!';
	static AddingAddRecordUserTransferredPropertiesWasSuccessful = 'Överförda egenskaper har lagts till!';
	static DoYouReallyWantToRemoveKeywordParameter = 'Vill du verkligen ta bort sökordet "{0}"?';
	static Select = 'Välj';
	static AddEventMessageConfirmation = 'Vill du lägga till kommentaren? Kommentaren kan inte redigeras efter att den har lagts till.';
	static GroupByYear = 'Gruppera efter år';
	static SavingEventMessageWasNotSuccessfulErrorParameter = 'Det gick inte att spara kommentaren! Fel: \'{0}\'';
	static TrainingTime = 'Träningsdags';
	static DeletingCompaniesParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort företag \'{0}\' eftersom data har ändrats samtidigt av en annan användare!';
	static EventTypeCostsReportBarChartIndirectCostsByTimeName = '-';
	static SavingCompanyGroupParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara företagsgruppen \'{0}\'! Fel: \'{1}\'';
	static MovingTaskParameterToTrashBinWasNotSuccessfulConcurrencyError = '-';
	static FurtherEducationsHistory = 'Registrerade utbildningar';
	static Internet = 'Internet';
	static AccessRightFull = '-';
	static DeletingRecordBasicEducationParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort grundläggande utbildning \'{0}\'! Fel: \'{1}\'';
	static Yesterday = 'I går';
	static DoYouReallyWantToRemoveRiskCategoryParameter = '-';
	static DeletingRecordFurtherEducationParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort utbildning \'{0}\'! Fel: \'{1}\'';
	static LockedReportParameterCannotBePublished = '-';
	static DeletingEditableDocumentParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort dokumentet \'{0}\'! Fel: \'{1}\'';
	static AccessRightRead_Record = '-';
	static NoPublishedMessages = 'Inga publicerade meddelanden';
	static DoYouReallyWantToMoveOpportunityParameterToTrashBin = '-';
	static MaximumTotalSizeOfAttachmentsIsParameterMB = 'Den maximala totala storleken på alla bilagor är {0} MB!';
	static DeletingRiskStandardsParameterWasSuccessful = '-';
	static PanelIsShared = '-';
	static JobResultParameterNotFound = 'Jobbresultat \'{0}\' hittades inte!';
	static AutoSaveVersionHistorySize = 'Autospara versionshistorikstorlek';
	static DoYouReallyWantToRemoveAttachmentParameter = 'Vill du verkligen ta bort bilagan \'{0}\'?';
	static AddFurtherEducations = 'Lägg till utbildningar';
	static End = 'Slutet';
	static RemovingRecordUserFamiliarizationHandlerWasNotSuccessfulErrorParameter = 'Misslyckades med att ta bort godkännare! Fel: \'{0}\'';
	static EmailSent = 'Email skickat';
	static RiskTreatments = '-';
	static RecordEmailNotificationType = 'Jag vill få rapport om utbildning från företagets resurser (utgående utbildningar)';
	static EventTypeBs = 'Kategori 2';
	static DocumentRootPathIsNotEmpty = 'Dokumentets rotsökväg är inte tom mapp!';
	static DoYouReallyWantToRemoveFilterParameter = 'Vill du verkligen ta bort filtret "{0}"?';
	static EventHandler = 'Hanterare';
	static ShowUsers = 'Visa användarkonton';
	static PreventiveAction = 'Förebyggande åtgärd';
	static SavingEmailSendLogParameterWasSuccessful = '-';
	static DoYouReallyWantToMoveReportParameterToTrashBin = '-';
	static SavingOptionParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara alternativet \'{0}\', eftersom data i alternativet har ändrats samtidigt av en annan användare!';
	static RemoveRow = 'Ta bort rad';
	static DeletingRiskStandardsParameterWasNotSuccessfulErrorParameter = '-';
	static WhistleBlowAnonymousReportInfo = 'Om du inte vill avslöja ditt namn under rapporteringsprocessen, välj det här alternativet.';
	static ChangePassword = 'Ändra lösenord';
	static ArchivingRecordUserFurtherEducationsWasNotSuccessfulErrorParameter = 'Misslyckades med att arkivera utbildningar! Fel: \'{0}\'';
	static AccessRightRead_Event_C = '-';
	static RecordUserFurtherEducationsBarChartByEducationName = '-';
	static Folder = 'Mapp';
	static EventTypesGeneric = 'Typer';
	static FormModifyUser = 'Ändra användare';
	static ByName = 'Vid namn';
	static DeletingEventUrgencyClassParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort brådskande klass \'{0}\'! Fel: \'{1}\'!';
	static InvalidRequest = 'Ogiltig begäran!';
	static UserRecordStatisticsExpiredQualifications = 'Utgångna kvalifikationer';
	static KeywordsOrCondition = 'Något av de valda sökorden';
	static EditDefaultFurtherEducation = 'Redigera standard utbildning';
	static SpecifedTimeFrame = 'Angiven tidsram';
	static DeletingEventTypeBParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kategori 2 \'{0}\'! Fel: \'{1}\'';
	static UnitProperties = 'Enhetsegenskaper';
	static SavingDocumentTemplateParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara dokumentmallen \'{0}\', eftersom data i dokumentmallen har ändrats samtidigt av en annan användare!';
	static SaveTaskConfirmation = '-';
	static WhistleBlowInformation = 'Rapportera information';
	static SaveComment = 'Spara kommentar';
	static Approval = 'Godkännande';
	static AddRiskAssessments = '-';
	static PublishingRiskParameterWasNotSuccessfulConcurrencyError = '-';
	static TaskChartValueFieldCalculationTypeMedian = '-';
	static FamiliarizationsMustBeDefinedBeforeAddingRecordUserFamiliarizations = 'Företagsbekännelser måste definieras innan bekantskaper med användarposter läggs till!';
	static PanelSize2 = '2 x 1';
	static RiskThreatMustBeDefined = '-';
	static EditRecordUserPartner = 'Redigera resurspartner';
	static LockedReportParameterCannotBeRestored = '-';
	static SaveInstantMessageChannelConfirmation = 'Vill du spara chatten?';
	static SaveFilterAs = 'Spara filter som';
	static ActivePlural = 'Aktiva';
	static Last120Days = 'Senaste 120 dagarna';
	static Min = 'Min';
	static ExportToExcel = 'exportera till Excel';
	static FirstRows = '-';
	static SavingWhistleBlowMessageWasNotSuccessfulErrorParameter = 'Det gick inte att spara meddelandet! Fel: \'{0}\'';
	static MyLastModifications = 'Användarens senaste ändringar';
	static SavingMessageTypeParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara meddelandetypen \'{0}\'! Fel: \'{1}\'';
	static AssessmentComment = '-';
	static ChangeSystemLanguageToSwedish = 'Byt språk till svenska';
	static DeletingTaskParameterWasNotSuccessfulConcurrencyError = '-';
	static DeletingCalendarTaskCategoryParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort kategorin \'{0}\'! Fel: \'{1}\'';
	static ModifyDate = 'Senast ändrad';
	static AccessRightRead_EventDescription_C = '-';
	static LockedDocumentsParameterCannotBeMoved = 'Låsta dokument "{0}" kan inte flyttas!';
	static SaveUserFamiliarizationConfirmation = 'Vill du spara bekanta dig?';
	static RemovePayer = 'Ta bort betalare';
	static FormColumnWidth = 'Kolumnbredd';
	static AddUserGroupsParameterWasSuccessful = 'Användargrupperna \'{0}\' har lagts till!';
	static UserFilterNoUserGroup = 'Ingen användargrupp';
	static FormEmptyArea = 'Tomt område';
	static SaveEventHandlerConfirmation = 'Vill du rädda händelsen?';
	static AddSharedPanel = '-';
	static Resources = 'Resurser';
	static DoYouReallyWantToRemoveEventParameter = 'Vill du verkligen ta bort incidenten \'{0}\'?';
	static ImageProperties = 'Bildegenskaper';
	static SavingSharedPanelWasNotSuccessfulErrorParameter = '-';
	static DeletingKeywordsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort sökorden \'{0}\'! Fel: \'{1}\'';
	static InstantMessagePartners = 'Instant Message Partners';
	static RestoringReportParameterFromArchiveWasNotSuccessfulConcurrencyError = '-';
	static WaitingToBeApproved = 'Väntar på att bli godkänd';
	static ImageChangeInterval = 'Bildändringsintervall';
	static Warning = 'Varning';
	static OldestMessage = 'Äldsta meddelande';
	static QualificationRequirementOneValid = 'Kvalifikation: 1 giltig utbildning';
	static Last2Years = '-';
	static AccessRightWrite_CompanyDescription = '-';
	static Subject = 'Ämne';
	static SavingEventDefaultHandlerParameterWasSuccessful = 'Standardincidenthanteraren \'{0}\' har sparats!';
	static DeletingMessageTypesParameterWasSuccessful = 'Meddelandetyperna \'{0}\' har tagits bort!';
	static RequiredValidQualificationCount = 'Krävs giltigt antal kvalifikationer';
	static ResidualRisk = '-';
	static AccessRightWrite_AppReport = '-';
	static TaskCreated = 'Skapad av';
	static RemoveFolder = 'Ta bort mapp';
	static Conversions = 'Konverteringar';
	static SharePanel = '-';
	static EditFurtherEducation = 'Redigera utbildning';
	static EditAttachment = 'Redigera bilaga';
	static DeletingDirectoryItemDocumentParameterWasSuccessful = 'Filen \'{0}\' har tagits bort!';
	static FormRequired = 'Indata krävs';
	static PageNameMustBeDefined = 'Sidnamn måste definieras!';
	static PushNotificationInUse = 'Jag vill ta emot push-meddelanden (eSalkku Mobile)';
	static LanguageParameterIsNotSupported = 'Språket \'{0}\' stöds inte!';
	static AccountNumberTkbOutCredit = 'Handelskonto';
	static NoName = 'Anonym';
	static DeletingRiskProcessParameterWasSuccessful = '-';
	static EditEventTypes = 'Redigera kategori 1';
	static DoYouReallyWantToRestoreThisInstantMessage = 'Vill du verkligen återställa det här snabbmeddelandet?';
	static SelectRecordUserTypeToBeCreated = 'Välj användarposttyp för ny post';
	static AddQrCodeUserGroup = 'Lägg till QR-kodsanvändargrupp';
	static UsedQuota = 'Använd kvot';
	static WhistleBlowWasNotFound = 'Visslingsrapport hittades inte!';
	static CalendarTaskEditSeries = 'Redigera serie';
	static NotSelected = 'Ej valt';
	static FormTitle3 = 'Titel 3';
	static AccessRightNone_UserDescription = '-';
	static RestoringTaskParameterFromTrashBinWasSuccessful = '-';
	static RiskStakeholderCodeIsAlreadyInUse = '-';
	static PortalInUse = 'Inloggningsportalen används';
	static DocumentEndDate = 'Giltig till';
	static DeletingAttachmentsWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort bilagor! Fel: \'{0}\'';
	static ReportTemplatesMustBeDefinedBeforeAddingReports = '-';
	static AddNotifiedPerson = 'Lägg till person som ska meddelas';
	static Collapse = 'Kollaps';
	static DeletingTaskStatesParameterWasSuccessful = '-';
	static DefaultSettings = 'Standardinställningar';
	static UserFilterQrCodeUser = 'QR-kod användarkonton';
	static CalendarTaskOccurrence = 'Förekomst';
	static AddDefaultTaskType = '-';
	static YouDeletedThisMessage = 'Du tog bort det här meddelandet';
	static WhistleBlowResolutionUnspecified = 'Inte löst';
	static Clear = 'Klar';
	static DeletingCompanyGroupsParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort företagsgrupper "{0}"! Fel: \'{1}\'';
	static JobTitleMustBeDefined = 'Arbetstitel måste definieras!';
	static LogisticVoucherCustomer = 'Kund';
	static NewInstantMessageChannelGroupInternal = 'Ny grupp (företagsintern)';
	static Location = 'Plats';
	static RiskSettingNotFound = '-';
	static OpenWhistleBlow = 'Öppna Whistle Blow Report';
	static PrintTask = '-';
	static InheritedUserRight = '(ärvt tillstånd)';
	static DoYouReallyWantToClearLog = 'Vill du verkligen rensa loggen?';
	static FormRecordReferenceWarning = '-';
	static EditableDocumentPublishConfirmation = 'Vill du publicera dokument till fil?';
	static DeletingMessageParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort meddelandet \'{0}\'! Fel: \'{1}\'';
	static SavingTaskDataRowWasNotSuccessfulErrorParameter = '-';
	static FormSizeLarge = 'Stor';
	static Operators = 'Operatörer';
	static FormNumbers = 'Tal';
	static CompanyInstantMessageChannels = 'Företagschattar';
	static PublishTaskType = '-';
	static AccessRightRead_MessageDescription_A = '-';
	static Text = 'Text';
	static FormTextInput = 'Textinmatning';
	static TaskTaskChartGroupingFieldGroupingTypeValue = '-';
	static Test = 'Testa';
	static InstantMessages = 'Snabbmeddelanden';
	static TaskPrioritiesMustBeDefinedBeforeAddingTasks = '-';
	static RiskApprovalInfo = '-';
	static AddChildDefaultEventType = 'Lägg till standardunderkategori 1';
	static Qualification = 'Kvalifikation';
	static ArgumentParameterIsNULL = 'Värdet på argumentet \'{0}\' är NULL!';
	static UserRecordStatisticsExpiredFurtherEducations = 'Utgångna utbildningar';
	static NoImagesToShow = 'Inga bilder att visa';
	static EventClosed = 'Incidenten stängd';
	static DeletingUserGroupsParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort användargrupperna \'{0}\' eftersom data i användargrupper har ändrats samtidigt av en annan användare!';
	static UnlockingTaskDataRowWasNotSuccessful = '-';
	static Risks = '-';
	static UnlockingTaskParameterWasNotSuccessful = '-';
	static QualificationIsValid = 'Kvalifikationen är giltig';
	static PublishingReportParameterWasNotSuccessfulErrorParameter = '-';
	static SelectUrgencyClass = 'Välj brådskande klass';
	static OpportunityDescription = '-';
	static ReminderDayBefore = 'dagen före';
	static InstantMessageChannelUsers = 'Deltagare';
	static SavingPrintWasNotSuccessfulErrorParameter = 'Det gick inte att spara utskriften! Fel: \'{1}\'';
	static ReadImpPlur = 'Läsa';
	static UserPublicPasswordChangeMessage = 'Du kan ange ditt nya lösenord på den här sidan. Ditt användarnamn inkluderades i e-postmeddelandet som innehåller länken till denna sida.';
	static DefaultEventUrgencyClassMustBeDefinedBeforeAddingEvents = 'Standard brådskande klass måste definieras innan incidenter läggs till!';
	static MovingRiskParameterToTrashBinWasNotSuccessfulErrorParameter = '-';
	static RecordUserPartnerIsAlreadyDefined = 'Resurspartner är redan definierad!';
	static UserEventsNotApproved = 'Användarhändelser inte godkända';
	static TaskStates = '-';
	static EventModuleInfoUnits = 'En enhet är en kanal där incidenter kan sparas. En enhet kan representera till exempel en process, plats, enhet etc. Skapa det nödvändiga antalet observationskanaler, till exempel baserat på olika funktioner.';
	static WhistleBlowChannelParameterNotFound = 'Visselblåsningskanalen \'{0}\' hittades inte!';
	static DesignArea = 'Designområde';
	static AddPartnersByClickingPlusButton = 'Lägg till partners genom att klicka på plusknappen.';
	static DateMustBeDefined = 'Datum måste anges!';
	static RiskControlsMustBeDefined = '-';
	static AccessRightWrite_Event = '-';
	static DeletingTaskTypesParameterWasNotSuccessfulErrorParameter = '-';
	static RestoringOpportunityParameterFromTrashBinWasNotSuccessfulConcurrencyError = '-';
	static Permission = 'Lov';
	static AddChildEventType = 'Lägg till underkategori 1';
	static FormTitle4 = 'Titel 4';
	static RiskLevelMedium = '-';
	static RemoveUserAndRecordUserArchive = 'Ta bort användarkonto och arkivera användarpost';
	static ResolutionDescription = 'Beskrivning av upplösning';
	static AddFamiliarization = 'Lägg till ytterligare bekantskap';
	static PermissionsForSystems = 'Systembehörigheter';
	static RemoveUser = 'Ta bort användarkonto';
	static BusinessIdentityCode = 'Företagsidentitetskod';
	static WhistleBlowApplicationName = 'Whistle Blow Channel';
	static RestoringOpportunityParameterFromTrashBinWasNotSuccessfulErrorParameter = '-';
	static SavingRiskTemplateParameterWasSuccessful = '-';
	static AccessRightNone_MessageDescription = '-';
	static RecordUserLogEntryTypePrint = 'Utskrift';
	static LogModuleProperties = 'Loggar egenskaper';
	static AddingTaskTypeUnitsWasSuccessful = '-';
	static AddingRecordUserSalaryRowsWasSuccessful = 'Lönerader har lagts till!';
	static WhistleBlowEventTypeCreated = 'Skapad';
	static DeletingUserParametersWasSuccessful = 'Användarparametrar har tagits bort!';
	static JobTypeMessageNotification = 'Meddelandemeddelande';
	static Today = 'I dag';
	static SearchTasks = '-';
	static ParameterResults = '({0} resultat)';
	static ExcelFile = 'Excel-fil';
	static UserCodeMustBeDefined = 'Användarnamn måste definieras!';
	static WhistleBlowCategoryParameterIsInUseInParameterWhistleBlowsAndCannotBeDeleted = 'Whistle blow kategori "{0}" används i {1} whistle blow records och kan inte tas bort!';
	static Voluntary = 'Frivillig';
	static PostalCode = 'postnummer';
	static NewRecordUserMustBeSavedBeforeAttachmentsCanBeAdded = 'Ny användarpost måste sparas innan bilagor kan läggas till!';
	static AddingTaskTypeUnitsWasNotSuccessfulErrorParameter = '-';
	static TimeSpanMonth = 'Månad';
	static SavingTaskParameterWasNotSuccessfulErrorParameter = '-';
	static FieldParameterValueCanOnlyContainNumbers = 'Värdet på fältet \'{0}\' kan bara innehålla siffror!';
	static AddReportTemplate = '-';
	static TaskDataRowTotalTypeColSum = '-';
	static NoTasksToShow = '-';
	static NoModifications = 'Inga ändringar';
	static EventTypeCostsReportTableIndirectCostsByTimeName = '-';
	static ImageOrPdfUpToParameterMb = 'Bild- eller PDF-format, upp till {0} MB';
	static Communication = 'Kommunikation';
	static AddPrint = 'Lägg till utskrift';
	static ChangeToEditMode = 'Byt till redigeringsläge';
	static DoYouReallyWantToRemoveMessageParameter = 'Vill du verkligen ta bort meddelandet \'{0}\'?';
	static WhistleBlowEventTypeHandlersRemoved = 'Handlare borttagna';
	static VersionInformation = 'Versionsinformation';
	static RecordUserModuleInfoFurtherEducations = 'Kurser, utbildningsdagar, coachningssessioner och webbseminarier registreras under Utbildning / Kompetenser. De kan grupperas efter ämne vid behov.#Grupper kan läggas till med hjälp av #-knappen och utbildningar med #-knappen.';
	static SaveToTemplate = 'Spara som mall';
	static LikelihoodMustBeDefined = '-';
	static MovingFilesAndDocumentsToFolderParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att flytta filer/dokument till mappen "{0}", eftersom data i mappen har ändrats samtidigt av en annan användare!';
	static SavingEventPartnerParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara incidentpartnern \'{0}\'! Fel: \'{1}\'';
	static Resolution = 'Upplösning';
	static EditLogisticVoucherCustomer = 'Redigera kund';
	static DeletingRiskStakeholdersParameterWasNotSuccessfulErrorParameter = '-';
	static QrCodeAuthenticationTimeoutWeek = '7 dagar';
	static InstantMessage = 'Snabbmeddelande';
	static AddCompaniesParameterWasSuccessful = 'Företag \'{0}\' har lagts till!';
	static SaveTask = '-';
	static LockedTaskParameterCannotBeSaved = '-';
	static DeletingDefaultEventHandlerParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort standardincidenthanteraren \'{0}\'! Fel: \'{1}\'';
	static UpdatingGroupCodeWasNotSuccessfulErrorParameter = 'Det gick inte att uppdatera gruppkoden! Fel: \'{0}\'';
	static AdditionalPermissions = 'Ytterligare behörigheter';
	static SendInvitationEmailToImportedUsers = 'Skicka e-postinbjudan till importerade användare';
	static DoYouReallyWantToRemoveSelectedMessageTypes = 'Vill du verkligen ta bort valda meddelandetyper?';
	static NoNotificationsToSend = 'Inga aviseringar ska skickas!';
	static RemoveDocument = 'Ta bort markerade filer/dokument';
	static Modified = 'Senast ändrad av';
	static DoYouReallyWantToRemoveSelectedRiskStandards = '-';
	static DocumentsParameterOverwriteConfirmation = 'Filerna \'{0}\' finns redan i mappen. Vill du skriva över dessa filer?';
	static MovingTaskParameterToTrashBinWasSuccessful = '-';
	static AddingAddRecordUserTransferredPropertiesWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till överförda egenskaper! Fel: \'{0}\'';
	static NoReports = 'Inga rapporter!';
	static PermissionsOtherCompanies = 'Behörigheter (andra företag)';
	static ValidityEndDateExpirationTime = 'Giltighet Utgångstid';
	static UpdateUserParameterExternalSystemsWasSuccessful = 'Användaren \'{0}\' har länkats till externa system!';
	static ChangeSystemLanguageToEnglish = 'Ändra språk till engelska';
	static WhistleBlowCategory = 'Whistle Blow Kategori';
	static AttachmentImageSize = 'Bifogad bild Miniatyrstorlek';
	static PrivateAndPublic = 'Privat och offentlig';
	static UserGroupCodeIsAlreadyInUse = 'Användargruppskoden används redan!';
	static UnpublishingReportParameterWasNotSuccessfulErrorParameter = '-';
	static BasicEducations = 'Grundläggande utbildningar';
	static RecordUserExcelQualification = 'Kvalifikationer';
	static RiskApproval = '-';
	static AddCompanyGroupParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till företagsgruppen \'{0}\'! Fel: \'{1}\'';
	static Add = 'Lägg till';
	static Shared = 'Delad';
	static SavingRiskStakeholderParameterWasSuccessful = '-';
	static DeletingRecordQualificationParameterWasSuccessful = 'Kvalifikationen \'{0}\' har tagits bort!';
	static DeletingCompanyGroupParameterWasSuccessful = 'Företagsgruppen \'{0}\' har tagits bort!';
	static UnitCodeIsAlreadyInUse = 'Enhetens namn används redan!';
	static RecordUserEmploymentParameterNotFound = 'Användarregister anställningspost \'{0}\' hittades inte!';
	static RemoveFromFavorites = 'Ta bort från favoriter';
	static Next = 'Nästa';
	static DeletingAttachmentsParameterWasSuccessful = 'Bilagorna \'{0}\' har tagits bort!';
	static AddPartnerParameterWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till partner \'{0}\'! Fel: \'{1}\'';
	static Handling = 'Hantering';
	static NotEvaluated = '-';
	static FamiliarizationsHistory = 'Registrerade bekantskaper';
	static PanelSize6 = '3 x 2';
	static TaskChartValueFieldCalculationTypeAverage = '-';
	static AddKeyword = 'Lägg till nyckelord';
	static SavingFilterWasSuccessful = 'Filtret har sparats!';
	static WhistleBlowInformantDateAndTime = 'När inträffade detta?';
	static FurtherEducationParameterNotFound = 'Utbildning \'{0}\' hittades inte!';
	static EmployeeType = 'Typ av anställd';
	static CompanyNumber = 'Företagsnummer';
	static TreatmentTargetDateMustBeDefined = '-';
	static EventTypeCCodeIsAlreadyInUse = 'Kategori 3-namnet används redan!';
	static DeletingFileFiltersParameterWasSuccessful = 'Filfiltren \'{0}\' har tagits bort!';
	static DeletingEventUrgencyClassesParameterWasNotSuccessfulErrorParameter = 'Det gick inte att ta bort brådskande klasser \'{0}\'! Fel: \'{1}\'!';
	static LockedRiskParameterCannotBeArchived = '-';
	static PublishVersionHistorySize = 'Publicera versionshistorik Storlek';
	static SelectMonth = 'Välj månad';
	static RemoveDefaultTaskPriority = '-';
	static WhistleBlowSourceMail = 'Post';
	static Move = 'Flytta';
	static SelectableWhenCreatingAnEvent = 'Valbar när du skapar en händelse';
	static Unit = 'Enhet';
	static InstantMessageChannelUserParameterIsNotAllowedToUseChannelParameter = 'Användaren \'{0}\' har inte behörighet att använda chatten \'{1}\'!';
	static UserGroupNameMustBeDefined = 'Användargruppsnamn måste definieras!';
	static UserTypeClaimNotFound = 'Användaranspråket "användartyp" hittades inte!';
	static Risk = '-';
	static Value = 'Värde';
	static Course = 'Kurs';
	static ApprovalDateMustBeDefined = '-';
	static DoYouWantToEraseOpportunityBenefitAndDescription = '-';
	static FormRadioOptionsDialog = '-';
	static Table = '-';
	static DocumentTemplate = 'Dokumentmall';
	static AddCompanyGroup = 'Lägg till företagsgrupp';
	static GroupByHalfYear = 'Gruppera efter halvår';
	static FamiliarizationIsNotApprovedByUser = 'Användaren har inte godkänt introduktionen';
	static WhistleBlowStateNew = 'Ny';
	static EmptyingRiskManagementTrashBinWasSuccessful = '-';
	static FormulaRound = 'Avrundad';
	static SavingOneTimePasswordParameterWasSuccessful = 'Engångslösenordet har sparats!';
	static LoggedInUser = 'Inloggad användare';
	static RiskRegisterSummary = '-';
	static RiskTreatmentStateTreatmentsSpecified = '-';
	static Employee = 'Anställd';
	static FormTaskReferenceWarning = '-';
	static RemoveDefaultTaskType = '-';
	static PositionErrorUnavailable = 'Platsinformation är inte tillgänglig.';
	static EventTypes = 'Kategori 1';
	static SelectedDocument = '-';
	static OthersLastModifications = 'Senaste ändringar av företag';
	static ExternalsSystemParameterNotFound = 'Det externa systemet \'{0}\' hittades inte!';
	static Priority = 'Prioritet';
	static SavingEventDefaultHandlerParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara standardincidenthanteraren \'{0}\', eftersom data i standardincidenthanteraren har ändrats samtidigt av en annan användare!';
	static RemoveOpportunityPermanently = '-';
	static DeletingRecordFurtherEducationParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort utbildning \'{0}\', eftersom data i utbildningen har ändrats samtidigt av en annan användare!';
	static CalendarTasks = 'Händelser';
	static RemoveRecordUser = 'Ta bort användarpost';
	static UserModuleProperties = 'Egenskaper för användarkonton';
	static AddRiskTemplateFromTemplate = '-';
	static FormModifyDate = 'Ändringsdatum';
	static RiskModuleInfoRiskStakeholders = '-';
	static SavingCompanyGroupParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara företagsgruppen \'{0}\' eftersom data i företagsgruppen har ändrats samtidigt av en annan användare!';
	static PositionErrorPermissionDenied = 'Applikationen har inte behörighet att läsa plats.';
	static DeletingMessageParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att ta bort meddelandet \'{0}\' eftersom data i meddelandet har ändrats samtidigt av en annan användare!';
	static TitleMustBeDefined = 'Titel måste definieras!';
	static FormulaAddition = 'Tillägg';
	static UserLastNameMustBeDefined = 'Användarefternamn måste definieras!';
	static SavingWhistleBlowCategoryParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att spara whistle blow-kategorin \'{0}\', eftersom data i whistleblow-kategorin har ändrats samtidigt av en annan användare!';
	static RiskParameterNotFound = '-';
	static RemovingWhistleBlowHandlersWasSuccessful = 'Hanterare har tagits bort!';
	static ArchivingRiskParameterWasSuccessful = '-';
	static Restore = 'Återställ';
	static DeletingPartnersParameterWasSuccessful = 'Partners \'{0}\' har tagits bort!';
	static No = 'Nej';
	static AdminMustBeDefinedForSectionParameter = 'Administratör måste definieras för avsnittet \'{0}\'!';
	static Header = 'Rubrik';
	static CompanyModuleProperties = 'Företagsfastigheter';
	static Go = 'Gå';
	static RiskImpact1 = '-';
	static SavingCompanyParameterWasSuccessful = 'Företaget \'{0}\' har sparats!';
	static RiskImpact3 = '-';
	static RiskImpact2 = '-';
	static RiskImpact5 = '-';
	static AddPartnersParameterWasNotSuccessfulConcurrencyError = 'Det gick inte att lägga till partner "{0}", eftersom data har ändrats samtidigt av en annan användare!';
	static FurtherEducationGroup = 'Utbildningsgruppen';
	static SavingMessageParameterWasNotSuccessfulErrorParameter = 'Det gick inte att spara meddelandet \'{0}\'! Fel: \'{1}\'';
	static AddingWhistleBlowHandlerWasNotSuccessfulErrorParameter = 'Det gick inte att lägga till hanterare! Fel: \'{0}\'';
	static DeletingEventUrgencyClassParameterWasSuccessful = 'Brådskande klass \'{0}\' har tagits bort!';
	static TaskTypeParameterIsInUseInParameterTasksAndCannotBeDeleted = '-';
	static SavingReportWasNotSuccessfulErrorParameter = 'Det gick inte att spara rapporten! Fel: \'{0}\'';
	static Partners = 'Partners';
	static AddRecordUserWithoutUserAccount = 'Lägg till användarpost utan användarkonto';
	static VoucherPrefix = 'Verifikationsprefix';
	static EmptyTaskTrashBin = '-';
	static PreviewPanel = 'Förhandsvisning';
	static FirstListRow = 'Första listraden';
	static SomeWhistleBlowHandlersHaveReadMessage = 'Vissa handläggare av whistleblow-rapporter har läst ditt meddelande';
	static SelectEventTypeB = 'Välj kategori 2';
	static UnpublishingReportParameterWasSuccessful = '-';
	static EditReport = '-';
	static PanelSize4 = '2 x 2';
	static AddEventHandler = 'Lägg till hanterare';
	static Theme = 'Tema';
	static UpdatingDatabase = 'Uppdaterar databas...';
	static EditRiskAssessment = '-';
	static CompanyCodeIsAlreadyInUse = 'Koden för företaget är redan i bruk!';
	static FileParameterIsEmpty = 'Filen \'{0}\' är tom!';
}
// ReSharper restore InconsistentNaming
